import { ChangeEvent, EventHandler, SetStateAction, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import StandeditorService from "../../services/plan/standeditor.service";
import AuthService from "../../services/auth/auth.service";
import ReactHtmlParser from 'html-react-parser'; 
import './css/standeditor.css'
import './css/plan.css'
import './css/planstyle.css'
import standeditorService from "../../services/plan/standeditor.service";
import userService from "../../services/user/user.service";
import contractorService from "../../services/contractor/contractor.service";
import contactService from "../../services/contractor/contacts.service";

import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import React from "react";
import { Box, Button, CircularProgress } from "@mui/material";
import planService from "../../services/plan/plan.service";
import { useSSR } from "react-i18next";
import { enqueueSnackbar } from "notistack";
import { BorderAll, BorderColor } from "@mui/icons-material";
import { isNumber } from "slickgrid-react";
import { relative } from "path";

const parse = require('html-react-parser').default;

const LOCAL_STORAGE_POSX = AuthService.getCurrentUser()?.shrt + '_crm-standeditor'  + '-scrollposX' 
const LOCAL_STORAGE_POSY = AuthService.getCurrentUser()?.shrt + '_crm-standeditor'  + '-scrollposY' 

async function getBase64(file: Blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      resolve(reader.result)
    }
    reader.onerror = reject
  })
}


const Standeditor : React.FC  = () => {
    var user = AuthService.getCurrentUser()
    var username : string | undefined =''
  
    const [content, setContent] = useState('');
    const [backgroundImg, setBackgroundImg] = useState("");
    const [backgroundPosition, setbackgroundPosition] = useState("left 0px top 0px");
    const [hideBackground, setHideBackground] = useState(true)
    
    const [modifier_id, setModifierId] = useState(0);
    const [modifier_name, setModifierName] = useState("");
    const [plan_width, setPlanWidth] = useState(0);
    const [plan_height, setPlanHeight] = useState(0);
    const [plan_size, setPlanSize] = useState([0,0])
    const [color_wall, setWallColor] = useState("");
    const [color_stand, setStandColor] = useState("");
    const [plan_name, setPlanName] = useState("");
    const [plan_date, setPlanDate] = useState("");
    const [plan_groupId, setPlanGroupID] = useState(0);
    const [plan_modified, setPlanModifiedDate] = useState(0);
    const [isplanEdited, setisplanEdited] = useState(false);
    const [backups, setBackups] = useState([{name:"", label:"Brak historii"}]);

    const [alertInfo, setAlertInfo] = useState('')
    const [alertError, setAlertError] = useState('')
    

    const [background_size, setBackgroundSize] = useState('');

    //const [numberVertical, setnumberVertical] = useState("");
    //const [numberHorizontal, setnumberHorizontal] = useState("");



    const [users, setUsers] = useState([]);




    const [func_stand, setFuncStand] = useState("");
    const [func_stand_element, setFuncStandElement] = useState("");
    const [func_stand_element_w, setFuncStandElementW] = useState(0);
    const [func_stand_element_h, setFuncStandElementH] = useState(0);
    const [func_stand_editor_orient, setFuncStandEditorOrient] = useState("");
    const [func_stand_auto_step, setFuncStandAutoStep] = useState(0);
    const [func_stand_auto_step_click, setFuncStandAutoStepClick] = useState("");
    const [func_stand_auto_1_x, setsetFuncStandAuto1x] = useState(0);
    const [func_stand_auto_1_Y, setsetFuncStandAuto1y] = useState(0);
    const [func_stand_auto_2_x, setsetFuncStandAuto2x] = useState(0);
    const [func_stand_auto_2_Y, setsetFuncStandAuto2y] = useState(0);

    const [func_stand_auto_step_mouse, setFuncStandAutoStepmouse] = useState(0);

    

    const [func_put, setFuncPut] = useState("");
    const [func_end, setFuncEnd] = useState("");
    const [func, setFunc] = useState("");

    const [func_rotate_id, setFuncRotateId] = useState("");
    const [rotate, setRotate] = useState(0);
    const [sendMail, setSendMail] = useState(false);
	
    const [draw_auto_1_x, setDrawAuto1x] = useState(0);
    const [draw_auto_1_y, setDrawAuto1y] = useState(0);
    const [draw_auto_2_x, setDrawAuto2x] = useState(0);
    const [draw_auto_2_y, setDrawAuto2y] = useState(0);
    const [lastActivity, setLastActivity] = useState(new Date())
     


    const params = useParams();
    const param_id = params.id
    var plan_id = -1;
    if (param_id){
      var tmp_id = parseInt(param_id)
      if (!Number.isNaN(tmp_id)){
        plan_id = tmp_id
      }
  
    }

/////////////////////////////////////GLOBAL DOCUMENT FUNCTIONS////////////////////////////////////////////////////////
const [contractor_open, setEditContractorOpen] = React.useState(false);
const [contact_open, setEditContactOpen] = React.useState(false);

const [contractor_name, setEditContractorName] = React.useState('');
const [contact_name, setEditContactName] = React.useState('');


//const [options, setOptions] = React.useState<readonly Film[]>([]);
var loadingContractor = contractor_open ;
var loadingContact = contact_open ;
const [similarityList, setSimilarityList] = useState<any[]>([])
const [contactsList, setContactsList] = useState([])





useEffect(()=>{
  $('#plan_width').val(plan_width)

  var y=0;
  var x=0;
  $('#sbs-content-scroll').show();                                            //GLOBAL DOCUMENT FUNCTIONS useEffect[]
  if ( localStorage[LOCAL_STORAGE_POSX]){
    x = parseFloat(localStorage[LOCAL_STORAGE_POSX])
  }
  if ( localStorage[LOCAL_STORAGE_POSY]){
    y = parseFloat(localStorage[LOCAL_STORAGE_POSY])
  }

   
const element = document.getElementById("sbs-content-scroll");
if (element){
  element.scrollLeft =x;
  element.scrollTop =y;
}

 // $('#sbs-content-scroll').scrollTop(y);
 // $('#sbs-content-scroll').scrollLeft(x);

}, [content])



useEffect(()=>{
    $('#plan_width').val(plan_width)

    ;

}, [plan_width])

useEffect(()=>{
  $('#plan_height').val(plan_height)

  
}, [plan_height])

useEffect(()=>{
  if (!hideBackground){
    //$('#plan_CONTENT').
    var backgroundPos = backgroundPosition.split(" ")
    $('#plan_CONTENT').css('backgroundPosition', backgroundPosition)
    //var backgroundPos = $('#plan_CONTENT').css('backgroundPosition').split(" ");
    var xPos = parseInt(backgroundPos[1]);
    $('#background_left_position').val(xPos)

    //alert(xPos);
    var yPos = parseInt(backgroundPos[3]);
    $('#background_top_position').val(yPos)
    //alert(yPos);

  } 
}, [hideBackground])

  const imageGridChange = async (e:any) => {

  if (e.target.files && e.target.files.length > 0) {
    var b64 = String(await getBase64(e.target.files[0]))
    //alert(b64)

    StandeditorService.savePlanBackground(plan_id, e.target.files[0].name, b64).then(
      (data) => {
          window.location.reload()
       
      }
    ).catch(
      (error) => {
        console.log(error)
      }
    )

  }
};

const beforeUnLoad = (e:any) => {

  var scrollLeft : number = $('#sbs-content-scroll')?.scrollLeft() ? $('#sbs-content-scroll')?.scrollLeft() as number : 0
  var scrollTop : number = $('#sbs-content-scroll')?.scrollTop() ? $('#sbs-content-scroll')?.scrollTop() as number : 0

  localStorage.setItem(LOCAL_STORAGE_POSX, JSON.stringify(scrollLeft))
  localStorage.setItem(LOCAL_STORAGE_POSY, JSON.stringify(scrollTop))
}

useEffect(()=>{                                                 //GLOBAL DOCUMENT FUNCTIONS useEffect[]
    
    if (plan_id > 0){
        StandeditorService.getplan(tmp_id).then(response => {
          setContent(response)
          $('#plan_CONTENT').css('backgroundPosition', backgroundPosition)
        });

        StandeditorService.getplanbackground(tmp_id).then(response => {
          const encoder = new TextEncoder();
          var byteArray = encoder.encode(response)
          const charCodes =  response;
          const byteNumbers = new Array(charCodes.length);
          var url = "" 
          url ="data:image/png;base64," + response;

          setBackgroundImg(url);
          

          //$('#plan_CONTENT').backgroundImage =  url;
         // console.log($('#plan_CONTENT'))

         // console.log(document.getElementById('plan_CONTENT'))
       //   (document.getElementById('plan_CONTENT') as HTMLElement).style.backgroundImage = "AAA";
       //   console.log((document.getElementById('plan_CONTENT') as HTMLElement))
          //document.getElementById('plan_Content').style.backgroundImage = url;
                 
        });

        userService.getusers("").then(response=>{
          setUsers(response.items)

        })
      
        StandeditorService.getplandata(tmp_id).then(response => {
          setModifierId(response.openeduser_id)
          setModifierName(response.openedusername)
          setPlanSize([response.width, response.height])
          setPlanWidth(response.width)
          setPlanHeight(response.height)
         
          if ((response.background_position) && (response.background_position!='')){
            
            setbackgroundPosition(response.background_position)
           
          }
          var size = (response.width*40).toString() + 'px ' + (response.height*40).toString() + 'px' 
          setBackgroundSize(size)
          setWallColor(response.color_wall)
          setStandColor(response.color_stand)
          setisplanEdited(response.openeduser_id==user?.u_id);


          if (response.openeduser_id==user?.u_id){
            setInterval(function () {
              checkactivityedit();		
            }, 20000);	

          }
            

          setPlanName(response.name)
          setPlanDate(response.data)
          setPlanGroupID(response.group_id)
          setPlanModifiedDate(response.modified)

          var docW = document.documentElement.clientWidth;
          var docH = document.documentElement.clientHeight;
          $('#sbs-table-content').width(docW-120);
          $('.sbs-table').width(docW+120);
          $('#sbs-content-scroll').width(docW-140);
          $('#sbs-content-scroll').height(docH-50);
          $('#plan-preview').width(response.width*40);
          $('#plan-preview').height(response.height*40);
          $('.sbs-table-panel-overflow').height(docH-50);

        });     
    }
    var y=0;
    var x=0;
    $('#sbs-content-scroll').show();                                            //GLOBAL DOCUMENT FUNCTIONS useEffect[]


  

   // $('#sbs-content-scroll').scrollTop(y);
   // $('#sbs-content-scroll').scrollLeft(x);

   window.addEventListener('beforeunload', beforeUnLoad);


    $(window).on('resize', function(e){	
      var docW = document.documentElement.clientWidth;
      var docH = document.documentElement.clientHeight;
      $('#sbs-table-content').width(docW-120);
      $('.sbs-table').width(docW+120);
      $('#sbs-content-scroll').width(docW-140);
      $('#sbs-content-scroll').height(docH-50);
      $('#plan-preview').width(plan_width *40);
      $('#plan-preview').height(plan_height*40);
      $('.sbs-table-panel-overflow').height(docH-50);
    });
    



        

    // Popup Close
    $('#sbs-popup .popup .close').unbind('click')
    $('#sbs-popup .popup .close').on('click', function() {
      $('#sbs-popup').hide();
    });	
    $('#sbs-popup .popup a.form-cancel').unbind('click');
    $('#sbs-popup .popup a.form-cancel').on('click', function() {
      $('#sbs-popup').hide();
    });	


    

    // Popup Close
    $('#sbs-popup .popup .close').unbind('click')                               //GLOBAL DOCUMENT FUNCTIONS useEffect[]
    $('#sbs-popup .popup .close').on('click', function() {
      $('#sbs-popup').hide();
    });	

    $('#sbs-popup .popup a.form-cancel').unbind('click')
    $('#sbs-popup .popup a.form-cancel').on('click', function() {
      $('#sbs-popup').hide();
    });	

    

    // Stand New Submit
    /*$('#sbs-popup-stand-new a.form-submit').unbind('click')
    $('#sbs-popup-stand-new a.form-submit').on('click', function() {           //GLOBAL DOCUMENT FUNCTIONS useEffect[]
      
      var stand_NAME = $('#sbs-popup-stand-new .stand_NAME').val();
      var stand_NR = $('#sbs-popup-stand-new .stand_NR').val();
      var stand_W = $('#sbs-popup-stand-new .stand_W').val();
      var stand_H = $('#sbs-popup-stand-new .stand_H').val();
      var stand_COLOR = color_stand;

      if(stand_NAME == '') {
        alert('Uzupełnij pola obowiązkowe!');
      }else {	
        StandeditorService.newstand('stand_NEW', String(stand_NAME), String(stand_NR), Number(stand_W), Number(stand_H), stand_COLOR).then(response => {
          setFunc('move-temp-stand');
          setFuncPut('');
          $('#sbs-popup').hide();
          $('#temp-STAND').html(response.data).show();
        }).catch(
          (error) => {
            console.log(error)
          }
        )	
      }
    });	
    */


    // Plan Restore List @mk
    $(document).on('mouseenter', '.view-select.list',  function() {           //GLOBAL DOCUMENT FUNCTIONS useEffect[]
        //var inner = $(this).find('.inner');
        //inner.html( 
        //'<a target="_blank" class="">' +
        //'	Pobieram historię' +
        //'</a>');
        f_BackupList(plan_id, function(backups: any[]) { 
          if(backups.length > 0) {
            setBackups(backups)
          }else {		
            setBackups([{name : "", label : "Brak historii"}])
          }	
        });
    });	


    // Plan Restore - Show Backups
    function f_BackupList(plan_ID : number, next:any) {                 //GLOBAL DOCUMENT FUNCTIONS useEffect[]
      if(!plan_ID) return;
      standeditorService.getbackuplist(plan_ID).then( (response) => {
        var backups = response.data;	
        console.log(response.data)
        next(backups);
      })
    }

      
}, [])                                                               //GLOBAL DOCUMENT FUNCTIONS useEffect[]


useEffect(()=>{                                                     //GLOBAL DOCUMENT FUNCTIONS
  


// Stand New Submit
$('#sbs-popup-stand-new a.form-submit').unbind('click');
$('#sbs-popup-stand-new a.form-submit').on('click', function() {            //GLOBAL DOCUMENT FUNCTIONS useEffect[]
  var stand_NAME = $('#sbs-popup-stand-new .stand_NAME').val();
  var stand_NR = $('#sbs-popup-stand-new .stand_NR').val();
  var stand_W = $('#sbs-popup-stand-new .stand_W').val();
  var stand_H = $('#sbs-popup-stand-new .stand_H').val();
  var stand_COLOR = color_stand
  //console.log(color_stand)

  if(stand_NAME == '') {
    alert('Uzupełnij pola obowiązkowe!');
  }
  else {	
    StandeditorService.newstand('stand_NEW', String(stand_NAME), String(stand_NR), Number(stand_W), Number(stand_H), stand_COLOR).then(response => {
      setFunc('move-temp-stand');
      setFuncPut('');
      $('#sbs-popup').hide();
      $('#temp-STAND').html(response.data).show();

    }).catch(
      (error) => {
        console.log('send stand status error')
      }
    )
  }
});	
}, [color_stand])

useEffect(()=>{                                                     //GLOBAL DOCUMENT FUNCTIONS
  if (isplanEdited){
    var events = ["mouseup", "keydown", "scroll", "mousemove"];
    events.forEach(function (e) { 
      document.removeEventListener(e, checkEditorActivity); 
      document.addEventListener(e, checkEditorActivity)
    });
  }else{
    var events = ["mouseup", "keydown", "scroll", "mousemove"];
    events.forEach(function (e) { 
      document.removeEventListener(e, checkEditorActivity); 
    });
  }
}, [lastActivity,isplanEdited])

function f_ResetFunc(){                                           //GLOBAL DOCUMENT FUNCTIONS
    setFuncEnd('')
    setFuncPut('')
    setFuncRotateId('')
    
    setDrawAuto1x(0)
    setDrawAuto1y(0)
    setDrawAuto2x(0)
    setDrawAuto2y(0)
    //alert('ff')
    //$('#plan_CONTENT td:not(.stand)').unbind('mousewheel');
    
    $('#plan-temp-draw').hide();
    $('#plan-temp-draw').css({'width': '20px', 'height': '20px'});
}



function checkactivityedit(){                                   //GLOBAL DOCUMENT FUNCTIONS
  StandeditorService.checkactivityedit(plan_id).then((response) => {
    if (response.data==0){
      window.location.reload();
    }

  }).catch(
    (error) => {
      window.location.reload();
    }
    )
}

function f_PlanActivityEdit(){                                       //GLOBAL DOCUMENT FUNCTIONS
  console.log('setactivityedit')
  StandeditorService.setactivityedit(plan_id).then((response) => {
     setLastActivity(new Date()); 
   }).catch(
     (error) => {
      console.log(error) 
     }
   )
}

const checkEditorActivity = ( e:any) =>{                                //GLOBAL DOCUMENT FUNCTIONS
  var that = this
    var date = new Date();
    var diffMs : number = (date.getTime() - lastActivity.getTime()); // milliseconds between now
    var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000);
    if (diffMins > 2){
        var events = ["mouseup", "keydown", "scroll", "mousemove"];
        events.forEach(function (e) { 
          document.removeEventListener(e, checkEditorActivity); 
        });
        setLastActivity(new Date()); 
        f_PlanActivityEdit();   
    }
}

$(document).unbind('keyup');
$(document).keyup(function(e) {
  if ($('#sbs-popup-stand-new').is(':visible')) {
    if(e.which == 13) {$('#sbs-popup-stand-new a.form-submit').click();}
    if(e.which == 27) {$('#sbs-popup-stand-new a.form-cancel').click();}
  }
  if ($('#sbs-popup-stand-edit').is(':visible')) {
    if(e.which == 13) {$('#sbs-popup-stand-edit a.editor-update').click();}
    if(e.which == 27) {$('#sbs-popup-stand-edit div.close').click();}
  }
  if (func == 'move-temp-stand') {
    setFunc(func_put);
    $('#temp-STAND').html('');
  }
});



/////!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!GLOBAL DOCUMENT FUNCTIONS!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!///////

/////////////////////////////////////FUNCTIONS STANDEDITOR////////////////////////////////////////////////////////////  

const editorStandClick = (e:any) => {
  $('.sbs-table-panel-tab p').removeClass('active');
  f_ResetFunc();
  
  $(e.currentTarget).addClass('active');
  
  if ($(e.currentTarget).is('.stand-new')) {f_stand_New();}
  if ($(e.currentTarget).is('.stand-load')) {setFunc('stand-load');}
  if ($(e.currentTarget).is('.stand-edit')) {setFunc('stand-edit');}
  if ($(e.currentTarget).is('.stand-move')) {setFunc('stand-move');}
  if ($(e.currentTarget).is('.stand-rotate')) {setFunc('stand-rotate');}
  if ($(e.currentTarget).is('.stand-clone')) {setFunc('stand-clone');}
  if ($(e.currentTarget).is('.stand-delete')) {setFunc('stand-delete');}

};	

// Stand Delete
function f_stand_Delete(stand_ID : string){
		var confirmDelete = window.confirm("Czy na pewno chcesz usunąć wybrane stoisko?");
		if (confirmDelete){
			$('#'+stand_ID).parent().removeClass();
			$('#'+stand_ID).parent().html('');
			$('#sbs-table-menu a.save').slideDown();
			f_UpdateList();
		}
}


// Stand New
function f_stand_New(){                                               //FUNCTIONS STANDEDITOR
    $('.sbs-table-panel-tab p').removeClass('active');	
    
    var standCount = $('#plan_CONTENT div.stand').length+1;
    $('#sbs-popup-stand-new .stand_NAME').val('Nowe stoisko');
    $('#sbs-popup-stand-new .stand_NR').val(standCount);
        
    $('#sbs-popup .popup').hide();
    $('#sbs-popup-stand-new').show();
    $('#sbs-popup').show();
}

const advancedRotateStand = (stand_ID:string) => {
  if (document.getElementById(stand_ID) != undefined){
    //console.log(document.getElementById(stand_ID))

    var width : number = $('#'+stand_ID).width() ?  $('#'+stand_ID).width() as number : 0
    var height : number  = $('#'+stand_ID).height() ?  $('#'+stand_ID).height() as number  : 0
    var tmp =  $($($('#'+stand_ID + ' table')[0].children[0].children))
    //console.log(tmp)
    //console.log('height='+height + ', width=' + width)

      $('#'+stand_ID). width(height)
      $('#'+stand_ID).height(width)
      
      var style =   $($($('#'+stand_ID + ' table')[0].children[0].children[0])).css('background-color')
      $($($('#'+stand_ID + ' table')[0].children[0].children)).remove()
      $($('#'+stand_ID + ' table')).height(width)
      $($('#'+stand_ID + ' table')).width(height)
      for (let index = 0; index <=$($(tmp[0])[0].children).length - 1; index++) {
        var element =  $($('#'+stand_ID + ' table')[0].children[0]).append($('<tr>').addClass('stand').css('background-color', style))
        for (let index2 = $(tmp).length-1; index2 >=0; index2--) {
          var data_1 = $($(tmp[index2])[0].children[index])
          $($(element[0].children).last()).append( $('<td>').addClass('stand'))
          var td = $($(($(element[0].children).last())[0].children).last())[0]
          let tst = $(data_1[0].children).length 
          let x=0
          while ($(data_1[0].children).length > 0){ 
            let z=0;
            x=x+1
            
            let is_chairs3 = false;
            let is_volt = false;

            let is_any_b = false;
            let is_any_r = false;
            let is_any_t = false;
            let is_any_l = false;

            let is_any2_b = false;
            let is_any2_r = false;
            let is_any2_t = false;
            let is_any2_l = false;

            let is_light_l = false;
            let is_light_t = false;
            let is_light_r = false;
            let is_light_b = false;

            let is_hoker_l = false;
            let is_hoker_t = false;
            let is_hoker_r = false;
            let is_hoker_b = false;

            let is_wall_1_l = false;
            let is_wall_1_t = false;
            let is_wall_1_r = false;
            let is_wall_1_b = false;

            let is_wall_2_l = false;
            let is_wall_2_t = false;
            let is_wall_2_r = false;
            let is_wall_2_b = false;

            let is_bull_l = false;
            let is_bull_t = false;
            let is_bull_r = false;
            let is_bull_b = false;

            let is_leaflets_l = false;
            let is_leaflets_t = false;
            let is_leaflets_r = false;
            let is_leaflets_b = false;

            let is_hanger_b = false;
            let is_hanger_r = false;
            let is_hanger_t = false;
            let is_hanger_l = false;

            let is_regal_b = false;
            let is_regal_r = false;
            let is_regal_t = false;
            let is_regal_l = false;

            let is_chairs2_b = false;
            let is_chairs2_r = false;
            let is_chairs2_t = false;
            let is_chairs2_l = false;
            
            let is_chairs1_b = false;
            let is_chairs1_r = false;
            let is_chairs1_t = false;
            let is_chairs1_l = false;
            

            if ($(data_1[0].children)[z]){
              
              for (let c_index = 0; c_index <= $(data_1[0].children)[z].classList.length-1; c_index++){
                
                if ($(data_1[0].children)[z].classList[c_index].includes('chairs-3')){
                  is_chairs3 = true;

                  let pos = (($(element[0].children).last())[0].children).length  -4  >= 0 ? (($(element[0].children).last())[0].children).length - 4  : 0
                  //console.log("pos=" + pos)
                  //if (pos > 0){
                    var td1 = $($(($(element[0].children).last())[0].children).eq(pos))[0]
                    td1.append($(data_1[0].children)[z])
                  //}else{
                  //  td1.append($(data_1[0].children)[z])
                 // }
                  
                  break;
                }

                //any 
                else if ($(data_1[0].children)[z].classList[c_index].includes('any-b')){
                  is_any_b = true;
                  //var td1 = $($(($(element[0].children).last())[0].children).eq($(($(element[0].children).last())[0].children).length-1))[0]
                  $($(data_1[0].children)[z]).removeClass('any-b');
                  $($(data_1[0].children)[z]).addClass('any-r');
                  //td1.append($(data_1[0].children)[z])
                  td.append($(data_1[0].children)[z])
                  break;
                }
                else if ($(data_1[0].children)[z].classList[c_index].includes('any-t')){
                  is_any_t = true;
                  //var td1 = $($(($(element[0].children).last())[0].children).eq($(($(element[0].children).last())[0].children).length-1))[0]
                  $($(data_1[0].children)[z]).removeClass('any-t');
                  $($(data_1[0].children)[z]).addClass('any-l');
                  //td1.append($(data_1[0].children)[z])
                  td.append($(data_1[0].children)[z])
                  break;
                }

                else if ($(data_1[0].children)[z].classList[c_index].includes('any-r')){
                  is_any_r = true;
                  var td1 = $($(($(element[0].children).last())[0].children).eq($(($(element[0].children).last())[0].children).length-2))[0]
                  $($(data_1[0].children)[z]).removeClass('any-r');
                  $($(data_1[0].children)[z]).addClass('any-b');
                  td1.append($(data_1[0].children)[z])
                  //td.append($(data_1[0].children)[z])
                  break;
                }
                else if ($(data_1[0].children)[z].classList[c_index].includes('any-l')){
                  is_any_l = true;
                  var td1 = $($(($(element[0].children).last())[0].children).eq($(($(element[0].children).last())[0].children).length-2))[0]
                  $($(data_1[0].children)[z]).removeClass('any-l');
                  $($(data_1[0].children)[z]).addClass('any-t');
                  td1.append($(data_1[0].children)[z])
                  //td.append($(data_1[0].children)[z])
                  break;
                }

                //any2 
                else if ($(data_1[0].children)[z].classList[c_index].includes('any2-b')){
                  is_any2_b = true;
                  //var td1 = $($(($(element[0].children).last())[0].children).eq($(($(element[0].children).last())[0].children).length-1))[0]
                  $($(data_1[0].children)[z]).removeClass('any2-b');
                  $($(data_1[0].children)[z]).addClass('any2-r');
                  //td1.append($(data_1[0].children)[z])
                  td.append($(data_1[0].children)[z])
                  break;
                }
                else if ($(data_1[0].children)[z].classList[c_index].includes('any2-t')){
                  is_any2_t = true;
                  //var td1 = $($(($(element[0].children).last())[0].children).eq($(($(element[0].children).last())[0].children).length-1))[0]
                  $($(data_1[0].children)[z]).removeClass('any2-t');
                  $($(data_1[0].children)[z]).addClass('any2-l');
                  //td1.append($(data_1[0].children)[z])
                  td.append($(data_1[0].children)[z])
                  break;
                }

                else if ($(data_1[0].children)[z].classList[c_index].includes('any2-r')){
                  is_any2_r = true;
                  var td1 = $($(($(element[0].children).last())[0].children).eq($(($(element[0].children).last())[0].children).length-2))[0]
                  $($(data_1[0].children)[z]).removeClass('any2-r');
                  $($(data_1[0].children)[z]).addClass('any2-b');
                  td1.append($(data_1[0].children)[z])
                  //td.append($(data_1[0].children)[z])
                  break;
                }
                else if ($(data_1[0].children)[z].classList[c_index].includes('any2-l')){
                  is_any2_l = true;
                  var td1 = $($(($(element[0].children).last())[0].children).eq($(($(element[0].children).last())[0].children).length-2))[0]
                  $($(data_1[0].children)[z]).removeClass('any2-l');
                  $($(data_1[0].children)[z]).addClass('any2-t');
                  td1.append($(data_1[0].children)[z])
                  //td.append($(data_1[0].children)[z])
                  break;
                }


                //light
                else if ($(data_1[0].children)[z].classList[c_index].includes('light-l')){
                  is_light_l = true;
                  //var td1 = $($(($(element[0].children).last())[0].children).eq($(($(element[0].children).last())[0].children).length-2))[0]
                  $($(data_1[0].children)[z]).removeClass('light-l');
                  $($(data_1[0].children)[z]).addClass('light-t');
                  //td1.append($(data_1[0].children)[z])
                  td.append($(data_1[0].children)[z])
                  break;
                }
                else if ($(data_1[0].children)[z].classList[c_index].includes('light-t')){
                  is_light_t = true;
                  //var td1 = $($(($(element[0].children).last())[0].children).eq($(($(element[0].children).last())[0].children).length-2))[0]
                  $($(data_1[0].children)[z]).removeClass('light-t');
                  $($(data_1[0].children)[z]).addClass('light-r');
                  //td1.append($(data_1[0].children)[z])
                  td.append($(data_1[0].children)[z])
                  break;
                }
                else if ($(data_1[0].children)[z].classList[c_index].includes('light-r')){
                  is_light_r = true;
                  //var td1 = $($(($(element[0].children).last())[0].children).eq($(($(element[0].children).last())[0].children).length-2))[0]
                  $($(data_1[0].children)[z]).removeClass('light-r');
                  $($(data_1[0].children)[z]).addClass('light-b');
                  //td1.append($(data_1[0].children)[z])
                  td.append($(data_1[0].children)[z])
                  break;
                }
                else if ($(data_1[0].children)[z].classList[c_index].includes('light-b')){
                  is_light_b = true;
                  //var td1 = $($(($(element[0].children).last())[0].children).eq($(($(element[0].children).last())[0].children).length-2))[0]
                  $($(data_1[0].children)[z]).removeClass('light-b');
                  $($(data_1[0].children)[z]).addClass('light-l');
                  //td1.append($(data_1[0].children)[z])
                  td.append($(data_1[0].children)[z])
                  break;
                }

                //leaftlefts

                else if ($(data_1[0].children)[z].classList[c_index].includes('leaflets-l')){
                  is_leaflets_l = true;
                  //var td1 = $($(($(element[0].children).last())[0].children).eq($(($(element[0].children).last())[0].children).length-2))[0]
                  $($(data_1[0].children)[z]).removeClass('leaflets-l');
                  $($(data_1[0].children)[z]).addClass('leaflets-t');
                  //td1.append($(data_1[0].children)[z])
                  td.append($(data_1[0].children)[z])
                  break;
                }
                else if ($(data_1[0].children)[z].classList[c_index].includes('leaflets-t')){
                  is_leaflets_t = true;
                  //var td1 = $($(($(element[0].children).last())[0].children).eq($(($(element[0].children).last())[0].children).length-2))[0]
                  $($(data_1[0].children)[z]).removeClass('leaflets-t');
                  $($(data_1[0].children)[z]).addClass('leaflets-r');
                  //td1.append($(data_1[0].children)[z])
                  td.append($(data_1[0].children)[z])
                  break;
                }
                else if ($(data_1[0].children)[z].classList[c_index].includes('leaflets-r')){
                  is_leaflets_r = true;
                  //var td1 = $($(($(element[0].children).last())[0].children).eq($(($(element[0].children).last())[0].children).length-2))[0]
                  $($(data_1[0].children)[z]).removeClass('leaflets-r');
                  $($(data_1[0].children)[z]).addClass('leaflets-b');
                  //td1.append($(data_1[0].children)[z])
                  td.append($(data_1[0].children)[z])
                  break;
                }
                else if ($(data_1[0].children)[z].classList[c_index].includes('leaflets-b')){
                  is_leaflets_b = true;
                  //var td1 = $($(($(element[0].children).last())[0].children).eq($(($(element[0].children).last())[0].children).length-2))[0]
                  $($(data_1[0].children)[z]).removeClass('leaflets-b');
                  $($(data_1[0].children)[z]).addClass('leaflets-l');
                  //td1.append($(data_1[0].children)[z])
                  td.append($(data_1[0].children)[z])
                  break;
                }

                //volt
                else if ($(data_1[0].children)[z].classList[c_index].includes('volt-')){
                  is_volt = true;
                  td.append($(data_1[0].children)[z])
                  break;
                }

                else if ($(data_1[0].children)[z].classList[c_index].includes('hoker-l')){
                  is_hoker_l = true;
                  //var td1 = $($(($(element[0].children).last())[0].children).eq($(($(element[0].children).last())[0].children).length-2))[0]
                  $($(data_1[0].children)[z]).removeClass('hoker-l');
                  $($(data_1[0].children)[z]).addClass('hoker-t');
                  //td1.append($(data_1[0].children)[z])
                  td.append($(data_1[0].children)[z])
                  break;
                }
                else if ($(data_1[0].children)[z].classList[c_index].includes('hoker-t')){
                  is_hoker_t = true;
                  //var td1 = $($(($(element[0].children).last())[0].children).eq($(($(element[0].children).last())[0].children).length-2))[0]
                  $($(data_1[0].children)[z]).removeClass('hoker-t');
                  $($(data_1[0].children)[z]).addClass('hoker-r');
                  //td1.append($(data_1[0].children)[z])
                  td.append($(data_1[0].children)[z])
                  break;
                }
                else if ($(data_1[0].children)[z].classList[c_index].includes('hoker-r')){
                  is_hoker_r = true;
                  //var td1 = $($(($(element[0].children).last())[0].children).eq($(($(element[0].children).last())[0].children).length-2))[0]
                  $($(data_1[0].children)[z]).removeClass('hoker-r');
                  $($(data_1[0].children)[z]).addClass('hoker-b');
                  //td1.append($(data_1[0].children)[z])
                  td.append($(data_1[0].children)[z])
                  break;
                }
                else if ($(data_1[0].children)[z].classList[c_index].includes('hoker-b')){
                  is_hoker_b = true;
                  //var td1 = $($(($(element[0].children).last())[0].children).eq($(($(element[0].children).last())[0].children).length-2))[0]
                  $($(data_1[0].children)[z]).removeClass('hoker-b');
                  $($(data_1[0].children)[z]).addClass('hoker-l');
                  //td1.append($(data_1[0].children)[z])
                  td.append($(data_1[0].children)[z])
                  break;
                }


                else if ($(data_1[0].children)[z].classList[c_index].includes('wall-1-l')){
                  is_wall_1_l = true;
                  var td1 = $($(($(element[0].children).last())[0].children).eq(0))[0]
                  $($(data_1[0].children)[z]).removeClass('wall-1-l');
                  $($(data_1[0].children)[z]).addClass('wall-1-t');

                  //TST
                  let ElmH : number =  Number($($(data_1[0].children)[z]).height());
                  let ElmW : number = Number($($(data_1[0].children)[z]).width());
                  let top  = $($(data_1[0].children)[z]).css('top');
                  let left = $($(data_1[0].children)[z]).css('left');
                  if (ElmH > 0){
                    $($(data_1[0].children)[z]).height(ElmW)
                    $($(data_1[0].children)[z]).width(ElmH)
                    $($(data_1[0].children)[z]).css('top', 0);
                    $($(data_1[0].children)[z]).css('left', 0);
                    td1.append($(data_1[0].children)[z])
                  }else{
                    td.append($(data_1[0].children)[z])
                  }
                  break;
                }
                else if ($(data_1[0].children)[z].classList[c_index].includes('wall-1-t')){
                  is_wall_1_t = true;
                  var td1 = $($(($(element[0].children).last())[0].children).eq(0))[0]
                  $($(data_1[0].children)[z]).removeClass('wall-1-t');
                  $($(data_1[0].children)[z]).addClass('wall-1-r');
                  let ElmH : number =  Number($($(data_1[0].children)[z]).height());
                  let ElmW : number = Number($($(data_1[0].children)[z]).width());
                  let top  = $($(data_1[0].children)[z]).css('top');
                  let left = $($(data_1[0].children)[z]).css('left');
                  if (ElmW > 0){
                    $($(data_1[0].children)[z]).height(ElmW)
                    $($(data_1[0].children)[z]).width(ElmH)
                    $($(data_1[0].children)[z]).css('top', 0);
                    $($(data_1[0].children)[z]).css('left', height-20);
                    td1.append($(data_1[0].children)[z])
                  }else{       
                    td.append($(data_1[0].children)[z])
                  }
                  break;
                }
                else if ($(data_1[0].children)[z].classList[c_index].includes('wall-1-r')){
                  is_wall_1_r = true;
                  var td1 = $($(($(element[0].children).last())[0].children).eq(0))[0]
                  $($(data_1[0].children)[z]).removeClass('wall-1-r');
                  $($(data_1[0].children)[z]).addClass('wall-1-b');
                  let ElmH : number =  Number($($(data_1[0].children)[z]).height());
                  let ElmW : number = Number($($(data_1[0].children)[z]).width());
                  let top  = $($(data_1[0].children)[z]).css('top');
                  let left = $($(data_1[0].children)[z]).css('left');
                  if (ElmH > 0){
                    $($(data_1[0].children)[z]).height(ElmW)
                    $($(data_1[0].children)[z]).width(ElmH)
                    $($(data_1[0].children)[z]).css('top', left);
                    $($(data_1[0].children)[z]).css('left', top);
                    td1.append($(data_1[0].children)[z])
                  }else{
                    td.append($(data_1[0].children)[z])
                  }
                  break;
                }
                else if ($(data_1[0].children)[z].classList[c_index].includes('wall-1-b')){
                  is_wall_1_b = true;
                  var td1 = $($(($(element[0].children).last())[0].children).eq(0))[0]
                  $($(data_1[0].children)[z]).removeClass('wall-1-b');
                  $($(data_1[0].children)[z]).addClass('wall-1-l');

                  let ElmH : number =  Number($($(data_1[0].children)[z]).height());
                  let ElmW : number = Number($($(data_1[0].children)[z]).width());
                  let top  = $($(data_1[0].children)[z]).css('top');
                  let left = $($(data_1[0].children)[z]).css('left');
                  if (ElmW > 0){
                    $($(data_1[0].children)[z]).height(ElmW)
                    $($(data_1[0].children)[z]).width(ElmH)
                    $($(data_1[0].children)[z]).css('top', left);
                    $($(data_1[0].children)[z]).css('left', 0);
                    td1.append($(data_1[0].children)[z])
                  }else{
                    td.append($(data_1[0].children)[z])
                  }
                  break;
                }

                //wall2

                else if ($(data_1[0].children)[z].classList[c_index].includes('wall-2-l')){
                  is_wall_2_l = true;
                  var td1 = $($(($(element[0].children).last())[0].children).eq(0))[0]
                  $($(data_1[0].children)[z]).removeClass('wall-2-l');
                  $($(data_1[0].children)[z]).addClass('wall-2-t');

                  //TST
                  let ElmH : number =  Number($($(data_1[0].children)[z]).height());
                  let ElmW : number = Number($($(data_1[0].children)[z]).width());
                  let top  = $($(data_1[0].children)[z]).css('top');
                  let left = $($(data_1[0].children)[z]).css('left');
                  if (ElmH > 0){
                    $($(data_1[0].children)[z]).height(ElmW)
                    $($(data_1[0].children)[z]).width(ElmH)
                    $($(data_1[0].children)[z]).css('top', 0);
                    $($(data_1[0].children)[z]).css('left', 0);
                    td1.append($(data_1[0].children)[z])
                  }else{
                    td.append($(data_1[0].children)[z])
                  }
                  break;
                }
                else if ($(data_1[0].children)[z].classList[c_index].includes('wall-2-t')){
                  is_wall_2_t = true;
                  var td1 = $($(($(element[0].children).last())[0].children).eq(0))[0]
                  $($(data_1[0].children)[z]).removeClass('wall-2-t');
                  $($(data_1[0].children)[z]).addClass('wall-2-r');
                  let ElmH : number =  Number($($(data_1[0].children)[z]).height());
                  let ElmW : number = Number($($(data_1[0].children)[z]).width());
                  let top  = $($(data_1[0].children)[z]).css('top');
                  let left = $($(data_1[0].children)[z]).css('left');
                  if (ElmW > 0){
                    $($(data_1[0].children)[z]).height(ElmW)
                    $($(data_1[0].children)[z]).width(ElmH)
                    $($(data_1[0].children)[z]).css('top', 0);
                    $($(data_1[0].children)[z]).css('left', height-20);
                    td1.append($(data_1[0].children)[z])
                  }else{       
                    td.append($(data_1[0].children)[z])
                  }
                  break;
                }
                else if ($(data_1[0].children)[z].classList[c_index].includes('wall-2-r')){
                  is_wall_2_r = true;
                  var td1 = $($(($(element[0].children).last())[0].children).eq(0))[0]
                  $($(data_1[0].children)[z]).removeClass('wall-2-r');
                  $($(data_1[0].children)[z]).addClass('wall-2-b');
                  let ElmH : number =  Number($($(data_1[0].children)[z]).height());
                  let ElmW : number = Number($($(data_1[0].children)[z]).width());
                  let top  = $($(data_1[0].children)[z]).css('top');
                  let left = $($(data_1[0].children)[z]).css('left');
                  if (ElmH > 0){
                    $($(data_1[0].children)[z]).height(ElmW)
                    $($(data_1[0].children)[z]).width(ElmH)
                    $($(data_1[0].children)[z]).css('top', left);
                    $($(data_1[0].children)[z]).css('left', top);
                    td1.append($(data_1[0].children)[z])
                  }else{
                    td.append($(data_1[0].children)[z])
                  }
                  break;
                }
                else if ($(data_1[0].children)[z].classList[c_index].includes('wall-2-b')){
                  is_wall_2_b = true;
                  var td1 = $($(($(element[0].children).last())[0].children).eq(0))[0]
                  $($(data_1[0].children)[z]).removeClass('wall-2-b');
                  $($(data_1[0].children)[z]).addClass('wall-2-l');

                  let ElmH : number =  Number($($(data_1[0].children)[z]).height());
                  let ElmW : number = Number($($(data_1[0].children)[z]).width());
                  let top  = $($(data_1[0].children)[z]).css('top');
                  let left = $($(data_1[0].children)[z]).css('left');
                  if (ElmW > 0){
                    $($(data_1[0].children)[z]).height(ElmW)
                    $($(data_1[0].children)[z]).width(ElmH)
                    $($(data_1[0].children)[z]).css('top', left);
                    $($(data_1[0].children)[z]).css('left', 0);
                    td1.append($(data_1[0].children)[z])
                  }else{
                    td.append($(data_1[0].children)[z])
                  }
                  break;
                }

                //wall3

                else if ($(data_1[0].children)[z].classList[c_index].includes('wall-3-l')){
                  is_wall_2_l = true;
                  var td1 = $($(($(element[0].children).last())[0].children).eq(0))[0]
                  $($(data_1[0].children)[z]).removeClass('wall-3-l');
                  $($(data_1[0].children)[z]).addClass('wall-3-t');

                  //TST
                  let ElmH : number =  Number($($(data_1[0].children)[z]).height());
                  let ElmW : number = Number($($(data_1[0].children)[z]).width());
                  let top  = $($(data_1[0].children)[z]).css('top');
                  let left = $($(data_1[0].children)[z]).css('left');
                  if (ElmH > 0){
                    $($(data_1[0].children)[z]).height(ElmW)
                    $($(data_1[0].children)[z]).width(ElmH)
                    $($(data_1[0].children)[z]).css('top', 0);
                    $($(data_1[0].children)[z]).css('left', 0);
                    td1.append($(data_1[0].children)[z])
                  }else{
                    td.append($(data_1[0].children)[z])
                  }
                  break;
                }
                else if ($(data_1[0].children)[z].classList[c_index].includes('wall-3-t')){
                  is_wall_2_t = true;
                  var td1 = $($(($(element[0].children).last())[0].children).eq(0))[0]
                  $($(data_1[0].children)[z]).removeClass('wall-3-t');
                  $($(data_1[0].children)[z]).addClass('wall-3-r');
                  let ElmH : number =  Number($($(data_1[0].children)[z]).height());
                  let ElmW : number = Number($($(data_1[0].children)[z]).width());
                  let top  = $($(data_1[0].children)[z]).css('top');
                  let left = $($(data_1[0].children)[z]).css('left');
                  if (ElmW > 0){
                    $($(data_1[0].children)[z]).height(ElmW)
                    $($(data_1[0].children)[z]).width(ElmH)
                    $($(data_1[0].children)[z]).css('top', 0);
                    $($(data_1[0].children)[z]).css('left', height-20);
                    td1.append($(data_1[0].children)[z])
                  }else{       
                    td.append($(data_1[0].children)[z])
                  }
                  break;
                }
                else if ($(data_1[0].children)[z].classList[c_index].includes('wall-3-r')){
                  is_wall_2_r = true;
                  var td1 = $($(($(element[0].children).last())[0].children).eq(0))[0]
                  $($(data_1[0].children)[z]).removeClass('wall-3-r');
                  $($(data_1[0].children)[z]).addClass('wall-3-b');
                  let ElmH : number =  Number($($(data_1[0].children)[z]).height());
                  let ElmW : number = Number($($(data_1[0].children)[z]).width());
                  let top  = $($(data_1[0].children)[z]).css('top');
                  let left = $($(data_1[0].children)[z]).css('left');
                  if (ElmH > 0){
                    $($(data_1[0].children)[z]).height(ElmW)
                    $($(data_1[0].children)[z]).width(ElmH)
                    $($(data_1[0].children)[z]).css('top', left);
                    $($(data_1[0].children)[z]).css('left', top);
                    td1.append($(data_1[0].children)[z])
                  }else{
                    td.append($(data_1[0].children)[z])
                  }
                  break;
                }
                else if ($(data_1[0].children)[z].classList[c_index].includes('wall-3-b')){
                  is_wall_2_b = true;
                  var td1 = $($(($(element[0].children).last())[0].children).eq(0))[0]
                  $($(data_1[0].children)[z]).removeClass('wall-3-b');
                  $($(data_1[0].children)[z]).addClass('wall-3-l');

                  let ElmH : number =  Number($($(data_1[0].children)[z]).height());
                  let ElmW : number = Number($($(data_1[0].children)[z]).width());
                  let top  = $($(data_1[0].children)[z]).css('top');
                  let left = $($(data_1[0].children)[z]).css('left');
                  if (ElmW > 0){
                    $($(data_1[0].children)[z]).height(ElmW)
                    $($(data_1[0].children)[z]).width(ElmH)
                    $($(data_1[0].children)[z]).css('top', left);
                    $($(data_1[0].children)[z]).css('left', 0);
                    td1.append($(data_1[0].children)[z])
                  }else{
                    td.append($(data_1[0].children)[z])
                  }
                  break;
                }

                //bull
                else if ($(data_1[0].children)[z].classList[c_index].includes('bull-l')){
                  is_bull_l = true;
                  var td1 = $($(($(element[0].children).last())[0].children).eq(0))[0]
                  $($(data_1[0].children)[z]).removeClass('bull-l');
                  $($(data_1[0].children)[z]).addClass('bull-t');

                  //TST
                  let ElmH : number =  Number($($(data_1[0].children)[z]).height());
                  let ElmW : number = Number($($(data_1[0].children)[z]).width());
                  let top  = $($(data_1[0].children)[z]).css('top');
                  let left = $($(data_1[0].children)[z]).css('left');
                  if (ElmH > 0){
                    $($(data_1[0].children)[z]).height(ElmW)
                    $($(data_1[0].children)[z]).width(ElmH)
                    $($(data_1[0].children)[z]).css('top', 0);
                    $($(data_1[0].children)[z]).css('left', 0);
                    td1.append($(data_1[0].children)[z])
                  }else{
                    td.append($(data_1[0].children)[z])
                  }
                  break;
                }
                else if ($(data_1[0].children)[z].classList[c_index].includes('bull-t')){
                  is_bull_t = true;
                  var td1 = $($(($(element[0].children).last())[0].children).eq(0))[0]
                  $($(data_1[0].children)[z]).removeClass('bull-t');
                  $($(data_1[0].children)[z]).addClass('bull-r');
                  let ElmH : number =  Number($($(data_1[0].children)[z]).height());
                  let ElmW : number = Number($($(data_1[0].children)[z]).width());
                  let top  = $($(data_1[0].children)[z]).css('top');
                  let left = $($(data_1[0].children)[z]).css('left');
                  if (ElmW > 0){
                    $($(data_1[0].children)[z]).height(ElmW)
                    $($(data_1[0].children)[z]).width(ElmH)
                    $($(data_1[0].children)[z]).css('top', 0);
                    $($(data_1[0].children)[z]).css('left', height-20);
                    td1.append($(data_1[0].children)[z])
                  }else{       
                    td.append($(data_1[0].children)[z])
                  }
                  break;
                }
                else if ($(data_1[0].children)[z].classList[c_index].includes('bull-r')){
                  is_bull_r = true;
                  var td1 = $($(($(element[0].children).last())[0].children).eq(0))[0]
                  $($(data_1[0].children)[z]).removeClass('bull-r');
                  $($(data_1[0].children)[z]).addClass('bull-b');
                  let ElmH : number =  Number($($(data_1[0].children)[z]).height());
                  let ElmW : number = Number($($(data_1[0].children)[z]).width());
                  let top  = $($(data_1[0].children)[z]).css('top');
                  let left = $($(data_1[0].children)[z]).css('left');
                  if (ElmH > 0){
                    $($(data_1[0].children)[z]).height(ElmW)
                    $($(data_1[0].children)[z]).width(ElmH)
                    $($(data_1[0].children)[z]).css('top', left);
                    $($(data_1[0].children)[z]).css('left', -20);
                    td1.append($(data_1[0].children)[z])
                  }else{
                    td.append($(data_1[0].children)[z])
                  }
                  break;
                }
                else if ($(data_1[0].children)[z].classList[c_index].includes('bull-b')){
                  is_bull_b = true;
                  var td1 = $($(($(element[0].children).last())[0].children).eq(0))[0]
                  $($(data_1[0].children)[z]).removeClass('bull-b');
                  $($(data_1[0].children)[z]).addClass('bull-l');

                  let ElmH : number =  Number($($(data_1[0].children)[z]).height());
                  let ElmW : number = Number($($(data_1[0].children)[z]).width());
                  let top  = $($(data_1[0].children)[z]).css('top');
                  let left = $($(data_1[0].children)[z]).css('left');
                  if (ElmW > 0){
                    $($(data_1[0].children)[z]).height(ElmW)
                    $($(data_1[0].children)[z]).width(ElmH)
                    $($(data_1[0].children)[z]).css('top', left);
                    $($(data_1[0].children)[z]).css('left', 0);
                    td1.append($(data_1[0].children)[z])
                  }else{
                    td.append($(data_1[0].children)[z])
                  }
                  break;
                }

                //hanger
                 else if ($(data_1[0].children)[z].classList[c_index].includes('hanger-b')){
                  is_hanger_b = true;
                  //var td1 = $($(($(element[0].children).last())[0].children).eq($(($(element[0].children).last())[0].children).length-1))[0]
                  $($(data_1[0].children)[z]).removeClass('hanger-b');
                  $($(data_1[0].children)[z]).addClass('hanger-r');
                  //td1.append($(data_1[0].children)[z])
                  td.append($(data_1[0].children)[z])
                  break;
                }
                else if ($(data_1[0].children)[z].classList[c_index].includes('hanger-t')){
                  is_hanger_t = true;
                  //var td1 = $($(($(element[0].children).last())[0].children).eq($(($(element[0].children).last())[0].children).length-1))[0]
                  $($(data_1[0].children)[z]).removeClass('hanger-t');
                  $($(data_1[0].children)[z]).addClass('hanger-l');
                  //td1.append($(data_1[0].children)[z])
                  td.append($(data_1[0].children)[z])
                  break;
                }

                else if ($(data_1[0].children)[z].classList[c_index].includes('hanger-r')){
                  is_hanger_r = true;
                  var td1 = $($(($(element[0].children).last())[0].children).eq($(($(element[0].children).last())[0].children).length-2))[0]
                  $($(data_1[0].children)[z]).removeClass('hanger-r');
                  $($(data_1[0].children)[z]).addClass('hanger-b');
                  td1.append($(data_1[0].children)[z])
                  //td.append($(data_1[0].children)[z])
                  break;
                }
                else if ($(data_1[0].children)[z].classList[c_index].includes('hanger-l')){
                  is_hanger_l = true;
                  var td1 = $($(($(element[0].children).last())[0].children).eq($(($(element[0].children).last())[0].children).length-2))[0]
                  $($(data_1[0].children)[z]).removeClass('hanger-l');
                  $($(data_1[0].children)[z]).addClass('hanger-t');
                  td1.append($(data_1[0].children)[z])
                  //td.append($(data_1[0].children)[z])
                  break;
                }


                //regal
                else if ($(data_1[0].children)[z].classList[c_index].includes('regal-b')){
                  is_regal_b = true;
                  //var td1 = $($(($(element[0].children).last())[0].children).eq($(($(element[0].children).last())[0].children).length-1))[0]
                  $($(data_1[0].children)[z]).removeClass('regal-b');
                  $($(data_1[0].children)[z]).addClass('regal-r');
                  //td1.append($(data_1[0].children)[z])
                  td.append($(data_1[0].children)[z])
                  break;
                }
                else if ($(data_1[0].children)[z].classList[c_index].includes('regal-t')){
                  is_regal_t = true;
                  //var td1 = $($(($(element[0].children).last())[0].children).eq($(($(element[0].children).last())[0].children).length-1))[0]
                  $($(data_1[0].children)[z]).removeClass('regal-t');
                  $($(data_1[0].children)[z]).addClass('regal-l');
                  //td1.append($(data_1[0].children)[z])
                  td.append($(data_1[0].children)[z])
                  break;
                }

                else if ($(data_1[0].children)[z].classList[c_index].includes('regal-r')){
                  is_regal_r = true;
                  var td1 = $($(($(element[0].children).last())[0].children).eq($(($(element[0].children).last())[0].children).length-2))[0]
                  $($(data_1[0].children)[z]).removeClass('regal-r');
                  $($(data_1[0].children)[z]).addClass('regal-b');
                  td1.append($(data_1[0].children)[z])
                  //td.append($(data_1[0].children)[z])
                  break;
                }
                else if ($(data_1[0].children)[z].classList[c_index].includes('regal-l')){
                  is_regal_l = true;
                  var td1 = $($(($(element[0].children).last())[0].children).eq($(($(element[0].children).last())[0].children).length-2))[0]
                  $($(data_1[0].children)[z]).removeClass('regal-l');
                  $($(data_1[0].children)[z]).addClass('regal-t');
                  td1.append($(data_1[0].children)[z])
                  //td.append($(data_1[0].children)[z])
                  break;
                }

                //chairs2
                else if ($(data_1[0].children)[z].classList[c_index].includes('chairs-2-b')){
                  is_chairs2_b = true;
                  //var td1 = $($(($(element[0].children).last())[0].children).eq($(($(element[0].children).last())[0].children).length-1))[0]
                  let pos = (($(element[0].children).last())[0].children).length  -2  >= 0 ? (($(element[0].children).last())[0].children).length - 2  : 0
                  //console.log("pos=" + pos)
                  //if (pos > 0){
                    var td1 = $($(($(element[0].children).last())[0].children).eq(pos))[0]
                  $($(data_1[0].children)[z]).removeClass('chairs-2-b');
                  $($(data_1[0].children)[z]).addClass('chairs-2-r');
                  td1.append($(data_1[0].children)[z])
                  //td.append($(data_1[0].children)[z])
                  break;
                }
                else if ($(data_1[0].children)[z].classList[c_index].includes('chairs-2-t')){
                  is_chairs2_t = true;
                  //console.log("length=" + $(($(element[0].children).last())[0].children).length + 'index=' + index + ', index2=' + index2)
                  //var td1 = $($(($(element[0].children).last())[0].children).eq($(($(element[0].children).last())[0].children).length-1))[0]
                  let pos = (($(element[0].children).last())[0].children).length  -2  >= 0 ? (($(element[0].children).last())[0].children).length - 2  : 0
                  var td1 = $($(($(element[0].children).last())[0].children).eq(pos))[0]
                  $($(data_1[0].children)[z]).removeClass('chairs-2-t');
                  $($(data_1[0].children)[z]).addClass('chairs-2-l');
                  td1.append($(data_1[0].children)[z])
                  //td.append($(data_1[0].children)[z])
                  break;
                }

                else if ($(data_1[0].children)[z].classList[c_index].includes('chairs-2-r')){
                  is_chairs2_r = true;
                  //var td1 = $($(($(element[0].children).last())[0].children).eq($(($(element[0].children).last())[0].children).length-2))[0]
                  let pos = (($(element[0].children).last())[0].children).length  -4  >= 0 ? (($(element[0].children).last())[0].children).length - 4  : 0
                  var td1 = $($(($(element[0].children).last())[0].children).eq(pos))[0]
                  $($(data_1[0].children)[z]).removeClass('chairs-2-r');
                  $($(data_1[0].children)[z]).addClass('chairs-2-b');
                  td1.append($(data_1[0].children)[z])
                  //td.append($(data_1[0].children)[z])
                  break;
                }
                else if ($(data_1[0].children)[z].classList[c_index].includes('chairs-2-l')){
                  is_chairs2_l = true;
                  //var td1 = $($(($(element[0].children).last())[0].children).eq($(($(element[0].children).last())[0].children).length-2))[0]
                  let pos = (($(element[0].children).last())[0].children).length  -4  >= 0 ? (($(element[0].children).last())[0].children).length - 4  : 0
                  var td1 = $($(($(element[0].children).last())[0].children).eq(pos))[0]

                  $($(data_1[0].children)[z]).removeClass('chairs-2-l');
                  $($(data_1[0].children)[z]).addClass('chairs-2-t');
                  td1.append($(data_1[0].children)[z])
                  //td.append($(data_1[0].children)[z])
                  break;
                }

                //chairs-1
                 else if ($(data_1[0].children)[z].classList[c_index].includes('chairs-1-b')){
                  is_chairs1_b = true;
                  //var td1 = $($(($(element[0].children).last())[0].children).eq($(($(element[0].children).last())[0].children).length-2))[0]
                  let pos = (($(element[0].children).last())[0].children).length  -2  >= 0 ? (($(element[0].children).last())[0].children).length - 2  : 0
                  var td1 = $($(($(element[0].children).last())[0].children).eq(pos))[0]
                  $($(data_1[0].children)[z]).removeClass('chairs-1-b');
                  $($(data_1[0].children)[z]).addClass('chairs-1-l');
                  td1.append($(data_1[0].children)[z])
                  //td.append($(data_1[0].children)[z])
                  break;
                }
                else if ($(data_1[0].children)[z].classList[c_index].includes('chairs-1-t')){
                  is_chairs1_t = true;
                  //var td1 = $($(($(element[0].children).last())[0].children).eq($(($(element[0].children).last())[0].children).length-2))[0]
                  let pos = (($(element[0].children).last())[0].children).length  -2  >= 0 ? (($(element[0].children).last())[0].children).length - 2  : 0
                  var td1 = $($(($(element[0].children).last())[0].children).eq(pos))[0]
                  $($(data_1[0].children)[z]).removeClass('chairs-1-t');
                  $($(data_1[0].children)[z]).addClass('chairs-1-r');
                  td1.append($(data_1[0].children)[z])
                  //td.append($(data_1[0].children)[z])
                  break;
                }

                else if ($(data_1[0].children)[z].classList[c_index].includes('chairs-1-r')){
                  is_chairs1_r = true;
                  //var td1 = $($(($(element[0].children).last())[0].children).eq($(($(element[0].children).last())[0].children).length-6))[0]
                  let pos = (($(element[0].children).last())[0].children).length  -4  >= 0 ? (($(element[0].children).last())[0].children).length - 4  : 0
                  var td1 = $($(($(element[0].children).last())[0].children).eq(pos))[0]
                  $($(data_1[0].children)[z]).removeClass('chairs-1-r');
                  $($(data_1[0].children)[z]).addClass('chairs-1-b');
                  td1.append($(data_1[0].children)[z])
                  //td.append($(data_1[0].children)[z])
                  break;
                }
                else if ($(data_1[0].children)[z].classList[c_index].includes('chairs-1-l')){
                  is_chairs1_l = true;
                  //var td1 = $($(($(element[0].children).last())[0].children).eq($(($(element[0].children).last())[0].children).length-3))[0]
                  let pos = (($(element[0].children).last())[0].children).length  -4  >= 0 ? (($(element[0].children).last())[0].children).length - 4  : 0
                  var td1 = $($(($(element[0].children).last())[0].children).eq(pos))[0]

                  $($(data_1[0].children)[z]).removeClass('chairs-1-l');
                  $($(data_1[0].children)[z]).addClass('chairs-1-t');
                  td1.append($(data_1[0].children)[z])
                  //td.append($(data_1[0].children)[z])
                  break;
                }

              }
            
              if (!is_chairs3 && !is_any_b && !is_any_r && !is_any_l && !is_any_t &&  !is_light_l && !is_light_t && !is_light_r && !is_light_b && !is_volt 
                && !is_hoker_l && !is_hoker_t && !is_hoker_r && !is_hoker_b && !is_wall_1_t && !is_wall_1_l  && !is_wall_1_r && !is_wall_1_b
                && !is_wall_2_t && !is_wall_2_l  && !is_wall_2_r && !is_wall_2_b && !is_bull_t && !is_bull_l  && !is_bull_r && !is_bull_b
                && !is_leaflets_l && !is_leaflets_t && !is_leaflets_r && !is_leaflets_b && !is_any2_b && !is_any2_r && !is_any2_l && !is_any2_t 
                && !is_hanger_b && !is_hanger_r && !is_hanger_l && !is_hanger_t  && !is_regal_b && !is_regal_r && !is_regal_l && !is_regal_t
                && !is_chairs2_b && !is_chairs2_r && !is_chairs2_l && !is_chairs2_t && !is_chairs1_b && !is_chairs1_r && !is_chairs1_l && !is_chairs1_t
              ){
                  //td.append($(data_1[0].children)[z])
                  if ($(data_1[0].children)[z]) {
                    $(data_1[0].children)[z].remove()
                  }
              }
            }
          }
           //$($(element[0].children).last()).append( $('<td>').addClass('stand')); 
          //$($(element[0].children).last()).append( $('<td>').addClass('stand').html($($(tmp[index2])[0].children[index]).html()))  
        }
      }
      //console.log($('#'+stand_ID));
      //console.log(document.getElementById(stand_ID))
  }
}

const standMouseUp = (e : any) => {                                 //FUNCTIONS STANDEDITOR
  
  var stand_ID :string = $(e.currentTarget).attr('id') ?  $(e.currentTarget).attr('id') as string : '';	
  switch (e.which) {
    case 1:
      if (func == 'stand-edit' || func == '') {f_stand_Edit(stand_ID);}   // Edit
      if (func == 'stand-move') {f_stand_Move(stand_ID);}                 // Move
      if (func == 'stand-move-rotate') {f_stand_Move_Rotate(stand_ID);}                 // Move
      if (func == 'stand-rotate') { 
        if ($('#' + 'rotate_type').val() == '0'){
          
          var transform = (document.getElementById(stand_ID) as HTMLElement).style.removeProperty('transform') ;   
          advancedRotateStand(stand_ID);
          

          setFunc('stand-rotate')

          var temp_STAND = $('#'+stand_ID).parent().html();
          //alert(temp_STAND)
          $('#'+stand_ID).parent().removeClass();
          $('#'+stand_ID).parent().html('');
  
          setFuncPut('stand-rotate');
          setFunc('move-temp-stand');
          $('#temp-STAND').html(temp_STAND).show();

          //setFunc('stand-rotate')
          //AdamAdam
         // setFunc('move-temp-stand');
         // f_stand_Move(stand_ID);

          
        }else{
          f_stand_Rotate(stand_ID);
          
          
        }
        
        

        
      }             // Rotate
      
      if (func == 'stand-clone') {f_stand_Clone(stand_ID);}               // Clone
      if (func == 'stand-delete') {f_stand_Delete(stand_ID);}             // Delete
    break
    case 3:
      // Stand Menu
      var scrollLeft : number = $('#sbs-content-scroll')?.scrollLeft() ? $('#sbs-content-scroll')?.scrollLeft() as number : 0
      var scrollTop : number = $('#sbs-content-scroll')?.scrollTop() ? $('#sbs-content-scroll')?.scrollTop() as number : 0
 
      var x = e.pageX - 50 - 120 + scrollLeft;
      var y = e.pageY - 90 + scrollTop;
      
      $('#sbs-context-menu-stand').css({'top': y-30+'px', 'left': x-30+'px'});
      $('#sbs-context-menu-stand').attr('stand_ID', stand_ID);
      //$('#sbs-context-menu-stand').show(); 
      //if (panelWidth == 120) {$('#sbs-table-menu a.stand').click();}
  }
  
};

function f_stand_Edit(stand_ID : string){   
  $(".highlighted").removeClass("highlighted");                                      //FUNCTIONS STANDEDITOR
  setFunc('stand-edit');		
  $('#sbs-panel-stand p.stand-edit').addClass('active');
  // Reset Editor Draw
  f_StandEditorReset();
  // Read
  var stand_CLASS = $('#'+stand_ID).attr('class');
  //var stand_Transform = document.getElementById(stand_ID)?.style.transform;
  
  
  var stand_NAME = $('#'+stand_ID).find('span.stand_NAME').html(); 
  var stand_NR = $('#'+stand_ID).find('span.stand_NR').html(); 
  var stand_FRYZ = $('#'+stand_ID).find('p.stand_FRYZ').html(); 

  var stand_FRYZ_SELECT = $('#'+stand_ID).find('p.stand_FRYZ_SELECT').html(); 
  var stand_SUR = $('#'+stand_ID).find('p.stand_SUR').html(); 
  var stand_COLOR = $('#'+stand_ID).find('p.stand_COLOR').html(); 
  var stand_TEXT = $('#'+stand_ID).find('div.stand_TEXT');  
  var stand_SIZE = $('#'+stand_ID).find('p.stand_SIZE').html(); 
  var stand_ADD_CLIENT = $('#'+stand_ID).find('p.stand_ADD_CLIENT').html(); 
  var stand_ADD_USER = $('#'+stand_ID).find('p.stand_ADD_USER').html(); 

  if ($('#'+stand_ID).find('p.stand_ADD_USER').length==0){
    $('#'+stand_ID).find('.stand_DETAILS').append('<p class="stand_ADD_USER"></p>');
  }
  if ($('#'+stand_ID).find('p.stand_FRYZ_SELECT').length==0){
    $('#'+stand_ID).find('.stand_DETAILS').append('<p class="stand_FRYZ_SELECT"></p>');
  }
  var stand_TEMP = $('#'+stand_ID).html();
  
  
  var select : HTMLSelectElement =  $('#'+'sbs-popup-stand-edit').find('select.stand_ADD_USER')[0] as HTMLSelectElement;
  
  
  for (i = 0; i < select.length; i++){
    var option = select.options[i];
    
    if (option.text==stand_ADD_USER){
      $(option).attr('selected', 'selected');
      break;
    }else{
      $(option).removeAttr('selected');
    }
  }
  
  $(select).prop('selectedIndex', i);
  var select1 : HTMLSelectElement =  $('#'+'sbs-popup-stand-edit').find('select.stand_FRYZ_SELECT')[0] as HTMLSelectElement;
  for (var i = 0; i < select1.length; i++){
    var option = select1.options[i];
    if (option.text==stand_FRYZ_SELECT){
      $(option).attr('selected', 'selected');
      break;
    }else{
      $(option).removeAttr('selected');
    }
  }
  
  var stand_ADD_INFO = $('#'+stand_ID).find('p.stand_ADD_INFO').html(); 

  var stand_W = $('#'+stand_ID).find('tr').eq(0).children('td').length;
  var stand_H = $('#'+stand_ID).find('tr').length;
  // Paste to Editor
  $('#temp-STAND-EDITOR').html(stand_TEMP);
  $('#temp-STAND-EDITOR').attr('class', stand_CLASS as string)
  $('#sbs-popup-stand-edit').attr('stand_ID', stand_ID);
  $('#sbs-popup-stand-edit').find('input.stand_NAME').val(stand_NAME);
  $('#sbs-popup-stand-edit').find('input.stand_NR').val(stand_NR);
  $('#sbs-popup-stand-edit').find('input.stand_FRYZ').val(stand_FRYZ);	


//ADAMEdytor
  //(document.getElementById('temp-STAND-EDITOR') as HTMLElement).style.transform = stand_Transform as string;
  //(document.getElementById('edit-table-editor-relative') as HTMLElement).style.transform = stand_Transform as string;
  
  //$('#sbs-popup-stand-edit').find('select.stand_FRYZ_SELECT').val();		
    // Text position
    $('#sbs-popup-stand-edit').find('select.stand_TEXT_POSITION').val('center');
    if (stand_TEXT.is('.pos-top')) {$('#sbs-popup-stand-edit').find('select.stand_TEXT_POSITION').val('top');}
    if (stand_TEXT.is('.pos-left')) {$('#sbs-popup-stand-edit').find('select.stand_TEXT_POSITION').val('left');}
    if (stand_TEXT.is('.pos-right')) {$('#sbs-popup-stand-edit').find('select.stand_TEXT_POSITION').val('right');}
    if (stand_TEXT.is('.pos-center')) {$('#sbs-popup-stand-edit').find('select.stand_TEXT_POSITION').val('center');}
    if (stand_TEXT.is('.pos-bottom')) {$('#sbs-popup-stand-edit').find('select.stand_TEXT_POSITION').val('bottom');}
    if (stand_TEXT.is('.pos-none')) {$('#sbs-popup-stand-edit').find('select.stand_TEXT_POSITION').val('none');}			
    // Text position
  $('#sbs-popup-stand-edit').find('select.stand_SUR').val(stand_SUR);		
  $('#sbs-popup-stand-edit .stand_DETAILS').find('p.stand_COLOR').html(stand_COLOR);	
  //$('#temp-STAND-EDITOR').css({'background-color': stand_COLOR});	
  $('#sbs-popup-stand-edit').find('.stand_COLOR.form-colors').attr('color', stand_COLOR);	
  $('#sbs-popup-stand-edit').find('.stand_COLOR.form-colors').css({'background-color': stand_COLOR});	
  $('#sbs-popup-stand-edit').find('input.stand_ADD_CLIENT').val(stand_ADD_CLIENT);
  //$('#sbs-popup-stand-edit').find('input.stand_ADD_USER').val(stand_ADD_USER);		
  //$('#sbs-popup-stand-edit').find('textarea.stand_ADD_CLIENT').val(stand_ADD_CLIENT);	
  $('#sbs-popup-stand-edit').find('input.stand_ADD_INFO').val(stand_ADD_INFO);	
  $('#sbs-popup-stand-edit').find('span.stand_SIZE').html(stand_SIZE);	
  $('#sbs-popup-stand-edit').find('span.stand_W').html((stand_W/2).toString());	
  $('#sbs-popup-stand-edit').find('span.stand_H').html((stand_H/2).toString());	

  if ($('#'+stand_ID).is('.free')) {$('#sbs-popup-stand-edit').find('select.stand_STATUS').val('free');}
  if ($('#'+stand_ID).is('.book')) {$('#sbs-popup-stand-edit').find('select.stand_STATUS').val('book');}
  if ($('#'+stand_ID).is('.deal')) {$('#sbs-popup-stand-edit').find('select.stand_STATUS').val('deal');}
  if ($('#'+stand_ID).is('.sold')) {$('#sbs-popup-stand-edit').find('select.stand_STATUS').val('sold');}
  if ($('#'+stand_ID).is('.risk')) {$('#sbs-popup-stand-edit').find('select.stand_STATUS').val('risk');}
  if ($('#'+stand_ID).is('.nbindbook')) {$('#sbs-popup-stand-edit').find('select.stand_STATUS').val('book');}
  if ($('#'+stand_ID).is('.mparticipat')) {$('#sbs-popup-stand-edit').find('select.stand_STATUS').val('mparticipat');}
  
  

  $('#sbs-popup-stand-edit').find('select.stand_O_MAIL_STATUS').val($('#sbs-popup-stand-edit').find('.stand_DETAILS').attr('stand_O_MAIL_STATUS') as string);
  $('#sbs-popup-stand-edit').find('input.stand_O_MAIL').val($('#sbs-popup-stand-edit').find('.stand_DETAILS').attr('stand_O_MAIL') as string);

  // GFX
  if ($('#sbs-popup-stand-edit').find('.stand_DETAILS').attr('gfx_1_checkbox') == 'true') {
    $('#sbs-popup-stand-edit').find('input.gfx_1_checkbox').prop('checked', true);
  } else {
    $('#sbs-popup-stand-edit').find('input.gfx_1_checkbox').prop('checked', false);
  }
  $('#sbs-popup-stand-edit').find('input.gfx_1_count').val($('#sbs-popup-stand-edit').find('.stand_DETAILS').attr('gfx_1_count') as string);
  $('#sbs-popup-stand-edit').find('select.gfx_1_status').val($('#sbs-popup-stand-edit').find('.stand_DETAILS').attr('gfx_1_status') as string);
  $('#sbs-popup-stand-edit').find('input.gfx_1_info').val($('#sbs-popup-stand-edit').find('.stand_DETAILS').attr('gfx_1_info') as string);

  if ($('#sbs-popup-stand-edit').find('.stand_DETAILS').attr('gfx_2_checkbox') == 'true') {
    $('#sbs-popup-stand-edit').find('input.gfx_2_checkbox').prop('checked', true);
  } else {
    $('#sbs-popup-stand-edit').find('input.gfx_2_checkbox').prop('checked', false);
  }
  $('#sbs-popup-stand-edit').find('input.gfx_2_count').val($('#sbs-popup-stand-edit').find('.stand_DETAILS').attr('gfx_2_count') as string);
  $('#sbs-popup-stand-edit').find('select.gfx_2_status').val($('#sbs-popup-stand-edit').find('.stand_DETAILS').attr('gfx_2_status') as string);
  $('#sbs-popup-stand-edit').find('input.gfx_2_info').val($('#sbs-popup-stand-edit').find('.stand_DETAILS').attr('gfx_2_info') as string);

  if ($('#sbs-popup-stand-edit').find('.stand_DETAILS').attr('gfx_3_checkbox') == 'true') {
    $('#sbs-popup-stand-edit').find('input.gfx_3_checkbox').prop('checked', true);
  } else {
    $('#sbs-popup-stand-edit').find('input.gfx_3_checkbox').prop('checked', false);
  }
  $('#sbs-popup-stand-edit').find('input.gfx_3_count').val($('#sbs-popup-stand-edit').find('.stand_DETAILS').attr('gfx_3_count') as string);
  $('#sbs-popup-stand-edit').find('select.gfx_3_status').val($('#sbs-popup-stand-edit').find('.stand_DETAILS').attr('gfx_3_status') as string);
  $('#sbs-popup-stand-edit').find('input.gfx_3_info').val($('#sbs-popup-stand-edit').find('.stand_DETAILS').attr('gfx_3_info') as string);

  if ($('#sbs-popup-stand-edit').find('.stand_DETAILS').attr('gfx_4_checkbox') == 'true') {
    $('#sbs-popup-stand-edit').find('input.gfx_4_checkbox').prop('checked', true);
  } else {
    $('#sbs-popup-stand-edit').find('input.gfx_4_checkbox').prop('checked', false);
  }
  $('#sbs-popup-stand-edit').find('input.gfx_4_count').val($('#sbs-popup-stand-edit').find('.stand_DETAILS').attr('gfx_4_count') as string);
  $('#sbs-popup-stand-edit').find('select.gfx_4_status').val($('#sbs-popup-stand-edit').find('.stand_DETAILS').attr('gfx_4_status') as string);
  $('#sbs-popup-stand-edit').find('input.gfx_4_info').val($('#sbs-popup-stand-edit').find('.stand_DETAILS').attr('gfx_4_info') as string);

  if ($('#sbs-popup-stand-edit').find('.stand_DETAILS').attr('gfx_5_checkbox') == 'true') {
    $('#sbs-popup-stand-edit').find('input.gfx_5_checkbox').prop('checked', true);
  } else {
    $('#sbs-popup-stand-edit').find('input.gfx_5_checkbox').prop('checked', false);
  }
  $('#sbs-popup-stand-edit').find('input.gfx_5_count').val($('#sbs-popup-stand-edit').find('.stand_DETAILS').attr('gfx_5_count') as string);
  $('#sbs-popup-stand-edit').find('select.gfx_5_status').val($('#sbs-popup-stand-edit').find('.stand_DETAILS').attr('gfx_5_status') as string);
  $('#sbs-popup-stand-edit').find('input.gfx_5_info').val($('#sbs-popup-stand-edit').find('.stand_DETAILS').attr('gfx_5_info') as string);

  if ($('#sbs-popup-stand-edit').find('.stand_DETAILS').attr('gfx_6_checkbox') == 'true') {
    $('#sbs-popup-stand-edit').find('input.gfx_6_checkbox').prop('checked', true);
  } else {
    $('#sbs-popup-stand-edit').find('input.gfx_6_checkbox').prop('checked', false);
  }
  $('#sbs-popup-stand-edit').find('input.gfx_6_count').val($('#sbs-popup-stand-edit').find('.stand_DETAILS').attr('gfx_6_count') as string);
  $('#sbs-popup-stand-edit').find('select.gfx_6_status').val($('#sbs-popup-stand-edit').find('.stand_DETAILS').attr('gfx_6_status') as string);
  $('#sbs-popup-stand-edit').find('input.gfx_6_info').val($('#sbs-popup-stand-edit').find('.stand_DETAILS').attr('gfx_6_info') as string);

  if ($('#sbs-popup-stand-edit').find('.stand_DETAILS').attr('gfx_7_checkbox') == 'true') {
    $('#sbs-popup-stand-edit').find('input.gfx_7_checkbox').prop('checked', true);
  } else {
    $('#sbs-popup-stand-edit').find('input.gfx_7_checkbox').prop('checked', false);
  }
  $('#sbs-popup-stand-edit').find('input.gfx_7_count').val($('#sbs-popup-stand-edit').find('.stand_DETAILS').attr('gfx_7_count') as string);
  $('#sbs-popup-stand-edit').find('select.gfx_7_status').val($('#sbs-popup-stand-edit').find('.stand_DETAILS').attr('gfx_7_status') as string);
  $('#sbs-popup-stand-edit').find('input.gfx_7_info').val($('#sbs-popup-stand-edit').find('.stand_DETAILS').attr('gfx_7_info') as string);

  if ($('#sbs-popup-stand-edit').find('.stand_DETAILS').attr('gfx_8_checkbox') == 'true') {
    $('#sbs-popup-stand-edit').find('input.gfx_8_checkbox').prop('checked', true);
  } else {
    $('#sbs-popup-stand-edit').find('input.gfx_8_checkbox').prop('checked', false);
  }
  $('#sbs-popup-stand-edit').find('input.gfx_8_count').val($('#sbs-popup-stand-edit').find('.stand_DETAILS').attr('gfx_8_count') as string);
  $('#sbs-popup-stand-edit').find('select.gfx_8_status').val($('#sbs-popup-stand-edit').find('.stand_DETAILS').attr('gfx_8_status') as string);
  $('#sbs-popup-stand-edit').find('input.gfx_8_info').val($('#sbs-popup-stand-edit').find('.stand_DETAILS').attr('gfx_8_info') as string);
  
  // O
  $('#sbs-popup-stand-edit').find('input.stand_O_NAME').val($('#sbs-popup-stand-edit').find('.stand_DETAILS').attr('stand_O_NAME') as string);
  $('#sbs-popup-stand-edit').find('input.stand_O_TEL').val($('#sbs-popup-stand-edit').find('.stand_DETAILS').attr('stand_O_TEL') as string);
  
  
  $('#sbs_popup_edit_contractor_name').val($('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('stand_Contractor_NAME') as string)
  $('#sbs_popup_edit_contractor_id').val($('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('stand_Contractor_ID') as string)


  setEditContractorName($('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('stand_Contractor_NAME') as string)
  setEditContactName($('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('stand_Contact_NAME') as string)
  contactService.contactsList(Number($('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('stand_Contractor_ID'))).then(resp =>{
    setContactsList(resp)
  }).catch(error => {
    console.log(error)
  })

  $('#sbs_popup_edit_contact_name').val($('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('stand_Contact_NAME') as string)
  $('#sbs_popup_edit_contact_id').val($('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('stand_Contact_ID') as string)


  updateStandEditorEvents();
  
  // Show Popup
  $('#sbs-popup .popup').hide();
  $('#sbs-popup-stand-edit').show();

  $('#sbs-popup-stand-edit .edit-table-left .menu p.tab-info').click();
  $('#sbs-popup').show();
}

// Stand Rotate
function f_stand_Rotate(stand_ID: string){                                          //FUNCTIONS STANDEDITOR
  
  setFuncRotateId(stand_ID);
  $('selector').css('cursor', 'pointer');
  $('#'+stand_ID).addClass('rotate');

  var mouseX = 0;
  var mouseY = 0;
  
  //$('#'+stand_ID).on('mousemove', function(e:any) {
  //   setFunc('stand-to-rotate');
    // setFunc('stand-move-rotate');
  //});

f_stand_Move_Rotate(stand_ID)
  
/*
  $('#'+stand_ID).on('mousewheel', function(e:any) {
    //$('#temp-STAND').on('mousewheel', function(e:any) {
    //alert(';aa')
    e.preventDefault()
    var rot=0
    var transform = this.style.transform ;  
    if (transform==''){
      this.style.transform = 'rotate(' + '0'+ 'deg)' 

    }
    var transform = this.style.transform ;  
    var deg = transform.substring(transform.indexOf('rotate(') + 7, transform.indexOf('deg)'))
    var degInt = parseInt(deg)
    

    var degree = degInt;
    if (e.originalEvent.deltaY>0){
      degree = degree+1
      if (degree > 360){
        degree = degree-360
      }
    }else{
      degree = degree-1
       if (degree < -360){
        degree = degree+360
      } 
    }
     console.log(e.originalEvent.deltaY)
    //console.log(degree)

    this.style.transform = 'rotate(' + degree + 'deg)';

    setFunc('stand-to-rotate');
    // setFunc('stand-move-rotate');
  });	
  */

 //  var temp_STAND = $('#'+stand_ID).parent().html();
  //alert(temp_STAND)
  //$('#'+stand_ID).parent().removeClass();
  //$('#'+stand_ID).parent().html('');
 // setFunc('stand-to-rotate');
  //$('#temp-STAND').html(temp_STAND).show();


}
  
// Stand Move
function f_stand_Move(stand_ID:string){                                       //FUNCTIONS STANDEDITOR
  $('#sbs-panel-stand p.stand-move').addClass('active');
  var temp_STAND = $('#'+stand_ID).parent().html();
  
  
  $('#'+stand_ID).parent().removeClass();
  $('#'+stand_ID).parent().html('');
  
  setFuncPut('stand-move');
  setFunc('move-temp-stand');
  $('#temp-STAND').html(temp_STAND).show();
}

// Stand Move
function f_stand_Move_Rotate(stand_ID:string){   
  //alert('AAA')                                    //FUNCTIONS STANDEDITOR
  //$('#sbs-panel-stand p.stand-move-rotate').addClass('active');
  var temp_STAND = $('#'+stand_ID).parent().html();
  
  
  $('#'+stand_ID).parent().removeClass();
  $('#'+stand_ID).parent().html('');
  
  setFuncPut('stand-rotate');
  setFunc('move-temp-stand');
  $('#temp-STAND').html(temp_STAND).show();
}

// Stand Clone
function f_stand_Clone(stand_ID : string){                                    //FUNCTIONS STANDEDITOR
  $('#sbs-panel-stand p.stand-clone').addClass('active');
  var stand_TEMP = $('#'+stand_ID).html();
  var stand_STYLE : string = $('#'+stand_ID).attr('style') ? $('#'+stand_ID).attr('style') as string : '';
  var stand_COLOR = $('#'+stand_ID).find('p.stand_COLOR').html();
   StandeditorService.clonstand('stand_CLONE', String(stand_TEMP),stand_COLOR).then(response => {
    $('#temp-STAND').html(response.data);
    $('#temp-STAND').find('div.stand').attr('style', stand_STYLE);
    $('#temp-STAND').find('div.stand').addClass('free');
    var stand_NAME = $('#temp-STAND').find('span.stand_NAME').html();
    var standCount = $('#plan_CONTENT div.stand').length+1;
    
    stand_NAME = 'Nowe stoisko';
    
    $('#temp-STAND').find('span.stand_NAME').html(stand_NAME);
    $('#temp-STAND').find('p.stand_FRYZ').html('');
    $('#temp-STAND').find('p.stand_FRYZ_SELECT').html('');
    $('#temp-STAND').find('p.stand_ADD_INFO').html('');
    $('#temp-STAND').find('p.stand_ADD_CLIENT').html('');
    $('#temp-STAND').find('p.stand_ADD_USER').html('');
    $('#temp-STAND').find('span.stand_NR').html(standCount.toString());
    
    $('#temp-STAND').find('div.stand_DETAILS').attr('stand_o_name', '');
    $('#temp-STAND').find('div.stand_DETAILS').attr('stand_o_tel', '');
    $('#temp-STAND').find('div.stand_DETAILS').attr('stand_o_mail', '');

    $('#temp-STAND').find('div.stand_DETAILS').attr('gfx_1_checkbox', '');
    $('#temp-STAND').find('div.stand_DETAILS').attr('gfx_1_count', '');
    $('#temp-STAND').find('div.stand_DETAILS').attr('gfx_1_status', '');
    $('#temp-STAND').find('div.stand_DETAILS').attr('gfx_1_info', '');

    $('#temp-STAND').find('div.stand_DETAILS').attr('gfx_2_checkbox', '');
    $('#temp-STAND').find('div.stand_DETAILS').attr('gfx_2_count', '');
    $('#temp-STAND').find('div.stand_DETAILS').attr('gfx_2_status', '');
    $('#temp-STAND').find('div.stand_DETAILS').attr('gfx_2_info', '');

    $('#temp-STAND').find('div.stand_DETAILS').attr('gfx_3_checkbox', '');
    $('#temp-STAND').find('div.stand_DETAILS').attr('gfx_3_count', '');
    $('#temp-STAND').find('div.stand_DETAILS').attr('gfx_3_status', '');
    $('#temp-STAND').find('div.stand_DETAILS').attr('gfx_3_info', '');

    $('#temp-STAND').find('div.stand_DETAILS').attr('gfx_4_checkbox', '');
    $('#temp-STAND').find('div.stand_DETAILS').attr('gfx_4_count', '');
    $('#temp-STAND').find('div.stand_DETAILS').attr('gfx_4_status', '');
    $('#temp-STAND').find('div.stand_DETAILS').attr('gfx_4_info', '');

    $('#temp-STAND').find('div.stand_DETAILS').attr('gfx_5_checkbox', '');
    $('#temp-STAND').find('div.stand_DETAILS').attr('gfx_5_count', '');
    $('#temp-STAND').find('div.stand_DETAILS').attr('gfx_5_status', '');
    $('#temp-STAND').find('div.stand_DETAILS').attr('gfx_5_info', '');

    $('#temp-STAND').find('div.stand_DETAILS').attr('gfx_6_checkbox', '');
    $('#temp-STAND').find('div.stand_DETAILS').attr('gfx_6_count', '');
    $('#temp-STAND').find('div.stand_DETAILS').attr('gfx_6_status', '');
    $('#temp-STAND').find('div.stand_DETAILS').attr('gfx_6_info', '');

    $('#temp-STAND').find('div.stand_DETAILS').attr('gfx_7_checkbox', '');
    $('#temp-STAND').find('div.stand_DETAILS').attr('gfx_7_count', '');
    $('#temp-STAND').find('div.stand_DETAILS').attr('gfx_7_status', '');
    $('#temp-STAND').find('div.stand_DETAILS').attr('gfx_7_info', '');

    $('#temp-STAND').find('div.stand_DETAILS').attr('gfx_8_checkbox', '');
    $('#temp-STAND').find('div.stand_DETAILS').attr('gfx_8_count', '');
    $('#temp-STAND').find('div.stand_DETAILS').attr('gfx_8_status', '');
    $('#temp-STAND').find('div.stand_DETAILS').attr('gfx_8_info', '');
    
    setFuncPut('stand-clone');
    setFunc('move-temp-stand');
  
    $('#temp-STAND').show();
  }).catch(
      (error) => {
          console.log('send stand status error')
      }
  )
  
}


//if (modifier_id == user?.u_id){   //AdamAdam                                        //FUNCTIONS STANDEDITOR
  $('#plan_CONTENT div.stand').unbind('mouseup');
  $('#plan_CONTENT div.stand').on("mouseup", standMouseUp);
//}




// Edit Stand
$('#sbs-panel-stand p').unbind('click')
$('#sbs-panel-stand p').one('click', editorStandClick.bind(this))
	
// New Stand
$('#dashboard-plans .new-plan').on('click', function() {                  //FUNCTIONS STANDEDITOR
		$('#dashboard-plans').hide();
		$('#dashboard-new-plan').slideDown();
		//AdamTODOo$("#dashboard-new-plan-datepicker").datepicker();
});	

function updateStandClick(){                                             //FUNCTIONS STANDEDITOR
  $('#plan_CONTENT div.stand:not(.bound)').addClass('bound').on("mouseup", function(event, e) {
    var stand_ID = $(e.currentTarget).attr('id');
    switch (event.which) {
      case 1:
        if (func == 'stand-edit' || func == '') {f_stand_Edit(stand_ID as string);}   // Edit
        if (func == 'stand-move') {f_stand_Move(stand_ID as string);}                 // Move
        if (func == 'stand-move-rotate') {f_stand_Move_Rotate(stand_ID as string);}
        if (func == 'stand-to-rotate') {
          f_stand_Rotate(stand_ID as string);
        }          // Rotate  
        if (func == 'stand-clone') {f_stand_Clone(stand_ID as string);}               // Clone
        if (func == 'stand-delete') {f_stand_Delete(stand_ID as string);}             // Delete
      break
      case 3:
        // Stand Menu
        var scrollLeft : number = $('#sbs-content-scroll').scrollLeft() ? $('#sbs-content-scroll').scrollLeft() as number : 0
        var scrollTop : number = $('#sbs-content-scroll').scrollTop() ? $('#sbs-content-scroll').scrollTop() as number : 0

        var x = event.pageX - 50 - 120 + scrollLeft;
        var y = event.pageY - 90 + scrollTop;
        
        $('#sbs-context-menu-stand').css({'top': y-30+'px', 'left': x-30+'px'});
        $('#sbs-context-menu-stand').attr('stand_ID', stand_ID as string);
        //$('#sbs-context-menu-stand').show();
        //if (panelWidth == 120) {$('#sbs-table-menu a.stand').click();}
      }
   });
}

  // Stand New Paste / Move Paste / Clone Paste
  $('#plan_CONTENT td:not(.stand, .is)').unbind('click');                         //FUNCTIONS STANDEDITOR
  $('#plan_CONTENT td:not(.stand)').unbind('click');
	$('#plan_CONTENT td:not(.stand)').on('click', function(e) {
    if (func=='stand-to-rotate'){
      if (func_rotate_id!=''){
      $('#' + func_rotate_id).removeClass('rotate');
      //$('#'+stand_ID).on('mousewheel'
      $('#'+func_rotate_id).unbind('mousewheel');
      $('#'+func_rotate_id).unbind('mousemove');
      //setFunc('stand-rotate')
      //var stand_ID :string = $(e.currentTarget).attr('id') ?  $(e.currentTarget).attr('id') as string : '';	
      //alert(func_rotate_id)
      f_stand_Move_Rotate(func_rotate_id);
      }
    }else if (func=='stand-rotate'){
      if ($('#' + 'rotate_type').val() == '1'){

      }else if ($('#' + 'rotate_type').val() == '2'){

      }else if ($('#' + 'rotate_type').val() == '3'){

      }else{
        //alert('GGG')
        setFunc('stand-to-rotate')
      }
      
    }
		
	});

  function planContentmouseenterEmptyArea(e:any){   
                                    //FUNCTIONS STANDEDITOR
     //   console.log('KKKK')                          
    if (func == 'wall-draw') {
			var plan_COLOR_WALL = $('#sbs-panel-wall .plan_COLOR_WALL').css('background-color');
			//if(isMouseDown) {
				$(e.currentTarget).css({"background-color": plan_COLOR_WALL});
				$(e.currentTarget).removeClass().addClass('wall');
				$('#sbs-table-menu a.save').slideDown();
			//}
		}
		if (func == 'wall-delete') {
				$(e.currentTarget).css({"background-color": ''});
				$(e.currentTarget)
					.html('')
					.removeClass('wall')
					.removeClass('filar')
					.removeClass('exit')
					.removeClass('exit-horizontal')
					.removeClass('wall-okta-t')
					.removeClass('wall-okta-l')
					.removeClass('wall-media')
					.removeClass('exit-vertical');
		}
    var scrollLeft : number = $('#sbs-content-scroll').scrollLeft() ? $('#sbs-content-scroll').scrollLeft() as number : 0
    var scrollTop : number = $('#sbs-content-scroll').scrollTop() ? $('#sbs-content-scroll').scrollTop() as number : 0
		
		if (func == 'wall-exit-arrow') {
			var x = Math.trunc(e.pageX - 50 - 120 + scrollLeft as number);
			var y = Math.trunc(e.pageY - 90 + scrollTop as number);
		
      setFuncEnd('wall-draw-auto-end');
				
      
      setDrawAuto1x(Math.trunc(x/20))
      setDrawAuto1y(Math.trunc(y/20))
			//console.log('GGGGGGG')
			
			//$('#temp-ARROW').css({'margin-left': Math.round(x/20)*20+'px', 'margin-top': Math.round(y/20)*20+'px'});		
      $('#temp-ARROW').css({'margin-left': draw_auto_1_x+'px', 'margin-top': draw_auto_1_y*20+'px'});	
		} else {
			$('#temp-ARROW').hide();	
		}
  }

  function planContentClickEmptyArea(e:any){                              //FUNCTIONS STANDEDITOR
    // Draw
    $(".highlighted").removeClass("highlighted");
    if (func == 'wall-draw') {
			var plan_COLOR_WALL = $('#sbs-panel-wall .plan_COLOR_WALL').css('background-color');
			$(e.currentTarget).css({'background-color': plan_COLOR_WALL});
			$(e.currentTarget).removeClass().addClass('wall');
			$('#sbs-table-menu a.save').slideDown();	
		}
		// Draw Auto
    var scrollLeft : number = $('#sbs-content-scroll').scrollLeft() ? $('#sbs-content-scroll').scrollLeft() as number : 0
    var scrollTop : number = $('#sbs-content-scroll').scrollTop() ? $('#sbs-content-scroll').scrollTop() as number : 0
		if (func == 'wall-draw-auto') {
      //alert('wall-draw-auto')
			var plan_COLOR_WALL = $('#sbs-panel-wall .plan_COLOR_WALL').css('background-color');
      //console.log(plan_COLOR_WALL)
			if (func_end == '') {
        var x = Math.trunc(e.pageX -50 -120 + scrollLeft as number)-1;
	    	var y = Math.trunc(e.pageY -90 + scrollTop as number)-1;
				setFuncEnd('wall-draw-auto-end');
        //console.log('FFFFF')
        //console.log(Math.round(x/20))
        var da1x = Math.trunc(x/20)
        var da1y = Math.trunc(y/20)

        if (Math.trunc(x/20) > 20){
          da1x = Math.trunc(x/20)
        }
         
        setDrawAuto1x(Math.trunc(x/20))
        setDrawAuto1y(Math.trunc(y/20))
        
				$('#plan-temp-draw').css({'width': '20px', 'height': '20px'}).show();
				$('#plan-temp-draw').css({'margin-left': Math.trunc(x/20)*20 +'px', 'margin-top': Math.trunc(y/20)*20+'px'});
			}else {
				var x = Math.trunc(e.pageX - 50 - 120 + scrollLeft as number);
	    	var y = Math.trunc(e.pageY - 90 + scrollTop as number);
        setFuncEnd('');
        setDrawAuto2x(Math.trunc(x/20))
        setDrawAuto2y(Math.trunc(y/20))
				//var tempDrawW = draw_auto_2_x-draw_auto_1_x+1;
				//var tempDrawH = draw_auto_2_y-draw_auto_1_y+1;
        console.log(draw_auto_1_x)
        var tempDrawW = Math.trunc(Math.trunc(x/20)-draw_auto_1_x);
				var tempDrawH = Math.trunc(Math.trunc(y/20)-draw_auto_1_y);
				// Draw W
				if (tempDrawW >= tempDrawH){
					if ($('#input-wall-okta').is(':checked')){
						for(var i:number=draw_auto_1_x;i<=draw_auto_1_x+tempDrawW;i++) {
							$('#plan_CONTENT tr:not(.stand)').eq(draw_auto_1_y).children('td:not(.stand)').eq(i).removeClass('wall-okta-t').addClass('wall-okta-t');
						}
					}else{
						for(i=draw_auto_1_x;i<=draw_auto_1_x+tempDrawW;i++) {    
              console.log(i)    
							$('#plan_CONTENT tr:not(.stand)').eq(draw_auto_1_y).children('td:not(.stand)').eq(i).css({"background-color": plan_COLOR_WALL}).removeClass().addClass('wall');
						}
					}					
				}
				// Draw H
       
				if (tempDrawW < tempDrawH){
					if ($('#input-wall-okta').is(':checked')){   
						for(i=draw_auto_1_y;i<=draw_auto_1_y+tempDrawH;i++) {
							$('#plan_CONTENT tr:not(.stand)').eq(i).children('td:not(.stand)').eq(draw_auto_1_x).removeClass('wall-okta-l').addClass('wall-okta-l');
						}	
					}else{
						for(i=draw_auto_1_y;i<=draw_auto_1_y+tempDrawH;i++) {
              console.log(i)
              console.log(draw_auto_1_x)
							$('#plan_CONTENT tr:not(.stand)').eq(i).children('td:not(.stand)').eq(draw_auto_1_x).css({"background-color": plan_COLOR_WALL}).removeClass().addClass('wall');
						}
					}						
				}
				// Draw One
				if (tempDrawW <= 1 && tempDrawH <= 1) {
					$('#plan_CONTENT tr:not(.stand)').eq(draw_auto_1_y).children('td:not(.stand)').eq(draw_auto_1_x).css({"background-color": plan_COLOR_WALL}).removeClass().addClass('wall');
				}
       
				$('#plan-temp-draw').css({'width': tempDrawW*20+'px'});
				$('#plan-temp-draw').hide();
				$('#sbs-table-menu a.save').slideDown();
			}
		}
		if (func == 'wall-draw-media') {
			if (func_end == '') {
				var x = Math.trunc(e.pageX - 50 - 120 + scrollLeft as number);
	    	    var y = Math.trunc(e.pageY - 90 + scrollTop as number);
           
        setFuncEnd('wall-draw-media-end');
        
        setDrawAuto1x(Math.trunc(x/20))
        setDrawAuto1y(Math.trunc(y/20))
       
				$('#plan-temp-draw').css({'width': '20px', 'height': '20px'}).show();
				$('#plan-temp-draw').css({'margin-left': Math.trunc(x/20)*20+'px', 'margin-top': Math.trunc(y/20)*20+'px'});
			} else {
				var x = Math.trunc(e.pageX - 50 - 120 + scrollLeft as number);
	    	    var y = Math.trunc(e.pageY - 90 + scrollTop as number);
			
        setFuncEnd('');
        setDrawAuto2x(Math.trunc(x/20))
        setDrawAuto2y(Math.trunc(y/20))
					
				var tempDrawW = Math.trunc(x/20)-draw_auto_1_x;
				var tempDrawH = Math.trunc(y/20)-draw_auto_1_y;
				// Draw W
				if (tempDrawW >= tempDrawH){
						for(i=draw_auto_1_x;i<=draw_auto_1_x+tempDrawW;i++) {
							$('#plan_CONTENT tr:not(.stand)').eq(draw_auto_1_y).children('td:not(.stand)').eq(i).removeClass().addClass('wall-media');
						}						
				}
				// Draw H
				if (tempDrawW < tempDrawH){
						for(i=draw_auto_1_y;i<=draw_auto_1_y+tempDrawH;i++) {
							$('#plan_CONTENT tr:not(.stand)').eq(i).children('td:not(.stand)').eq(draw_auto_1_x).removeClass().addClass('wall-media');
						}			
				}
				// Draw One
				if (tempDrawW <= 1 && tempDrawH <= 1) {
					$('#plan_CONTENT tr:not(.stand)').eq(draw_auto_1_y).children('td:not(.stand)').eq(draw_auto_1_x).removeClass().addClass('wall-media');
				}
				
				$('#plan-temp-draw').css({'width': tempDrawW*20+'px'});
				$('#plan-temp-draw').hide();
				$('#sbs-table-menu a.save').slideDown();
			}
		}
		// Exit
		if (func == 'wall-exit') {
			if (func_end == '') {
				var x = Math.trunc(e.pageX - 50 - 120 + scrollLeft as number);
	    	    var y = Math.trunc(e.pageY - 90 + scrollTop as number);
           
        setFuncEnd('wall-draw-auto-end');
        setDrawAuto1x(Math.trunc(x/20))
        setDrawAuto1y(Math.trunc(y/20))
       
				$('#plan-temp-draw').css({'width': '20px', 'height': '20px'}).show();
				$('#plan-temp-draw').css({'margin-left': (Math.trunc(x/20))*20+'px', 'margin-top': Math.trunc(y/20)*20+'px'});
			} else {
				var x = Math.trunc(e.pageX - 50 - 120 + scrollLeft as number);
	    	    var y = Math.trunc(e.pageY - 90 + scrollTop as number);
			
        setFuncEnd('');
        setDrawAuto2x(Math.trunc(x/20))
        setDrawAuto2y(Math.trunc(y/20))
				var tempDrawW = Math.trunc(Math.trunc(x/20)-draw_auto_1_x);
				var tempDrawH = Math.trunc(Math.trunc(y/20)-draw_auto_1_y);
				// Draw Exit W
       
				if (tempDrawW >= tempDrawH){
          
					for(i=draw_auto_1_x;i<=draw_auto_1_x+tempDrawW;i++) {
            //console.log(i)
						$('#plan_CONTENT tr:not(.stand)').eq(draw_auto_1_y).children('td:not(.stand)').eq(i).removeClass().addClass('exit').addClass('exit-horizontal').css({"background-color": ''});
					}				
				}
				// Draw Exit H
				if (tempDrawW < tempDrawH){
					for(i=draw_auto_1_y;i<=draw_auto_1_y+tempDrawH;i++) {
           // console.log(i)
						$('#plan_CONTENT tr:not(.stand)').eq(i).children('td:not(.stand)').eq(draw_auto_1_x).removeClass().addClass('exit').addClass('exit-vertical').css({"background-color": ''});
					}								
				}
				// Draw Exit One
				if (tempDrawW <= 1 && tempDrawH <= 1) {
					$('#plan_CONTENT tr:not(.stand)').eq(draw_auto_1_y).children('td:not(.stand)').eq(draw_auto_1_x).removeClass().addClass('exit').addClass('exit-horizontal').css({"background-color": ''});
				}
				$('#plan-temp-draw').css({'width': tempDrawW*20+'px'}).hide();
				$('#sbs-table-menu a.save').slideDown();
			}	
		}	
		// Exit Arrow
		if (func == 'wall-exit-arrow') {
			var temp_Class = $('#temp-ARROW').attr('class');
			$(e.currentTarget).html('<p class="exit-a '+temp_Class+'"> </p>');
			
			$('#sbs-table-menu a.save').slideDown();
		}			
		// Filar
		if (func == 'wall-filar') {
			var plan_COLOR_WALL = $('#sbs-panel-wall .plan_COLOR_WALL').css('background-color');
			if (!$('#input-filar-w').is(':checked')){
				$(e.currentTarget).css({"background-color": plan_COLOR_WALL});
				$(e.currentTarget).removeClass().addClass('filar');
				$('#sbs-table-menu a.save').slideDown();
			}else{
				$(e.currentTarget).removeClass();
				$(e.currentTarget).html('<p style="background-color: ' + plan_COLOR_WALL + '" class="filar-w"> </p>');
				$('#sbs-table-menu a.save').slideDown();	
			}				
		}
		if (func == 'wall-hydrant') {
			var plan_COLOR_WALL = $('#sbs-panel-wall .plan_COLOR_WALL').css('background-color');
			if (!$('#input-hydrant-w').is(':checked')){
				$(e.currentTarget).css({"background-color": plan_COLOR_WALL});
        $(e.currentTarget).removeClass().addClass('hydrant');
				$('#sbs-table-menu a.save').slideDown();
			}else{
				$(e.currentTarget).css({"background-color": plan_COLOR_WALL});
				$(e.currentTarget).removeClass().addClass('hydrant-w');
				$('#sbs-table-menu a.save').slideDown();
			}				
		}
		if (func == 'wall-bull') {
    
			var plan_COLOR_WALL = $('#sbs-panel-wall .plan_COLOR_WALL').css('background-color');
      
			$(e.currentTarget).html('<p class="s bull-t" />');			
		}
		
		if (func == 'wall-rbt') {
			var plan_COLOR_WALL = $('#sbs-panel-wall .plan_COLOR_WALL').css('background-color');
			if (!$('#input-rbt-w').is(':checked')){
				$(e.currentTarget).css({"background-color": plan_COLOR_WALL});
				$(e.currentTarget).removeClass().addClass('rbt');
				$('#sbs-table-menu a.save').slideDown();
			}else{
				$(e.currentTarget).css({"background-color": plan_COLOR_WALL});
				$(e.currentTarget).removeClass().addClass('rbt-w');
				$('#sbs-table-menu a.save').slideDown();
			}				
		}
		
		if (func == 'custom-text') {
			var tmp = $('#custom_text_input').val();
			var deg = $('#custom_text_degree').val();
			var font = $('#custom_text_font').val();
			if (tmp==''){
				alert('Wprowadź tekst!');
			}else{
				var plan_COLOR_WALL = $('#sbs-panel-wall .plan_COLOR_WALL').css('background-color');
				$(e.currentTarget).removeClass();
				var degree = 'transform: rotate(' + deg + 'deg)';
        var org = 'transform-origin: 0 0';
				$(e.currentTarget).html('<p style="' + org + '; ' + degree + '; font-size:' + font +'px;"  class="custom-text">' + tmp + '</p>');
			}
			$('#sbs-table-menu a.save').slideDown();
		}
		// Delete
		if (func == 'wall-delete') {
			$(e.currentTarget).css({"background-color": ''});
			$(e.currentTarget)
				.html('')
				.removeClass('wall')
				.removeClass('filar')
				.removeClass('exit')
				.removeClass('exit')
				.removeClass('wall-okta-l')
				.removeClass('wall-okta-t')
				.removeClass('exit-horizontal')
				.removeClass('exit-vertical')
				.removeClass('hydrant')
				.removeClass('hydrant-w')
				.removeClass('wall-media')
				.removeClass('rbt')
				.removeClass('rbt-w');
			$('#sbs-table-menu a.save').slideDown();
		}
		// Delete Auto
		if (func == 'wall-delete-auto') {
			if (func_end == '') {
				var x = Math.trunc(e.pageX - 50 - 120 + scrollLeft as number);
	    	    var y = Math.trunc(e.pageY - 90 + scrollTop as number);
			
        setFuncEnd('wall-draw-auto-end');
        setDrawAuto1x(Math.trunc(x/20))
        setDrawAuto1y(Math.trunc(y/20))
				$('#plan-temp-draw').css({'width': '20px', 'height': '20px'});
				$('#plan-temp-draw').show();
				$('#plan-temp-draw').css({'margin-left': Math.trunc(x/20)*20+'px', 'margin-top': Math.trunc(y/20)*20+'px'});
			} else {
				var x = Math.trunc(e.pageX - 50 - 120 + scrollLeft as number);
	    	    var y = Math.trunc(e.pageY - 90 + scrollTop as number);
			
        setFuncEnd('');
        setDrawAuto2x(Math.trunc(x/20))
        setDrawAuto2y(Math.trunc(y/20))
				var tempDrawW = Math.trunc(Math.trunc(x/20)-draw_auto_1_x);
				var tempDrawH = Math.trunc(Math.trunc(y/20)-draw_auto_1_y);
				// Draw W
				if (tempDrawW >= tempDrawH){
					for(i=draw_auto_1_x;i<=draw_auto_1_x+tempDrawW;i++) {
						$('#plan_CONTENT tr:not(.stand)').eq(draw_auto_1_y).children('td:not(.stand)').eq(i).css({"background-color": ''});
						$('#plan_CONTENT tr:not(.stand)').eq(draw_auto_1_y).children('td:not(.stand)').eq(i).removeClass();
					}				
				}
				// Draw H
				if (tempDrawW < tempDrawH){
					for(i=draw_auto_1_y;i<=draw_auto_1_y+tempDrawH;i++) {
						$('#plan_CONTENT tr:not(.stand)').eq(i).children('td:not(.stand)').eq(draw_auto_1_x).css({"background-color": ''});
						$('#plan_CONTENT tr:not(.stand)').eq(i).children('td:not(.stand)').eq(draw_auto_1_x).removeClass();
					}								
				}
				// Draw One
				if (tempDrawW <= 1 && tempDrawH <= 1) {
					$('#plan_CONTENT tr:not(.stand)').eq(draw_auto_1_y).children('td:not(.stand)').eq(draw_auto_1_x).css({"background-color": ''});
					$('#plan_CONTENT tr:not(.stand)').eq(draw_auto_1_y).children('td:not(.stand)').eq(draw_auto_1_x).removeClass();
				}
				
				$('#plan-temp-draw').css({'width': tempDrawW*20+'px'});
				$('#plan-temp-draw').hide();
				$('#sbs-table-menu a.save').slideDown();
			}
		}	

    if (func == 'move-temp-stand') {
      //Adam stand-move clickalert('AA')
      
			setFunc(func_put);
			$('#temp-STAND').children().clone(true,true).appendTo($(e.currentTarget));
			$('#temp-STAND').html('');
			$(e.currentTarget).addClass('is');
			$('#sbs-table-menu a.save').slideDown();
      if (func_rotate_id!='')
        $('#' + func_rotate_id).removeClass('rotate');

      $(e.currentTarget).find( 'div.stand' ).on("mouseup", function(event, e) {
        var stand_ID = $(e.currentTarget).attr('id');
        
        switch (event.which) {
          case 1:
            if ((func.toLowerCase() == 'stand-edit'.toLowerCase()) || (func.toLowerCase() == '')) {f_stand_Edit(stand_ID as string);}     // Edit
            if (func.toLowerCase() == 'stand-move'.toLowerCase()) {f_stand_Move(stand_ID as string);}       // Move
            if (func.toLowerCase() == 'stand-move-rotate'.toLowerCase()) {f_stand_Move_Rotate(stand_ID as string);}       // Move
            if (func.toLowerCase() == 'stand-rotate'.toLowerCase()) {
              f_stand_Rotate(stand_ID as string);
            }   // Rotate   
            if (func.toLowerCase() == 'stand-clone'.toLowerCase()) {f_stand_Clone(stand_ID as string);}     // Clone
            if (func.toLowerCase() == 'stand-delete'.toLowerCase()) {f_stand_Delete(stand_ID as string);}   // Delete
          break
          case 3:
            // Stand Menu
            var scrollLeft : number = $('#sbs-content-scroll').scrollLeft() ? $('#sbs-content-scroll').scrollLeft() as number : 0
            var scrollTop : number = $('#sbs-content-scroll').scrollTop() ? $('#sbs-content-scroll').scrollTop() as number : 0
            
            var x = Math.trunc(event.pageX - 50 - 120 + scrollLeft as number);
                var y = Math.trunc(event.pageY - 90 + scrollTop as number);
            
            $('#sbs-context-menu-stand').css({'top': y-30+'px', 'left': x-30+'px'});
            $('#sbs-context-menu-stand').attr('stand_ID', stand_ID as string);
            //$('#sbs-context-menu-stand').show();
            
          }
        });
			  // Stand Click
			  updateStandClick();
			  f_UpdateList();
		}
    else if (func=='stand-to-rotate'){
      if (func_rotate_id!=''){
        $('#' + func_rotate_id).removeClass('rotate');
        $('#'+func_rotate_id).unbind('mousemove');
      }
      setFunc('stand-rotate')
    }else if (func=='stand-rotate'){
      setFunc('stand-to-rotate')
    }

  }
  // Draw / Filar / Delete 
  $('#plan_CONTENT td:not(.stand, .is)').unbind('mouseenter');
  $('#plan_CONTENT td:not(.stand, .is)').unbind('click');
	$('#plan_CONTENT td:not(.stand, .is)').on('click', planContentClickEmptyArea); 
  //AdamTST$('#plan_CONTENT td').on('click', planContentClickEmptyArea); 
  $('#plan_CONTENT td:not(.stand, .is)').on("mouseenter", planContentmouseenterEmptyArea);



////!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!FUNCTIONS STANDEDITOR!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!///////////////   

/////////////////////////////////////FUNCTIONS STANDEDITOR STAND EDIT/////////////////////////////////////////////////
    //Stand Editor MouseOver
    function tempStandEditorMouseenter(e:any){                  //FUNCTIONS STANDEDITOR STAND EDIT
      // Draw Element Point
      var target = $(e.target);
      var offset : JQuery.Coordinates  = target.offset() ? target.offset() as JQuery.Coordinates : {left:0, top : 0};
      var parentoffset : JQuery.Coordinates  = target.parents("table:first").offset() ? target.parents("table:first").offset() as JQuery.Coordinates : {left:0, top:0}
      var docW = document.body.clientWidth;
      var docH = $( window ).height();
      var  draw_point_x = offset.left-(docW - 900)/2-30;
      var draw_point_y = offset.top-parentoffset.top; 

      if(func_stand == 'draw_point') {
        $('#draw-element').css({'left': draw_point_x+'px', 'top': draw_point_y+'px'});
      }

      // Draw Element Point Auto
      if(func_stand == 'draw_point_auto') {
        $('#draw-element').css({'left': draw_point_x+'px', 'top': draw_point_y+'px'});
      }
    }

    function tempStandEditorStandClick(e:any){                  //FUNCTIONS STANDEDITOR STAND EDIT
       // Draw Element Point
       //Rysowanie zabudowy stoiska
       console.log(func_stand)
       console.log(func_stand_element)
       console.log(func_stand_editor_orient)
       var taget : any = e.currentTarget; 
       if(func_stand == 'draw_point') {
        $(taget).append('<p class="'+func_stand_element+'">&nbsp;</p>');
        $($(taget)[0].childNodes).last().click(deleteEditElement);
      }
      // Draw Element Point
      if(func_stand == 'draw_point_auto') {
        $(taget).append('<p class="'+func_stand_element+'-'+func_stand_editor_orient+'">&nbsp;</p>');
        $($(taget)[0].childNodes).last().click(deleteEditElement);
      }
      e.stopPropagation();
    }

    function tempEditorOrientTopMouseenter(e:any){              //FUNCTIONS STANDEDITOR STAND EDIT
      if(func_stand == 'draw_point_auto' || func_stand == 'draw_auto' && func_stand_auto_step != 2) {
        setFuncStandEditorOrient('t')
        $('#draw-element').removeClass().addClass(func_stand_element+'-'+'t').css({'width': (func_stand_element_w)*20+'px', 'height': (func_stand_element_h)*20+'px'});
      }
      if (func_stand == 'draw_auto') {
        var standWCount = $('#temp-STAND-EDITOR tr').eq(0).children('td.stand').length;
        if  ($('#draw-element').hasClass('bull-t')){
           $('#draw-element').css({'left': '0px', 'top': '0px', 'width': (standWCount+1)*20+'px', 'height': '20px;'}); //top widok przed kliknięciem
        }else{
          $('#draw-element').css({'left': '0px', 'top': '0px', 'width': (standWCount)*20+'px', 'height': '20px;'});
        }
      }
    }
    function tempEditorOrientTopClick(e:any){
      if (func_stand == 'draw_auto') {
        var standWCount = $('#temp-STAND-EDITOR tr').eq(0).children('td.stand').length;
        //$('#temp-STAND-EDITOR table td').eq(0).append('<p class="'+func_stand_element+'-t" style="width: '+standWCount*20+'px; height: '+(func_stand_element_h+1)*20+'px; top: 0px; left: 0px;">&nbsp;</p>');
        if  ($('#draw-element').hasClass('bull-t')){  //top po kliknieciu
          $('#temp-STAND-EDITOR table td').eq(0).append('<p class="'+func_stand_element+'-t" style="width: '+(standWCount+1)*20+'px; height: '+'20px; top: 0px; left: 0px;">&nbsp;</p>');
        }else{ 
          $('#temp-STAND-EDITOR table td').eq(0).append('<p class="'+func_stand_element+'-t" style="width: '+(standWCount)*20+'px; height: '+'20px; top: 0px; left: 0px;">&nbsp;</p>');
         }
      }
    }

    function tempEditorOrientBottomMouseenter(e:any){          //FUNCTIONS STANDEDITOR STAND EDIT
      if(func_stand == 'draw_point_auto' || func_stand == 'draw_auto' && func_stand_auto_step != 2) {
        setFuncStandEditorOrient('b');
        $('#draw-element').removeClass().addClass(func_stand_element+'-'+'b').css({'width': func_stand_element_w*20+'px', 'height': func_stand_element_h*20+'px'});
      }
      if (func_stand == 'draw_auto') {
        var standWCount = $('#temp-STAND-EDITOR tr').eq(0).children('td.stand').length;
        var standHCount : number = $('#temp-STAND-EDITOR tr') ? $('#temp-STAND-EDITOR tr').length as number : 0;
        if  ($('#draw-element').hasClass('bull-b')){//TEST2025
          $('#draw-element').css({'left': '-20px', 'top': (standHCount-1)*20+'px', 'width': (standWCount+1)*20+'px', 'height': '20px;'});
        }else{
          $('#draw-element').css({'left': '0px', 'top': (standHCount-1)*20+'px', 'width': (standWCount)*20+'px', 'height': '20px;'});
        }
      }
    }
    function tempEditorOrientBottomClick(e:any){              //FUNCTIONS STANDEDITOR STAND EDIT
      if (func_stand == 'draw_auto') {
        var standWCount = $('#temp-STAND-EDITOR tr').eq(0).children('td.stand').length;
        var standHCount = $('#temp-STAND-EDITOR tr').length;
        if  ($('#draw-element').hasClass('bull-b')){                                                           //ADAM_TEST
          $('#temp-STAND-EDITOR table td').eq(0).append('<p class="'+func_stand_element+'-b" style="width: '+(standWCount+1)*20+'px; height: '+func_stand_element_h*20+'px; top: '+(standHCount-1)*20+'px; left: -20px;">&nbsp;</p>');
        }else{
          $('#temp-STAND-EDITOR table td').eq(0).append('<p class="'+func_stand_element+'-b" style="width: '+(standWCount)*20+'px; height: '+func_stand_element_h*20+'px; top: '+(standHCount-1)*20+'px; left: 0px;">&nbsp;</p>');
        }
      }
    }

    function tempEditorOrientLeftMouseenter(e:any){          //FUNCTIONS STANDEDITOR STAND EDIT
      if(func_stand == 'draw_point_auto' || func_stand == 'draw_auto' && func_stand_auto_step != 2) {
        setFuncStandEditorOrient('l');
        $('#draw-element').removeClass().addClass(func_stand_element+'-'+'l').css({'width': func_stand_element_h*20+'px', 'height': func_stand_element_w*20+'px'});
      }
      if (func_stand == 'draw_auto') {
        var standHCount = $('#temp-STAND-EDITOR tr').length;
        if  ($('#draw-element').hasClass('bull-l')){
          $('#draw-element').css({'left': '0px', 'top': '-20px', 'width': '20px', 'height': (standHCount+1)*20+'px'});
        }else{
          $('#draw-element').css({'left': '0px', 'top': '0px', 'width': '20px', 'height': (standHCount)*20+'px'});
        }
      }
    }

    function tempEditorOrientLeftClick(e:any){              //FUNCTIONS STANDEDITOR STAND EDIT
      if (func_stand == 'draw_auto') {
        var standHCount = $('#temp-STAND-EDITOR tr').length;
          if  ($('#draw-element').hasClass('bull-l')){
            $('#temp-STAND-EDITOR table td').eq(0).append('<p class="'+func_stand_element+'-l" style="width: 20px; height: '+(standHCount+1)*20+'px; top: -20px; left: 0px;">&nbsp;</p>');
          }else{
            $('#temp-STAND-EDITOR table td').eq(0).append('<p class="'+func_stand_element+'-l" style="width: 20px; height: '+standHCount*20+'px; top: 0px; left: 0px;">&nbsp;</p>');
          }
        }
    }

    function tempEditorOrientRightMouseenter(e:any){        //FUNCTIONS STANDEDITOR STAND EDIT
      if(func_stand == 'draw_point_auto' || func_stand == 'draw_auto' && func_stand_auto_step != 2) {
        setFuncStandEditorOrient('r');
        $('#draw-element').removeClass().addClass(func_stand_element+'-'+'r').css({'width': func_stand_element_h*20+'px', 'height': func_stand_element_w*20+'px'});
      }
      if (func_stand == 'draw_auto') {
        var standWCount : number = $('#temp-STAND-EDITOR tr').eq(0).children('td.stand') ?  $('#temp-STAND-EDITOR tr').eq(0).children('td.stand').length as number : 0;
        var standHCount = $('#temp-STAND-EDITOR tr').length;
        if  ($('#draw-element').hasClass('bull-r')){
          $('#draw-element').css({'left': (standWCount-1)*20+'px', 'top': '0px', 'width': '20px', 'height': (standHCount+1)*20+'px'});
        }else{
          $('#draw-element').css({'left': (standWCount-1)*20+'px', 'top': '0px', 'width': '20px', 'height': (standHCount)*20+'px'});
        }
      }
    }
    function tempEditorOrientRightClick(e:any){           //FUNCTIONS STANDEDITOR STAND EDIT
      if (func_stand == 'draw_auto') {
        var standWCount : number = $('#temp-STAND-EDITOR tr').eq(0).children('td.stand') ?  $('#temp-STAND-EDITOR tr').eq(0).children('td.stand').length as number : 0;
        var standHCount = $('#temp-STAND-EDITOR tr').length;
        if  ($('#draw-element').hasClass('bull-r')){
          $('#temp-STAND-EDITOR table td').eq(0).append('<p class="'+func_stand_element+'-r" style="width: 20px; height: '+(standHCount+1)*20+'px; top: 0px; left: '+(standWCount-1)*20+'px;">&nbsp;</p>');
        }else{
          $('#temp-STAND-EDITOR table td').eq(0).append('<p class="'+func_stand_element+'-r" style="width: 20px; height: '+standHCount*20+'px; top: 0px; left: '+(standWCount-1)*20+'px;">&nbsp;</p>');
        }
        }
    }

    function tempStandEditorClick(e:any){                 //FUNCTIONS STANDEDITOR STAND EDIT
      var stand_O_MAIL_STATUS : string = $('#sbs-popup-stand-edit select.stand_O_MAIL_STATUS').val() as string;
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('stand_O_MAIL_STATUS',stand_O_MAIL_STATUS);
      var stand_O_MAIL : string = $('#sbs-popup-stand-edit input.stand_O_MAIL').val() as string;
      
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('gfx_1_checkbox',$('#sbs-popup-stand-edit').find('input.gfx_1_checkbox').prop('checked'));
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('gfx_1_count',$('#sbs-popup-stand-edit').find('input.gfx_1_count').val() as string);
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('gfx_1_status',$('#sbs-popup-stand-edit').find('select.gfx_1_status').val() as string);
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('gfx_1_info',$('#sbs-popup-stand-edit').find('input.gfx_1_info').val() as string);
  
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('gfx_2_checkbox',$('#sbs-popup-stand-edit').find('input.gfx_2_checkbox').prop('checked'));
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('gfx_2_count',$('#sbs-popup-stand-edit').find('input.gfx_2_count').val() as string);
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('gfx_2_status',$('#sbs-popup-stand-edit').find('select.gfx_2_status').val() as string);
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('gfx_2_info',$('#sbs-popup-stand-edit').find('input.gfx_2_info').val() as string);
  
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('gfx_3_checkbox',$('#sbs-popup-stand-edit').find('input.gfx_3_checkbox').prop('checked'));
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('gfx_3_count',$('#sbs-popup-stand-edit').find('input.gfx_3_count').val() as string);
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('gfx_3_status',$('#sbs-popup-stand-edit').find('select.gfx_3_status').val() as string);
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('gfx_3_info',$('#sbs-popup-stand-edit').find('input.gfx_3_info').val() as string);
  
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('gfx_4_checkbox',$('#sbs-popup-stand-edit').find('input.gfx_4_checkbox').prop('checked'));
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('gfx_4_count',$('#sbs-popup-stand-edit').find('input.gfx_4_count').val() as string);
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('gfx_4_status',$('#sbs-popup-stand-edit').find('select.gfx_4_status').val() as string);
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('gfx_4_info',$('#sbs-popup-stand-edit').find('input.gfx_4_info').val() as string);
  
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('gfx_5_checkbox',$('#sbs-popup-stand-edit').find('input.gfx_5_checkbox').prop('checked'));
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('gfx_5_count',$('#sbs-popup-stand-edit').find('input.gfx_5_count').val() as string);
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('gfx_5_status',$('#sbs-popup-stand-edit').find('select.gfx_5_status').val() as string);
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('gfx_5_info',$('#sbs-popup-stand-edit').find('input.gfx_5_info').val() as string);
  
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('gfx_6_checkbox',$('#sbs-popup-stand-edit').find('input.gfx_6_checkbox').prop('checked'));
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('gfx_6_count',$('#sbs-popup-stand-edit').find('input.gfx_6_count').val() as string);
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('gfx_6_status',$('#sbs-popup-stand-edit').find('select.gfx_6_status').val() as string);
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('gfx_6_info',$('#sbs-popup-stand-edit').find('input.gfx_6_info').val() as string);
  
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('gfx_7_checkbox',$('#sbs-popup-stand-edit').find('input.gfx_7_checkbox').prop('checked'));
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('gfx_7_count',$('#sbs-popup-stand-edit').find('input.gfx_7_count').val() as string);
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('gfx_7_status',$('#sbs-popup-stand-edit').find('select.gfx_7_status').val() as string);
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('gfx_7_info',$('#sbs-popup-stand-edit').find('input.gfx_7_info').val() as string);
  
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('gfx_8_checkbox',$('#sbs-popup-stand-edit').find('input.gfx_8_checkbox').prop('checked'));
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('gfx_8_count',$('#sbs-popup-stand-edit').find('input.gfx_8_count').val() as string);
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('gfx_8_status',$('#sbs-popup-stand-edit').find('select.gfx_8_status').val() as string);
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('gfx_8_info',$('#sbs-popup-stand-edit').find('input.gfx_8_info').val() as string);
      
      
  
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('stand_O_NAME',$('#sbs-popup-stand-edit').find('input.stand_O_NAME').val() as string);
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('stand_O_TEL',$('#sbs-popup-stand-edit').find('input.stand_O_TEL').val() as string);
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('stand_O_MAIL',stand_O_MAIL);
  
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('stand_Contractor_NAME', $('#sbs_popup_edit_contractor_name').val() as string)
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('stand_Contractor_ID', $('#sbs_popup_edit_contractor_id').val() as string)

      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('stand_Contact_NAME', $('#sbs_popup_edit_contact_name').val() as string)
      $('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('stand_Contact_ID', $('#sbs_popup_edit_contact_id').val() as string)


      var stand_ID = $('#sbs-popup-stand-edit').attr('stand_ID');
      var stand_NAME = $('#sbs-popup-stand-edit input.stand_NAME').val();
      var stand_NR = $('#sbs-popup-stand-edit input.stand_NR').val();
      var stand_STATUS = $('#sbs-popup-stand-edit select.stand_STATUS').val();
      var stand_TEMP_EDITOR = $('#temp-STAND-EDITOR').html();
      var stand_TEMP_COLOR = $('#temp-STAND-EDITOR').find('p.stand_COLOR').html();
          
      var tempStatus = '';
      if ($('#'+stand_ID).is('.free')) {tempStatus = 'free';}
      if ($('#'+stand_ID).is('.book')) {tempStatus = 'book';}
      if ($('#'+stand_ID).is('.nbindbook')) {tempStatus = 'nbindbook';}
  
      if(stand_STATUS == 'free') {stand_O_MAIL = 'c';}
  
      if(stand_NAME == '') {
        alert('Uzupełnij pola obowiązkowe!');
      }
      else {
        if (sendMail == true) {
          if (tempStatus != stand_STATUS) {	
            if (stand_STATUS != '') {		
              StandeditorService.standstatusupdate('stand_STATUS_UPDATE', String(stand_STATUS), $('#sbs-table-menu').find('p.email').html(),
                                                  plan_id,  $('#plan-preview').find('p.plan_NAME').html(), String(stand_NR),  String(stand_NAME)).then(response => {
                  console.log('send stand status')
          
              }).catch(
                (error) => {
                  console.log('send stand status error')
                }
              )
            
            }
          }
        }
        
        $('#'+stand_ID).html(stand_TEMP_EDITOR)
        $('#'+stand_ID).css({'background-color': stand_TEMP_COLOR});
        $('#'+stand_ID).removeClass().addClass('stand').addClass(stand_TEMP_COLOR.replace('#', 'color-'));
        
        $('#'+stand_ID).addClass(stand_STATUS as string);

        $('#'+stand_ID).removeClass('ti_tosending');
        $('#'+stand_ID).removeClass('ti_sent');
        $('#'+stand_ID).removeClass('ti_received');
        $('#'+stand_ID).removeClass('ti_phoneconfirm');
        $('#'+stand_ID).removeClass('ti_mailconfirm');

        if (stand_O_MAIL_STATUS=="1"){
          $('#'+stand_ID).addClass('ti_tosending');
        }else if (stand_O_MAIL_STATUS=="2"){
          $('#'+stand_ID).addClass('ti_sent');
        }else if (stand_O_MAIL_STATUS=="3"){
          $('#'+stand_ID).addClass('ti_received');
        }else if (stand_O_MAIL_STATUS=="4"){
          $('#'+stand_ID).addClass('ti_phoneconfirm');
        }else if (stand_O_MAIL_STATUS=="5"){
          $('#'+stand_ID).addClass('ti_mailconfirm');
        }
        
        f_UpdateList();
        f_UpdateLegend();
        $('#sbs-popup').hide();
        $('#sbs-table-menu a.savesave').slideDown();
        //func == 'stand-edit';
        f_PlanSave(0)
      }
    }

     // Stand Editor Change Color
     $('#sbs-popup-stand-edit .sbs-popup-colors-stand p.color').unbind('click');
    $('#sbs-popup-stand-edit .sbs-popup-colors-stand p.color').on('click', function() {
       
       var stand_COLOR = $(this).find('span').html();
      // console.log(stand_COLOR)
       //console.log(stand_COLOR)
      // $('#temp-STAND-EDITOR tr.stand').css({'background-color': stand_COLOR});
      // $('#temp-STAND-EDITOR').removeClass().addClass('stand').addClass(stand_COLOR.replace('#', 'color-'));
       //$('#temp-STAND-EDITOR').find('p.stand_COLOR').html(stand_COLOR);//AdamAdam
      // $('#temp-STAND-EDITOR').find('p.stand_COLOR').css({'background-color': stand_COLOR});
      // console.log($('#temp-STAND-EDITOR').find('p.stand_COLOR'))
     });
     
   function changeColorClick(e:any){
       
    var stand_COLOR = $(e.currentTarget).find('span').html();
    $('#temp-STAND-EDITOR tr.stand').css({'background-color': stand_COLOR});
    $('#temp-STAND-EDITOR').removeClass().addClass('stand').addClass(stand_COLOR.replace('#', 'color-'));
    $('#temp-STAND-EDITOR').find('p.stand_COLOR').html(stand_COLOR);
    $('#temp-STAND-EDITOR').find('p.stand_COLOR').css({'background-color': stand_COLOR});
    //$('#temp-STAND-EDITOR').find('p.stand_COLOR').css({'color': stand_COLOR});
    $('#sbs-popup-stand-edit').find('p.stand_COLOR').css({'background-color': stand_COLOR});
  }

    function updateStandEditorEvents(){                  //FUNCTIONS STANDEDITOR STAND EDIT

      
      // Stand Send Mail
      $('#sendStandMail').unbind('click');
      $('#sendStandMail').on('click', function(e) {
        
        var temp_sendStandMail = $('#sendStandMail').closest('table').find('.stand_O_MAIL').val();
        var stand_ID = $('#sbs-popup-stand-edit').attr('stand_ID');
        var plan_ID = $('#plan-preview-detail').find('p.plan_ID').html();
        

        //var downloadLink = 'http://planner6d.pl ?download=d%26id='+plan_ID+'%26v=kt%26s='+stand_ID+'';
        var downloadLink = StandeditorService.getBaseURL() + 'plans/tcardview/' + plan_ID + '?download=d&v=kt&s='+stand_ID ;
        
        if(temp_sendStandMail == ''){
          e.preventDefault();
          alert('Uzupełnij pole e-mail!');
        }

        else{
          $('.stand_O_MAIL_STATUS').val('2');
          $(this).attr('href', 'mailto:'+temp_sendStandMail+'?subject=Odbierz swoją Kartę Wystawcy! Expoproperty&body=Witaj '+temp_sendStandMail+'!%0D%0A%0D%0AKliknij w poniższy link, aby pobrać swoją Kartę Techniczną Wystawcy.%0D%0A%0D%0A'+downloadLink+'%0D%0A%0D%0APozdrawiamy!%0D%0AZespół Expoproperty');
          f_PlanSave(0);
          $('#sbs-popup-stand-edit a.editor-update').click();
        }

      });
      
      

      // Stand Editor Change Text Position
      $('#sbs-popup-stand-edit select.stand_TEXT_POSITION').unbind('change');
      $('#sbs-popup-stand-edit select.stand_TEXT_POSITION').on('change', function() {
        $('#temp-STAND-EDITOR').find('div.stand_TEXT').removeClass().addClass('stand_TEXT').addClass('pos-'+$(this).val());
        
        if ($(this).val() == 'left' || $(this).val() == 'right') {
          var tempHeight80 = parseInt(String(Number($('#temp-STAND-EDITOR table')?.height())*0.8+1));
          var tempWidth80 = parseInt(String(Number($('#temp-STAND-EDITOR table')?.width())*0.8+1));
          
          if (tempHeight80<tempWidth80) {
            $('#temp-STAND-EDITOR').find('p.stand_NAME').css({'max-width': tempHeight80+'px'});
            $('#temp-STAND-EDITOR').find('p.stand_ADD_INFO').css({'width': tempHeight80+'px'});
          } else {
            $('#temp-STAND-EDITOR').find('p.stand_NAME').css({'max-width': tempWidth80+'px'});
            $('#temp-STAND-EDITOR').find('p.stand_ADD_INFO').css({'width': tempWidth80+'px'});				
          }
        } else {
          $('#temp-STAND-EDITOR').find('p.stand_NAME').css({'max-width': ''});
          $('#temp-STAND-EDITOR').find('p.stand_ADD_INFO').css({'width': ''});
        }
      });


      // Stand Editor Change Sur
      $('#sbs-popup-stand-edit select.stand_SUR').unbind('change')
      $('#sbs-popup-stand-edit select.stand_SUR').on('change', function() {
        $('#temp-STAND-EDITOR p.stand_SUR').html($(this).val() as string);
        
        if($(this).val() == 'Niezabudowana') {
          $('#temp-STAND-EDITOR tr.stand').css({'background-color': '#f1f1f2'});
          $('#temp-STAND-EDITOR').find('p.stand_COLOR').html('#f1f1f2');
          $('#sbs-popup-stand-edit p.stand_COLOR').attr('color', '#f1f1f2').css({'background-color': '#f1f1f2'});
        }
      });
      // Stand Editor Change Text Position
      $('#sbs-popup-stand-edit select.stand_STATUS').unbind('change');
      $('#sbs-popup-stand-edit select.stand_STATUS').on('change', function() {
        if($(this).val() == 'free') {
          $('#sbs-popup-stand-edit input.stand_O_NAME').val('');
          $('#sbs-popup-stand-edit input.stand_O_TEL').val('');
          $('#sbs-popup-stand-edit input.stand_O_MAIL').val('');
        }
      });

      // Stand Editor Change Text Position
      $('#sbs-popup-stand-edit select.stand_STATUS').unbind('change');
      $('#sbs-popup-stand-edit select.stand_STATUS').on('change', function() {
        function zeroWiodace(i: number) {
              return (i < 10)? '0'+String(i) : String(i);
          }
        
        var stand_ID = $('#sbs-popup-stand-edit').attr('stand_ID');
        var stand_STATUS_DATA = new Date();
        $('#'+stand_ID).attr('status_data', stand_STATUS_DATA.getFullYear()+zeroWiodace((stand_STATUS_DATA.getMonth()+1))+zeroWiodace(stand_STATUS_DATA.getDate())+'');
      });

     
      // Stand Editor Change Name
      $('#sbs-popup-stand-edit input.stand_NAME').unbind('input');
      $('#sbs-popup-stand-edit input.stand_NAME').on('input', function() {
        $('#temp-STAND-EDITOR span.stand_NAME').html(String($(this).val()));
       

      });

      // Stand Editor Change Nr
      $('#sbs-popup-stand-edit input.stand_NR').unbind('input')
      $('#sbs-popup-stand-edit input.stand_NR').on('input', function() {
        if ($(this).val() == '') {
          $('#temp-STAND-EDITOR span.stand_NR_L').html(String($(this).val()));
          $('#temp-STAND-EDITOR span.stand_NR').html(String($(this).val()));
          $('#temp-STAND-EDITOR span.stand_NR_R').html(String($(this).val()));
        } else {
          $('#temp-STAND-EDITOR span.stand_NR_L').html('[');
          $('#temp-STAND-EDITOR span.stand_NR').html(String($(this).val()));
          $('#temp-STAND-EDITOR span.stand_NR_R').html(']');
        }
      });

      // Stand Editor Change Add Info
      $('#sbs-popup-stand-edit input.stand_ADD_INFO').unbind('input');
      $('#sbs-popup-stand-edit input.stand_ADD_INFO').on('input', function() {
        $('#temp-STAND-EDITOR p.stand_ADD_INFO').html(String($(this).val()));
      });
      
      // Stand Editor Change Add Info
      $('#sbs-popup-stand-edit input.stand_ADD_CLIENT').unbind('input');
      $('#sbs-popup-stand-edit input.stand_ADD_CLIENT').on('input', function() {
        $('#temp-STAND-EDITOR p.stand_ADD_CLIENT').html(String($(this).val()));
      });

      // Stand Editor Change Fryz
      $('#sbs-popup-stand-edit input.stand_FRYZ').unbind('input');
      $('#sbs-popup-stand-edit input.stand_FRYZ').on('input', function() {
        $('#temp-STAND-EDITOR p.stand_FRYZ').html(String($(this).val()));
      });
      
      // Stand Editor Change Add Fryz select
      $('#sbs-popup-stand-edit select.stand_FRYZ_SELECT').unbind('change');
      $('#sbs-popup-stand-edit select.stand_FRYZ_SELECT').on('change', function() {
        $('#temp-STAND-EDITOR p.stand_FRYZ_SELECT').html($(this).find('option:selected').text());
      });



      // Stand Editor Change Add Client Info
      $('#sbs-popup-stand-edit select.stand_ADD_USER').unbind('change');
      $('#sbs-popup-stand-edit select.stand_ADD_USER').on('change', function() {

        $('#temp-STAND-EDITOR p.stand_ADD_USER').html($(this).find('option:selected').text());
		    $('#temp-STAND-EDITOR p.stand_NAME').css('background-color', String($(this).val()));
      });
      // Stand Editor MouseOver
      $('#temp-STAND-EDITOR td').unbind('mouseenter')
      $('#temp-STAND-EDITOR td').on('mouseenter', tempStandEditorMouseenter);
      // Stand Editor Click
      $('#temp-STAND-EDITOR td.stand').unbind('click');
      $('#temp-STAND-EDITOR td.stand').on('click', tempStandEditorStandClick);
          
      // Stand Edit Click Element
      $('#sbs-popup-stand-edit .element.bound').unbind('click');
      $('#sbs-popup-stand-edit .element:not(.bound)').addClass('bound');  
      $('#sbs-popup-stand-edit .element.bound').click(editElementClick);
    
      // Stand Editor Orient
      $('#editor-orient-top').unbind('mouseenter')
      $('#editor-orient-top').on('mouseenter', tempEditorOrientTopMouseenter)
      $('#editor-orient-top').unbind('click')
      $('#editor-orient-top').on('click', tempEditorOrientTopClick) 

      $('#editor-orient-bottom').unbind('mouseenter')
      $('#editor-orient-bottom').on('mouseenter', tempEditorOrientBottomMouseenter)
      $('#editor-orient-bottom').unbind('click')
      $('#editor-orient-bottom').on('click', tempEditorOrientBottomClick) 

      $('#editor-orient-left').unbind('mouseenter')
      $('#editor-orient-left').on('mouseenter', tempEditorOrientLeftMouseenter)
      $('#editor-orient-left').unbind('click')
      $('#editor-orient-left').on('click', tempEditorOrientLeftClick) 

      $('#editor-orient-right').unbind('mouseenter')
      $('#editor-orient-right').on('mouseenter', tempEditorOrientRightMouseenter)
      $('#editor-orient-right').unbind('click')
      $('#editor-orient-right').on('click', tempEditorOrientRightClick) 

      // Colors
     // console.log('GGGGGG')
     // console.log( $('.form-colors'))
      $('.form-colors').unbind('click')
      $('.form-colors').on('click', function() {
        $(this).parent().find('.sbs-popup-colors').show();
      });	
    
      $('.sbs-popup-colors').unbind('mouseleave')
      $('.sbs-popup-colors').on('mouseleave', function() {
        $(this).parent().find('.sbs-popup-colors').hide();
      });	
      
      $('.sbs-popup-colors p.color').unbind('click')
      $('.sbs-popup-colors p.color').on('click', function() {  
        
        $(this).parent().parent().find('.form-colors').attr('color', $(this).children('span').html()).css({'background-color': $(this).children('span').html()});
        $(this).parent().hide();
      });	
    
      // Stand Edit Update
      $('#sbs-popup-stand-edit a.editor-update').unbind('click');
      $('#sbs-popup-stand-edit a.editor-update').on('click', tempStandEditorClick);   
    }

    function senderBindParentElementClick(e:any){
      // Draw Element Point
      if(func_stand == 'draw_point') {
        $(e.currentTarget).append('<p class="'+func_stand_element+'">&nbsp;</p>');
        $($(e.currentTarget)[0].childNodes).last().click(deleteEditElement);
      }
      // Draw Element Point
      if(func_stand == 'draw_point_auto') {
        $(e.currentTarget).append('<p class="'+func_stand_element+'-'+func_stand_editor_orient+'">&nbsp;</p>');
        $($(e.currentTarget)[0].childNodes).last().click(deleteEditElement);
      }
      e.stopPropagation();
    }

    function deleteEditElement(e:any)                                   //FUNCTIONS STANDEDITOR STAND EDIT
    {

      //alert('delete')
      console.log(e.currentTarget)
      $(e.currentTarget).remove();	
        $($(e.currentTarget)[0].parentElement).on('click', senderBindParentElementClick);
       	
    };

    // Stand Edit Draw Element Point Auto
    function f_StandElementDrawPointAuto(element_group: string, element: string, element_w: number , element_h: number ){
     
      setFuncStand('draw_point_auto');
      setFuncStandElement(element_group+' '+element);
      setFuncStandElementW(element_w);
      setFuncStandElementH(element_h);
      
      setFuncStandEditorOrient('t');
      updateStandEditorEvents();
      $('#draw-element').removeClass().addClass(element_group+' '+element+'-'+'t').show().css({'width': element_w*20+'px', 'height': element_h*20+'px'});
    }

    // Stand Edit Draw Element Auto
    function f_StandElementDrawAuto(element_group: string, element: string, element_w: number, element_h: number){
      setFuncStand('draw_auto');
      setFuncStandElement(element_group+' '+element);
      setFuncStandElementW(element_w);
      setFuncStandElementH(element_h);
      setFuncStandEditorOrient('t');
      setFuncStandAutoStepmouse(1)

      $('#draw-element').removeClass().addClass(element_group+' '+element+'-'+'t').show().css({'width': element_w*20+'px', 'height': element_h*20+'px'});
      $('#editor-scroll .edit-table-editor').addClass('auto');
    }

    function f_StandElementDeletePoint(){                                   //FUNCTIONS STANDEDITOR STAND EDIT
      setFuncStand('delete');
      $('#temp-STAND-EDITOR').addClass('delete');
      $('#temp-STAND-EDITOR.delete table td p').click(deleteEditElement); 
    }

    
  
    // Stand Edit Delete Element
    function f_StandElementDeleteAll(element_group: string){
      $('#temp-STAND-EDITOR table td p.'+element_group).each(function(index, element) {
              $(this).remove();
          });
      f_StandEditorReset();
    }
    // Stand Edit Draw Element Point
    function f_StandElementDrawPoint(element_group: string, element: string, element_w: number, element_h: number){
      setFuncStand('draw_point');
      setFuncStandElement(element_group+' '+element);
      $('#draw-element').removeClass().addClass(element_group+' '+element).show().css({'width': element_w*20+'px', 'height': element_h*20+'px'});
    }

    // Plan Click
	$('#plan_CONTENT td:not(.stand, .is)').on('mouseup', function(event, e) {
		if (func == 'wall-exit-arrow') {
			switch (event.which) {
				case 3:
					var temp_dir = 'top';
					
					if ($('#temp-ARROW').is('.exit-a-t')) {temp_dir = 'exit-a-l';}
					if ($('#temp-ARROW').is('.exit-a-b')) {temp_dir = 'exit-a-r';}
					if ($('#temp-ARROW').is('.exit-a-l')) {temp_dir = 'exit-a-b';}
					if ($('#temp-ARROW').is('.exit-a-r')) {temp_dir = 'exit-a-t';}
					
					$('#temp-ARROW').removeClass().addClass(temp_dir);
				}
		}		
	});

    function editElementClick(e:  any) {                            //FUNCTIONS STANDEDITOR STAND EDIT
      /* handling automatic draw menu */
      var ss = e.currentTarget as Element
      
      var hasAuto = $(ss).hasClass('automatic-possibility');

      $('#sbs-popup-stand-edit .items-menu .element').removeClass('active');

      if(hasAuto){
        var autoType = $(ss).attr('data-auto-draw');

        if(autoType){
          $('.walls-container .automatic-possibility').removeClass('active');
          $(ss).addClass('active');

          $('#automatic-draw-menu p.element').hide();
          $('.'+autoType).show();
        }
      }
      if(!hasAuto){
        $('#automatic-draw-menu p.element.automatic-possibility').hide();
        $('#automatic-draw-menu p.element-disabled').show();
        if (!$(ss).hasClass('delete-all-m')){
          $(ss).addClass('active');
        }
      }

    
      $('#temp-STAND-EDITOR').removeClass('delete');
      $('#temp-STAND-EDITOR').addClass('mouseover');

      f_StandEditorReset();

      if ($(ss).is('.e-s-wall-1-auto')) {
        if($(ss).hasClass('active')){
          f_StandElementDrawPointAuto('s', 'wall-1', 1, 1);
          $('.element.e-s-wall-1').addClass('active');
        }else{
          f_StandElementDrawAuto('s', 'wall-1', 1, 1);
          $('.element.e-s-wall-1').addClass('active');
        }
        $(ss).toggleClass('active');
      }else{
        $('.e-s-wall-1-auto').removeClass('active');
      } 

      if ($(ss).is('.e-s-wall-2-auto')) {
        if($(ss).hasClass('active')){
          f_StandElementDrawPointAuto('s', 'wall-2', 1, 1);
          $('.element.e-s-wall-2').addClass('active');
        }else{
          f_StandElementDrawAuto('s', 'wall-2', 1, 1);
          $('.element.e-s-wall-2').addClass('active');
        }

        $(ss).toggleClass('active');
      }else{
        $('.e-s-wall-2-auto').removeClass('active');
      } 

      if ($(ss).is('.e-s-wall-3-auto')) {
        if($(ss).hasClass('active')){
          f_StandElementDrawPointAuto('s', 'wall-3', 1, 1);
          $('.element.e-s-wall-3').addClass('active');
        } else{
          f_StandElementDrawAuto('s', 'wall-3', 1, 1);
          $('.element.e-s-wall-3').addClass('active');
        }
        $(ss).toggleClass('active');
      }else{
        $('.e-s-wall-3-auto').removeClass('active');
      }
       // Draw Auto

      if ($(ss).is('.e-s-bull-auto')) {
        if($(ss).hasClass('active')){
          f_StandElementDrawPointAuto('s', 'bull', 1, 1);
          $('.element.e-s-bull').addClass('active');
        }else{
          f_StandElementDrawAuto('s', 'bull', 1, 1);
          $('.element.e-s-bull').addClass('active');
        }
        $(ss).toggleClass('active');
      }else{
        $('.e-s-bull-auto').removeClass('active');
      }
       // Draw Auto

      if ($(ss).is('.e-m-light-auto')) {
        if($(ss).hasClass('active')){
          f_StandElementDrawPointAuto('m', 'light', 1, 1);
          $('.e-m-light').addClass('active');
        }else{
          f_StandElementDrawAuto('m', 'light', 2, 1);
          $('.e-m-light').addClass('active');
        }
        $(ss).toggleClass('active'); 
      }else{
        $('.e-m-light-auto').removeClass('active');
      }
       // Draw Auto

      if ($(ss).is('.e-s-wall-1')) { f_StandElementDrawPointAuto('s', 'wall-1', 1, 1);	} // Draw PointAuto
      if ($(ss).is('.e-s-wall-2')) { f_StandElementDrawPointAuto('s', 'wall-2', 1, 1);} // Draw PointAuto
      if ($(ss).is('.e-s-wall-3')) { f_StandElementDrawPointAuto('s', 'wall-3', 1, 1); } // Draw PointAuto
      if ($(ss).is('.e-s-bull')) { f_StandElementDrawPointAuto('s', 'bull', 1, 1); } // Draw PointAuto
      if ($(ss).is('.e-s-exit')) { f_StandElementDrawPointAuto('s', 'exit', 2, 1); } // Draw PointAuto
    
      if ($(ss).is('.e-f-any')) { f_StandElementDrawPointAuto('f', 'any', 2, 1); } // Draw PointAuto
      if ($(ss).is('.e-f-any2')) { f_StandElementDrawPointAuto('f', 'any2', 1, 1); } // Draw PointAuto
      if ($(ss).is('.e-f-regal')) { f_StandElementDrawPointAuto('f', 'regal', 2, 1); } // Draw PointAuto
      if ($(ss).is('.e-f-hanger')) { f_StandElementDrawPointAuto('f', 'hanger', 2, 1); } // Draw PointAuto
      if ($(ss).is('.e-f-leaflets')) { f_StandElementDrawPointAuto('f', 'leaflets', 1, 1); } // Draw PointAuto
      if ($(ss).is('.e-f-table')) { f_StandElementDrawPointAuto('f', 'table', 1, 1); } // Draw PointAuto
      if ($(ss).is('.e-f-hoker')) { f_StandElementDrawPointAuto('f', 'hoker', 1, 1); } // Draw PointAuto
      if ($(ss).is('.e-f-chairs-1')) { f_StandElementDrawPointAuto('f', 'chairs-1', 3, 2); } // Draw PointAuto
      if ($(ss).is('.e-f-chairs-2')) { f_StandElementDrawPointAuto('f', 'chairs-2', 4, 2); } // Draw PointAuto
      if ($(ss).is('.e-f-chairs-3')) { f_StandElementDrawPointAuto('f', 'chairs-3', 4, 4); } // Draw PointAuto
  
      if ($(ss).is('.e-m-volt-c')) 			{														// Draw Point
        if($('#temp-STAND-EDITOR p.stand_SUR').html() == 'Niezabudowana') {
          f_StandElementDrawPoint('m', 'volt-m', 1, 1);	
        } else {
          f_StandElementDrawPoint('m', 'volt-c', 1, 1);
        }
      } 		
      if ($(ss).is('.e-m-light'))	{f_StandElementDrawPointAuto('m', 'light', 2, 1);} 		// Draw PointAuto
  
      if ($(ss).is('.e-m-halogen'))	{f_StandElementDrawPointAuto('m', 'halogen', 2, 1);} 		// Draw PointAuto
      
      if ($(ss).is('.delete')) 				{
        $(ss).addClass('active');
        f_StandElementDeletePoint();}
      if ($(ss).is('.delete-all-s')) 		{f_StandElementDeleteAll('s');}
      if ($(ss).is('.delete-all-f')) 		{f_StandElementDeleteAll('f');}
      if ($(ss).is('.delete-all-m')) 		{f_StandElementDeleteAll('m');}
  };
  
  // Update Legend	
	function f_UpdateLegend(){                                               //FUNCTIONS STANDEDITOR STAND EDIT
		// Stand
		if($('#plan_CONTENT div.stand').length > 0){$('#plan-legend p.legend-number').show(); $('#plan-legend p.legend-stand').show(); $('#plan-legend p.legend-stand-own').show();}
		else {$('#plan-legend p.legend-number').hide(); $('#plan-legend p.legend-stand').hide(); $('#plan-legend p.legend-stand-own').hide();}
		// Wall
		if($('#plan_CONTENT td.wall').length > 0){$('#plan-legend p.legend-wall').show();}
		else {$('#plan-legend p.legend-wall').hide();}
		// Filar
		if($('#plan_CONTENT td.filar').length > 0){$('#plan-legend p.legend-filar').show();}
		else {$('#plan-legend p.legend-filar').hide();}
		// Exit
		if($('#plan_CONTENT td.exit').length > 0){$('#plan-legend p.legend-exit').show();}
		else {$('#plan-legend p.legend-exit').hide();}
		// Stand Light
		if($('#plan_CONTENT p.light-t').length > 0 || $('#plan_CONTENT p.light-b').length > 0 || $('#plan_CONTENT p.light-l').length > 0 || $('#plan_CONTENT p.light-r').length > 0){$('#plan-legend p.legend-light').show();}
		else {$('#plan-legend p.legend-light').hide();}
		// Stand Halogen
		if($('#plan_CONTENT p.halogen-t').length > 0 || $('#plan_CONTENT p.halogen-b').length > 0 || $('#plan_CONTENT p.halogen-l').length > 0 || $('#plan_CONTENT p.halogen-r').length > 0){$('#plan-legend p.legend-halogen').show();}
		else {$('#plan-legend p.legend-halogen').hide();}
		// Stand Volt
		if($('#plan_CONTENT p.volt-c').length > 0 || $('#plan_CONTENT p.volt-m').length > 0){$('#plan-legend p.legend-volt').show();}
		else {$('#plan-legend p.legend-volt').hide();}
		// Exit
		if($('#plan_CONTENT p.exit-t').length > 0 || $('#plan_CONTENT p.exit-b').length > 0 || $('#plan_CONTENT p.exit-l').length > 0 || $('#plan_CONTENT p.exit-r').length > 0){$('#plan-legend p.legend-exit').show();}
		else {$('#plan-legend p.legend-exit').hide();}
		// Lada
		if($('#plan_CONTENT p.any-t').length > 0 || $('#plan_CONTENT p.any-b').length > 0 || $('#plan_CONTENT p.any-l').length > 0 || $('#plan_CONTENT p.any-r').length > 0){$('#plan-legend p.legend-any').show();}
		else {$('#plan-legend p.legend-any').hide();}
		// Regal
		if($('#plan_CONTENT p.regal-t').length > 0 || $('#plan_CONTENT p.regal-b').length > 0 || $('#plan_CONTENT p.regal-l').length > 0 || $('#plan_CONTENT p.regal-r').length > 0){$('#plan-legend p.legend-regal').show();}
		else {$('#plan-legend p.legend-regal').hide();}
		// Hanger
		if($('#plan_CONTENT p.hanger-t').length > 0 || $('#plan_CONTENT p.hanger-b').length > 0 || $('#plan_CONTENT p.hanger-l').length > 0 || $('#plan_CONTENT p.hanger-r').length > 0){$('#plan-legend p.legend-hanger').show();}
		else {$('#plan-legend p.legend-hanger').hide();}
		// Hooker
		if($('#plan_CONTENT p.hoker-t').length > 0 || $('#plan_CONTENT p.hoker-b').length > 0 || $('#plan_CONTENT p.hoker-l').length > 0 || $('#plan_CONTENT p.hoker-r').length > 0){$('#plan-legend p.legend-hoker').show();}
		else {$('#plan-legend p.legend-hoker').hide();}
		// Leaflets
		if($('#plan_CONTENT p.leaflets-t').length > 0 || $('#plan_CONTENT p.leaflets-b').length > 0 || $('#plan_CONTENT p.leaflets-l').length > 0 || $('#plan_CONTENT p.leaflets-r').length > 0){$('#plan-legend p.legend-leaflets').show();}
		else {$('#plan-legend p.legend-leaflets').hide();}
	}

  function f_StandEditorReset(){                                             //FUNCTIONS STANDEDITOR STAND EDIT
    $('#draw-element').removeClass().hide().css({'left': '0px', 'top': '0px', 'width': '20px', 'height': '20px'});
    $('#editor-scroll .edit-table-editor').removeClass('auto');
    setFuncStand('')
    setFuncStandElement('')
    setFuncStandElementW(0)
    setFuncStandElementH(0)
    setFuncStandEditorOrient('')
    setFuncStandAutoStep(0)
    setFuncStandAutoStepClick('')

    setsetFuncStandAuto1x(0)
    setsetFuncStandAuto1y(0)
    setsetFuncStandAuto2x(0)
    setsetFuncStandAuto2y(0)

  }

  // Stand Edit Click Tab                                               //FUNCTIONS STANDEDITOR STAND EDIT
	$('#sbs-popup-stand-edit .edit-table-left .menu p:not(.bound)').addClass('bound').on('click', function() {
		$('#sbs-popup-stand-edit .edit-table-left .menu p').removeClass('active');
		$(this).addClass('active');
		$('#sbs-popup-stand-edit .edit-table-right div.tab').hide();
		$('#sbs-popup-stand-edit .element').removeClass('active');		
		$('#temp-STAND-EDITOR').removeClass('mouseover');

		$('#sbs-popup-stand-edit .edit-table-right-top').show();
		
		f_StandEditorReset();
		
		$('#temp-STAND-EDITOR')
			.addClass('hide-s')
			.addClass('hide-f')
			.addClass('hide-m');
			
		if ($(this).is('.tab-info')) {
			$('#sbs-popup-stand-edit .edit-table-right-top').css({'height': '201px'});
			$('#sbs-popup-stand-edit .edit-table-right div.tab-info').show();
			$('#temp-STAND-EDITOR')
				.removeClass('hide-s')
				.removeClass('hide-f')
				.removeClass('hide-m');
		}
		if ($(this).is('.tab-info-add')) {
			$('#sbs-popup-stand-edit .edit-table-right-top').css({'height': '275px'});
			$('#sbs-popup-stand-edit .edit-table-right div.tab-info-add').show();
			$('#temp-STAND-EDITOR')
				.removeClass('hide-s')
				.removeClass('hide-f')
				.removeClass('hide-m');
		}
		if ($(this).is('.tab-wall')) {
			$('#sbs-popup-stand-edit .edit-table-right-top').css({'height': '275px'});
			$('#sbs-popup-stand-edit .edit-table-right div.tab-wall').show();
			$('#temp-STAND-EDITOR')
				.removeClass('hide-s');
		}
		if ($(this).is('.tab-furniture')) {
			$('#sbs-popup-stand-edit .edit-table-right-top').css({'height': '275px'});
			$('#sbs-popup-stand-edit .edit-table-right div.tab-furniture').show();
			$('#temp-STAND-EDITOR')
				.removeClass('hide-f');
		}
		if ($(this).is('.tab-light')) {
			$('#sbs-popup-stand-edit .edit-table-right-top').css({'height': '275px'});
			$('#sbs-popup-stand-edit .edit-table-right div.tab-light').show();
			$('#temp-STAND-EDITOR')
				.removeClass('hide-m');
		}	
		if ($(this).is('.tab-gfx')) {
			$('#sbs-popup-stand-edit .edit-table-right-top').css({'height': '201px'});
			$('#sbs-popup-stand-edit .edit-table-right div.tab-gfx').show();
			$('#temp-STAND-EDITOR')
				.removeClass('hide-s')
				.removeClass('hide-f')
				.removeClass('hide-m');
		}			
	});

   // Update List
	function f_UpdateList(){
		var tempList = '<tr class="empty"><td>&nbsp;</td><td><p class="info">Lista wystawców jest pusta!</p></td><td>&nbsp;</td></tr>';
		$('#list-table tbody').html(tempList)
		
		if($('#plan_CONTENT div.stand').length == 0) {
			$('#list-table tr.header').hide();
			$('#list-table tr.empty').show();
		} else {
			$('#list-table tr.header').show();
			$('#list-table tr.empty').hide();
			
			$('#plan_CONTENT div.stand').each(function() {
				var tempList_stand_ID = $(this).attr('id');
				var tempList_stand_NR = $(this).find('span.stand_NR').html();
				var tempList_stand_NAME = $(this).find('span.stand_NAME').html();
				var tempList_stand_SIZE = $(this).find('p.stand_SIZE').html();
							 	
				$('#list-table tbody').append('<tr stand_ID="'+tempList_stand_ID+'"><td class="nr">'+tempList_stand_NR+'</td><td>'+tempList_stand_NAME+'</td><td class="a-right size">'+tempList_stand_SIZE+'m&sup2;</td></tr>');
			});
			
			$("#list-table").trigger("update");
			$("#list-table .headerSortDown").click().click();
			$("#list-table .headerSortUp").click().click();
		}
	}

  useEffect(()=>{
    updateStandEditorEvents();
  }, [func_stand, func_stand_element, func_stand_element_w, func_stand_element_h, func_stand_editor_orient,func_stand_auto_step, func_stand_auto_step_click])

  useEffect(()=>{
    document.body.oncontextmenu = () => {if (func == 'wall-exit-arrow') { return false}else{return true}}

  }, [func])



////!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!FUNCTIONS STANDEDITOR STAND EDIT!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!/////    
    
  
 
  // Stand KT
  $('#sbs-popup-stand-edit a.editor-kt').unbind('click');
	$('#sbs-popup-stand-edit a.editor-kt').on('click', function() {
		var stand_ID = $('#sbs-popup-stand-edit').attr('stand_ID');
		
		setSendMail(false);
		
		$('#sbs-popup-stand-edit a.editor-update').click();
		setSendMail(true);

		f_PlanSave(0);
		var url = "/plans/cardview/" + plan_id.toString() + '?download=d&v=kt&s='+stand_ID
    window.open(url);
	});

  $('#sbs-popup-stand-edit a.editor-kt-en').unbind('click');
	$('#sbs-popup-stand-edit a.editor-kt-en').on('click', function() {
		var stand_ID = $('#sbs-popup-stand-edit').attr('stand_ID');
		
		setSendMail(false);
		
		$('#sbs-popup-stand-edit a.editor-update').click();
		setSendMail(true);

		f_PlanSave(0);
		var url = "/plans/cardview/" + plan_id.toString() + '?download=d&v=kt&s='+stand_ID + '&lang=en'
    window.open(url);
	});
	

  $('#sbs-popup-stand-edit a.editor-kt-pdf').unbind('click');
  $('#sbs-popup-stand-edit a.editor-kt-pdf').on('click', function() {
		var stand_ID = $('#sbs-popup-stand-edit').attr('stand_ID');

		setSendMail(false);
		$('#sbs-popup-stand-edit a.editor-update').click();
		setSendMail(true);

		f_PlanSave(0);
		var url = "/plans/cardview/" + plan_id.toString() + '?download=d&v=kt&s='+stand_ID+'&p=true'
   
    window.open(url);
	});

  $('#sbs-popup-stand-edit a.editor-kt-pdf-en').unbind('click');
  $('#sbs-popup-stand-edit a.editor-kt-pdf-en').on('click', function() {
		var stand_ID = $('#sbs-popup-stand-edit').attr('stand_ID');

		setSendMail(false);
		$('#sbs-popup-stand-edit a.editor-update').click();
		setSendMail(true);

		f_PlanSave(0);
		var url = "/plans/cardview/" + plan_id.toString() + '?download=d&v=kt&s='+stand_ID+'&p=true&lang=en' 
   
    window.open(url);
	});

  // Plan Wall
  $('#sbs-panel-wall p').unbind('click');
	$('#sbs-panel-wall p').on('click', function() {
   
		$('.sbs-table-panel-tab p').removeClass('active');
		f_ResetFunc();
		
		$(this).addClass('active');
		$('#temp-ARROW').hide();
    if ($(this).is('.form-colors')){$(this).parent().find('.sbs-popup-colors').show();}
		
		if ($(this).is('.wall-draw')) {setFunc('wall-draw');}
		if ($(this).is('.wall-draw-auto')) {setFunc('wall-draw-auto');}
		if ($(this).is('.wall-draw-media')) {setFunc('wall-draw-media');}
		if ($(this).is('.wall-filar')) {setFunc('wall-filar');}
		if ($(this).is('.wall-hydrant')) {setFunc('wall-hydrant');}
		if ($(this).is('.wall-bull')) {setFunc('wall-bull');}
		if ($(this).is('.wall-rbt')) {setFunc('wall-rbt');}
		if ($(this).is('.custom-text')) {setFunc('custom-text');}
		if ($(this).is('.wall-exit')) {setFunc('wall-exit');}
		if ($(this).is('.wall-exit-arrow')) {
			setFunc('wall-exit-arrow');
			$('#temp-ARROW').removeClass().addClass('exit-a-t').show();
		}
		if ($(this).is('.wall-delete')) {setFunc('wall-delete');}
		if ($(this).is('.wall-delete-auto')) {setFunc('wall-delete-auto');}

		// Border
		if ($(this).is('.wall-border')) {
			var plan_COLOR_WALL = $('#sbs-panel-wall .plan_COLOR_WALL').css('background-color');
     
			var plan_W = plan_width*2;
			var plan_H = plan_height*2;

			$('#plan_CONTENT tr:not(.stand)').eq(0).find('td:not(.stand)').css({"background-color": '#'+plan_COLOR_WALL}).removeClass().addClass('wall');
			$('#plan_CONTENT tr:not(.stand)').eq(plan_H-1).find('td:not(.stand)').css({"background-color": '#'+plan_COLOR_WALL}).removeClass().addClass('wall');
			
			for(var i=0;i<plan_H;i++) {
				$('#plan_CONTENT tr:not(.stand)').eq(i).find('td:not(.stand)').eq(0).css({"background-color": '#'+plan_COLOR_WALL}).removeClass().addClass('wall');				
				$('#plan_CONTENT tr:not(.stand)').eq(i).find('td:not(.stand)').eq(plan_W-1).css({"background-color": '#'+plan_COLOR_WALL}).removeClass().addClass('wall');				
			}
			$('#sbs-table-menu a.save').slideDown();	
			$('.sbs-table-panel-tab p').removeClass('active');
		}

		// Deleta All
		if ($(this).is('.wall-delete-all')) {
			var confirmDelete = window.confirm("Czy aby napewno chce usunąc wszystkie sciany, filary i wejścia?")
			if (confirmDelete){
				$('#plan_CONTENT td.wall').css({"background-color": ''}).removeClass('wall');
				$('#plan_CONTENT td.wall-okta-l').removeClass('wall-okta-l');
				$('#plan_CONTENT td.wall-okta-t').removeClass('wall-okta-t');
				$('#plan_CONTENT td.filar').css({"background-color": ''}).removeClass('filar');
				$('#plan_CONTENT td.exit').removeClass('exit');
				$('#plan_CONTENT td.exit-horizontal').removeClass('exit-horizontal');
				$('#plan_CONTENT td.exit-vertical').removeClass('exit-vertical');
				$('#plan_CONTENT .exit-a').remove();
				$('#sbs-table-menu a.save').slideDown();				
			}
			$('.sbs-table-panel-tab p').removeClass('active');
		}		
	});	



  // Change wall Color
  $('#sbs-panel-wall .sbs-popup-colors-wall p.color').unbind('click');
	$('#sbs-panel-wall .sbs-popup-colors-wall p.color').on('click', function() {
		var plan_COLOR_WALL = $(this).children('span').html();
		$('#plan_CONTENT td.wall').css({"background-color": plan_COLOR_WALL});
		$('#plan_CONTENT td.filar').css({"background-color": plan_COLOR_WALL});
		$('#sbs-table-menu a.save').slideDown();
    setWallColor(plan_COLOR_WALL);
    StandeditorService.setWallColor(plan_id, plan_COLOR_WALL).then(response => {
      f_Progress(0);
    }).catch(
      (error) => {
        alert('Wystąpił błąd przy zapisie koloru!')
      }
      )
	});	

  // Click View Item
  $('#sbs-panel-view p.item-view').unbind('click');
	$('#sbs-panel-view p.item-view').on('click', function() {
		$(this).toggleClass('active');

		if ($(this).is('.stands-book')) {$('#plan_CONTENT').toggleClass('hide-stands-book');}
		if ($(this).is('.stands-free')) {$('#plan_CONTENT').toggleClass('hide-stands-free');}
		if ($(this).is('.stands-sold')) {$('#plan_CONTENT').toggleClass('hide-stands-sold');}
		if ($(this).is('.texts')) {$('#plan_CONTENT').toggleClass('hide-texts');}
		if ($(this).is('.walls')) {$('#plan_CONTENT').toggleClass('hide-walls');}
		if ($(this).is('.walls-fryz')) {$('#plan_CONTENT').toggleClass('hide-walls-fryz');}
		if ($(this).is('.bulls')) {$('#plan_CONTENT').toggleClass('hide-bulls');}
		if ($(this).is('.exits')) {$('#plan_CONTENT').toggleClass('hide-exits');}
		if ($(this).is('.furnitures')) {$('#plan_CONTENT').toggleClass('hide-furnitures');}
		if ($(this).is('.volts')) {$('#plan_CONTENT').toggleClass('hide-volts');}
		if ($(this).is('.lights')) {$('#plan_CONTENT').toggleClass('hide-lights');}
		if ($(this).is('.guides')) {
			$('#plan-guide-x').toggleClass('none_imp');
			$('#plan-guide-y').toggleClass('none_imp');
		}

    if ($(this).is('.background')) {
      
      setHideBackground(!hideBackground)

    }
	});
  
  $('#plan_CONTENT div.stand').unbind('mouseenter');
  $('#plan_CONTENT div.stand').on('mouseenter', function(){
    $('#plan-guide-y').hide();
    $('#plan-guide-x').hide();
  }).on('mouseleave', function(){
    $('#plan-guide-y').show();
    $('#plan-guide-x').show();
  });


$('#plan_CONTENT td:not(.stand)').unbind('mouseenter');

$('#plan_CONTENT td:not(.stand)').unbind('mousewheel');
$('#plan_CONTENT td:not(.stand)').on('mousewheel', function(e:any) {
    //alert(func)
    if (func_put=='stand-rotate'){
    console.log(func_rotate_id)
    console.log(func)
    console.log(func_put)
    var tmp = $('#temp-STAND') 
    var stand_id = ''
    if (tmp){
      stand_id = String($(tmp[0].children[0]).attr('id'));
    }
    console.log()
    if (func_rotate_id!='' && func=='move-temp-stand'){
      e.preventDefault();
          var stand =  $('#' + func_rotate_id);
      //console.log(stand)
        //console.log(stand[0].style.transform)
        if (stand){
        var rot=0
        var transform = stand[0].style.transform;  
        console.log(transform)
        if (transform==''){
          stand[0].style.transform = 'rotate(' + '0'+ 'deg)' 

        }
      //  var transform = stand.attr("transform") ;  
        var deg = transform?.substring(transform.indexOf('rotate(') + 7, transform.indexOf('deg)')) 
        if (deg == undefined){
          deg='';
        }

        var degInt = parseInt(deg)
    

        var degree = degInt;
        if (e.originalEvent.deltaY>0){
          degree = degree+1
          if (degree > 360){
            degree = degree-360
          }
        }else{
          degree = degree-1
          if (degree < -360){
            degree = degree+360
          } 
        }
        //console.log(e.originalEvent.deltaY)
        console.log(degree)

        stand[0].style.transform =  'rotate(' + degree + 'deg)'; 
        
   }
  }else if (stand_id!='' && func=='move-temp-stand'){
    e.preventDefault();
    advancedRotateStand(stand_id)
  }
}
});

$('#plan_CONTENT td:not(.stand)').on('mouseenter', function(e) {	
 
    var menuWidth = 120;
    var scrollLeft : number = $('#sbs-content-scroll')?.scrollLeft() ? $('#sbs-content-scroll')?.scrollLeft() as number : 0
    var scrollTop : number = $('#sbs-content-scroll')?.scrollTop() ? $('#sbs-content-scroll')?.scrollTop() as number : 0
    var x = Math.trunc(e.pageX - 50 - menuWidth +  scrollLeft as number);
    var y = Math.trunc(e.pageY - 90 + scrollTop as number);
        
    x = Math.trunc(x/20)*20;
    y = Math.trunc(y/20)*20;
              
    $('#plan-guide-y').css({'left': x});
    $('#plan-guide-x').css({'top': y});
       
    if(func_end == 'wall-draw-auto-end') {
        var tempDrawWmouse = Math.trunc(x-draw_auto_1_x*20);
        var tempDrawHmouse = Math.trunc(y-draw_auto_1_y*20);	
                  
        if (tempDrawWmouse >= tempDrawHmouse && tempDrawWmouse >= 20){
            $('#plan-temp-draw').css({'width': tempDrawWmouse+20+'px'});
        } else {
            $('#plan-temp-draw').css({'width': '20px'});
        }
                
        if (tempDrawWmouse < tempDrawHmouse && tempDrawHmouse >= 20){
            $('#plan-temp-draw').css({'height': tempDrawHmouse+20+'px'});
        } else {
            $('#plan-temp-draw').css({'height': '20px'});
        }
    }
    if(func_end == 'wall-draw-media-end') {
        var tempDrawWmouse = Math.trunc(x-draw_auto_1_x*20);
        var tempDrawHmouse = Math.trunc(y-draw_auto_1_y*20);	
                  
        if (tempDrawWmouse >= tempDrawHmouse && tempDrawWmouse >= 20){
            $('#plan-temp-draw').css({'width': tempDrawWmouse+20+'px'});
        } else {
            $('#plan-temp-draw').css({'width': '20px'});
        }
                
        if (tempDrawWmouse < tempDrawHmouse && tempDrawHmouse >= 20){
            $('#plan-temp-draw').css({'height': tempDrawHmouse+20+'px'});
        } else {
            $('#plan-temp-draw').css({'height': '20px'});
        }
    }
   
        
    if ((func == 'move-temp-stand')) {
      //Adam
      //console.log($('#temp-STAND').attr('style'));
      //console.log(document.getElementById("temp-STAND")?.style );
      //  console.log($($('#temp-STAND')?.children()[0])?.width());
      //  console.log($($('#temp-STAND')?.children()[0])?.height());
      //  console.log($($('#temp-STAND')?.children()[0])?.attr('transform'));
     //let width  = $($('#temp-STAND')?.children()[0])?.width();
     //let height  = $($('#temp-STAND')?.children()[0])?.height();
       // if ($($('#temp-STAND')?.children()[0])?.attr('transform')){
         // console.log('aaa')
        // y = y - 100;
          $('#temp-STAND').css({'margin-left': x+'px', 'margin-top': y+'px'});

       // }else{
          //console.log('bbb')
          //console.log(y-x)
        //  y = y - ((Number(height)-Number(width))/2);
        //  x = x - ((Number(width)-Number(height))/2)
          //console.log(x-y)
      //    $('#temp-STAND').css({'margin-left': x+'px', 'margin-top': y+'px'});
      //  }
        
    }

    if(func == 'wall-exit-arrow') {
      $('#temp-ARROW').css({'margin-left': x+'px', 'margin-top': y+'px'});
  }
        
});
      





  function showStandMenu(){
    $('#sbs-panel-wall').hide();
		$('#sbs-panel-view').hide();
		$('#sbs-panel-stand').show();
    $('#item-stand-edit').addClass('active');
    setFunc('stand-edit');
  }

  function showWallMenu(){
    $('#sbs-panel-wall').show();
		$('#sbs-panel-view').hide();
		$('#sbs-panel-stand').hide();
  }

  function showViewMenu(){
    $('#sbs-panel-wall').hide();
		$('#sbs-panel-view').show();
		$('#sbs-panel-stand').hide();
  }

  function f_Progress(value:number) {
		value = Math.max(0, Math.min(100, +value || 0));
		$("#progress-bar").width(value + '%');
		var val = value == 0 ? '' : value + '%'; 
		$("#progress-val").text(val);
	}


  function f_PlanSave(close: number) {
    $('#sbs-table-menu').addClass('loading-dark');
		$('.bound').removeClass('bound');
		var plan_CONTENT = $('#plan_CONTENT').html();
		

		f_Progress(50);
		
		var t0 = new Date();
    console.log('plan_id=' + plan_id)
    console.log(plan_CONTENT)
				
    StandeditorService.saveplan(plan_id, plan_CONTENT, close).then(response => {
      f_Progress(0);
			$('#sbs-table-menu').removeClass('loading-dark');
			if (close > 0){
        window.close()
      }
      setAlertInfo('Zapisano plan!')
      if (plan_CONTENT==''){
        window.location.reload();
      }
    }).catch(
      (error) => {
        console.log(error);
        window.location.reload();
      }
      )
  }

  function f_PlanCancelEdit(close: number) {
    StandeditorService.canceledit(plan_id).then((response) => {
      if (close){ 
        window.close();
      }
      window.location.reload();
 
     }).catch(
       (error) => {
         window.location.reload();
       }
       )
  }

  function f_PlanStartEdit() {
    StandeditorService.startedit(plan_id).then((response) => {
			window.location.reload();
    }).catch(
      (error) => {
        window.location.reload();
      }
      )
  }

  function restoreBackupClick(e: any, data:any){
    if (data.value !=""){
      var confirmRestore = window.confirm("Czy na pewno chce przywrócić starszą wersję?")
      if (confirmRestore){
        f_BackupRestore(plan_id, data.value);
      }	
    }		
  };

  function changeBackgroundOffset(opt:any) {
    var backgroundPos = $('#plan_CONTENT').css('backgroundPosition');
    standeditorService.savebackgroundposition(plan_id, backgroundPos).then(()=>{
        setAlertInfo('Zapisano podkład!');
      }
    ).catch(()=>{
      setAlertError('Błąd zapisu!');
    })
    

  }

  function changesize(opt:any) {
    var type : number= Number($('#changesize_type option:selected').val())
    if ((plan_width == $('#plan_width').val()) && (plan_height == $('#plan_height').val())){
			
			alert('Nie zmieniono wymiarów!');
			//alert($($($('#plan_CONTENT')[0]).children()[0]).children()[5].cells.length)
				
		}else{
			if (plan_height > Number($('#plan_height').val())){
				var x:number;
        if ((type == 1) || (type == 3)){
          for (x=2*plan_height; x > 2*Number($('#plan_height').val()); x--){
            $($($('#plan_CONTENT')[0]).children()[0]).children().last().remove();
          }
        }else{
          for (x=2*plan_height; x > 2*Number($('#plan_height').val()); x--){
            $($($('#plan_CONTENT')[0]).children()[0]).children().first().remove();
          }
        }
			}else{
				var x:number;

        if ((type == 1) || (type == 3)){
          for (x=2*plan_height; x<2*Number($('#plan_height').val()); x++){
            $($($('#plan_CONTENT')[0]).children()[0]).append($('<tr>'));
            var y=0;
            for (y=0; y<2*plan_width; y++){
              $($($('#plan_CONTENT')[0]).children()[0]).children().last().append($('<td>'));
            }
          }
        }else{
          for (x=2*plan_height; x<2*Number($('#plan_height').val()); x++){
            $($($('#plan_CONTENT')[0]).children()[0]).prepend($('<tr>'));
            var y=0;
            for (y=0; y<2*plan_width; y++){
              $($($('#plan_CONTENT')[0]).children()[0]).children().first().append($('<td>'));
            }
          }
        }
			}
			
			if (plan_width > Number($('#plan_width').val())){
				var x:number;
        if ((type == 1) || (type == 2)){
          for (x=0; x<2*plan_height ; x++){
            var y:number;
            for (y=2* plan_width; y>2* Number($('#plan_width').val()); y--){
              $($($($('#plan_CONTENT')[0]).children()[0]).children()[x]).children().last().remove();
            }
          }
        }else{
          //for (x=0; x<2*plan_height ; x++){
          for (x=0;x<2*Number($('#plan_height').val());x++){
          var y:number;
            for (y=2* plan_width; y>2* Number($('#plan_width').val()); y--){
              $($($($('#plan_CONTENT')[0]).children()[0]).children()[x]).children().first().remove();
            }
          }
        }
			}else{
				var x:number;
        if ((type == 1) || (type == 2)){
          for (x=0; x<2*plan_height ; x++){
            //console.log(x);
            var y=0;
            for (y=2*plan_width; y<2*Number($('#plan_width').val()); y++){
              $($($($('#plan_CONTENT')[0]).children()[0]).children()[x]).append($('<td>'));
              //$($($($('#plan_CONTENT')[0]).children()[0]).children()[x]).prepend($('<td>'));
            }
            //$($('#plan_CONTENT')[0]).children().last().remove();
          }
        }else{
          for (x=0; x<2*plan_height ; x++){
            var y=0;
            for (y=2*plan_width; y<2*Number($('#plan_width').val()); y++){
              $($($($('#plan_CONTENT')[0]).children()[0]).children()[x]).prepend($('<td>'));
            }
          }
        }

			}
      planService.change_size({plan_id:plan_id, width:Number($('#plan_width').val()), height:Number($('#plan_height').val())}).then(resp =>{
       setPlanWidth(Number($('#plan_width').val()))
       setPlanHeight(Number($('#plan_height').val()))
       setPlanSize([Number($('#plan_width').val()), Number($('#plan_height').val())])
       
      }).catch(error => {
        console.log(error)
      })
    }
		
    f_PlanSave(0)
  }

  var numberVertical = ''
  var numberHorizontal = ''
  for(let nVertical=1;nVertical<=plan_height;nVertical++) {
    numberVertical = numberVertical + '<p><span>' + nVertical + '</span></p>'
    //setnumberVertical(tmp_numberVertical)
  }
  for(let nHorizontal=1;nHorizontal<=plan_width;nHorizontal++) {
    numberHorizontal = numberHorizontal + '<p><span>' + nHorizontal + '</span></p>'
    //setnumberHorizontal(tmp_numberHorizontal)
  }

  const handleEditContactChange = (event:any, value:any) =>{
    if (value){
      $('#sbs_popup_edit_contact_id').val(value.id) 
      $('#sbs_popup_edit_contact_name').val(value.name)

      setEditContactName(value.name)

      var tmp = value.name.split(' | ')

      if (tmp.length>=0){
        $('#sbs-popup-stand-edit').find('input.stand_O_NAME').val(tmp[0]);
      }
      if (tmp.length>=2){
        $('#sbs-popup-stand-edit input.stand_O_MAIL').val(tmp[2]);
      }
      if (tmp.length>=2){
      $('#sbs-popup-stand-edit').find('input.stand_O_TEL').val(tmp[1]);
      }

      $('#contact_button_edit').html('Aktualiuj kontakt w CRM')

    }else{
      $('#sbs_popup_edit_contact_id').val('') 
      $('#sbs_popup_edit_contact_name').val('')

      $('#contact_button_edit').html('Dodaj kontakt do CRM')
      setEditContactName('')
    }
  };

  const setEditedStandName = (e:any) =>{
    if (contractor_name != ''){
      $('#sbs-popup-stand-edit .stand_NAME').val(contractor_name)
      $('#temp-STAND-EDITOR span.stand_NAME').html(contractor_name);
    }
  }

  const updateContact = (e:any) =>{
    var contractor_id = Number($('#sbs_popup_edit_contractor_id').val());

    var contact_id = Number($('#sbs_popup_edit_contact_id').val())

    if (contact_id > 0){
      var contactName = $('#sbs-popup-stand-edit').find('input.stand_O_NAME').val() as string
      var contactPhone = $('#sbs-popup-stand-edit').find('input.stand_O_TEL').val() as string
      var contactMail =  $('#sbs-popup-stand-edit').find('input.stand_O_MAIL').val() as string;

      var re = /\S+@\S+\.\S+/;
      if ((contactMail=='') || re.test(contactMail)){
  
        re = /[a-zA-Z]+/;
        if ((contactPhone!='') && !re.test(contactPhone)){  
      
     
            contactService.editContact({id: contact_id, contractor_id:contractor_id, phone : contactPhone, mail: contactMail, name : contactName}).then(resp =>{
              //alert('poprawnie zaktualizowano kontakt')

              contactService.contactsList(Number($('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('stand_Contractor_ID'))).then(resp =>{
                setContactsList(resp)
                $('#sbs_popup_edit_contact_name').val(contactName + ' | ' + contactPhone + ' | '  + ' | ' + contactMail)
                setEditContactName(contactName + ' | ' + contactPhone + ' | '  + ' | ' + contactMail)
              // setEditContactName
              }).catch(error => {
                console.log(error)
              })   
              
            }).catch(error => {
              alert('Błąd podczas aktualizacji kontaktu w CRM-ie');
            })
      
          }else{
            alert('Numer telefonu nie może zawierać liter [a-z A-Z]!')
          }
        }else{
          alert('Nieprawidłowy adres e-mail!')
        }
    }else{
      alert('Nie wybrano kontaktu do aktualizacji!')
    }

  }

  const addContact = (e:any) =>{
    var contractor_id = Number($('#sbs_popup_edit_contractor_id').val());

    var contactName = $('#sbs-popup-stand-edit').find('input.stand_O_NAME').val() as string
    var contactPhone = $('#sbs-popup-stand-edit').find('input.stand_O_TEL').val() as string
    var contactMail =  $('#sbs-popup-stand-edit').find('input.stand_O_MAIL').val() as string;

    var re = /\S+@\S+\.\S+/;
    if ((contactMail=='') || re.test(contactMail)){

      re = /[a-zA-Z]+/;
      if ((contactPhone!='') && !re.test(contactPhone)){  
        contactService.addContact({contractor_id:contractor_id, phone : contactPhone, mail: contactMail, name : contactName}).then(resp =>{
          //alert('poprawnie dodano kontakt')
          contactService.contactsList(Number($('#temp-STAND-EDITOR').find('div.stand_DETAILS').attr('stand_Contractor_ID'))).then(resp =>{
            setContactsList(resp)
            $('#sbs_popup_edit_contact_name').val(contactName + ' | ' + contactPhone + ' | '  + ' | ' + contactMail)
            setEditContactName(contactName + ' | ' + contactPhone + ' | '  + ' | ' + contactMail)
            alert('Poprawnie dodano kontakt ddo CRM-u')
          }).catch(error => {
            console.log(error)
            //alert('Wystąpił błąd przy dodawaniu kontaktu')
            setAlertInfo('Dodano kontakt do CRM')
          })
        }).catch(error => {
          console.log(error)
          setAlertError('Błąd podczas dodawania kontaktu do CRM-u')
        })
      }else{
        alert('Numer telefonu nie może zawierać liter [a-z A-Z]!')
      }
    }else{
      alert('Nieprawidłowy adres e-mail!')
    }
  }


  


  const handleEditContractorChange = (event:any, value:any) =>{
    
    if (value){
      setEditContractorName(value.name)
      $('#sbs_popup_edit_contractor_id').val(value.id) 
      $('#sbs_popup_edit_contractor_name').val(value.name)


      if (String($('#sbs_popup_edit_contractor_name').val()) != String($('#sbs-popup-stand-edit .stand_NAME').val())) {
          $('#contractor_button_edit').html('Zaktualizuj nazwę stoiska')
      }else{
        $('#contractor_button_edit').html('-')
      }

      contactService.contactsList(value.id).then(resp =>{
        console.log(resp)
        setContactsList(resp)
      }).catch(error => {
        console.log(error)
      })

    }else{
      
      $('#sbs_popup_edit_contractor_id').val('') 
      $('#sbs_popup_edit_contractor_name').val('')
      setContactsList([])
      $('#contractor_button_edit').html('-')
      setEditContractorName('')
    }
       
  };


  function change_background_left_position(event: ChangeEvent<HTMLInputElement>): void {
    //console.log(event)
    var backgroundPos = $('#plan_CONTENT').css('backgroundPosition').split(" ");
    var yPos = parseInt(backgroundPos[3]);
    var backgroundPosNew = 'left ' + event.target.value + 'px top ' + yPos +'px'

    $('#plan_CONTENT').css('backgroundPosition', backgroundPosNew)
    
  }

  function change_background_top_position(event: ChangeEvent<HTMLInputElement>): void {
    var backgroundPos = $('#plan_CONTENT').css('backgroundPosition').split(" ");
    var xPos = parseInt(backgroundPos[1]);
    var backgroundPosNew = 'left ' + xPos + 'px top ' + event.target.value +'px'
    $('#plan_CONTENT').css('backgroundPosition', backgroundPosNew)
  }

  function searchAndHighlight(searchTerm:any) {
    if (searchTerm) {                
        var selector =  "#sbs-content"; //use body as selector if none provided
       
        var search = $( "#sbs-content .stand_NAME span" ).filter( function ()
        {
            return $( this ).text().toLowerCase().indexOf(searchTerm.toLowerCase().trim() ) >= 0;
        }).first();

        if (search.length>0){
          search[0].scrollIntoView({behavior: "smooth", block:"center"});
          
          search.parent().parent().parent().find(".stand").addClass('highlighted') ;
          return true;
        }
        
    }
    return false;
}

  function searchClick(event:any): void {
    $(".highlighted").removeClass("highlighted").removeClass("match");
    if (!searchAndHighlight($('#search-text').val())) {
        alert("No results found");
    }
  }

  function searchKeyUp(e:any):void{
      if (e.keyCode == 13) {
        $(".highlighted").removeClass("highlighted").removeClass("match");
        if (!searchAndHighlight($('#search-text').val())) {
          alert("No results found");
        }
      }
  }

  function stopClick(event:any): void {
    $(".highlighted").removeClass("highlighted");
  }

  //if (this.state.alertInfo) {
    
   
    
 //}

  return (
      <section className="content">
      {alertInfo !='' ? <> {enqueueSnackbar(alertInfo, {variant: 'info', preventDuplicate: true, autoHideDuration:5000, persist: false}) }
      {setAlertInfo('')}
      </>: '' }

      {alertError !='' ? <> {enqueueSnackbar(alertError, {variant: 'error', preventDuplicate: true, autoHideDuration:5000, persist: false}) }
      {setAlertError('')}
      </>: '' }

      <div>
        <table className="sbs-table">
          <tbody><tr>
              <td id="sbs-table-top" colSpan={4}>
                <ul className="main-menu">
                  { modifier_id==user?.u_id ?  <li className="main-menu-button"><a href="#" onClick={(e) => {showStandMenu(); }}>Edycja stoisk</a></li> : ""}
                  
                  { modifier_id==user?.u_id && (AuthService.getCurrentUser()?.group && (AuthService.getCurrentUser()?.group as number)  <= 3) ?  
                        <li className="main-menu-button"><a href="#" onClick={(e) => {showWallMenu();}}>Edycja hali</a></li> : "" }
                  
                  <li className="main-menu-button"><a href="#" onClick={(e) => {showViewMenu();}}>Widok</a></li>
                
                  {modifier_id==user?.u_id ?  <li className="main-menu-button"><a href="#" onClick={(e) => {f_PlanSave(0);}}>Zapisz</a></li> : ""}
                  {modifier_id==user?.u_id ?<li className="main-menu-button"><a href="#" onClick={(e) => {f_PlanSave(1);}}>Zapisz i wyjdź</a></li> : ""}
                  {modifier_id==user?.u_id ?<li className="main-menu-button"><a href="#" onClick={(e) => {f_PlanCancelEdit(0);}}>Anuluj</a></li> : ""}

                  {((modifier_id > 0) && (modifier_id!=user?.u_id)) ? 
                      (AuthService.getCurrentUser()?.group && AuthService.getCurrentUser()?.group as number  <= 3) ? 
                          <li className="main-menu-button"><a href="#" onClick={(e) => {f_PlanCancelEdit(-1);}}>Zakończ: {modifier_name}</a></li> :  
                          <li className="main-menu-button"><a href="#" >Edytuje: {modifier_name}</a></li> : 
                          (modifier_id > 0) ? '' :
                     <li className="main-menu-button"><a href="#" onClick={(e) => {f_PlanStartEdit();}}>Edytuj</a></li>}
                  <li className="main-menu-button"><a href="#" onClick={(e) => {f_PlanCancelEdit(1);}}>Wyjdź</a></li>
                  <li>
                    <div className="view-select">
                      <span>Wybierz podgląd</span>
                      <div className="inner">
                       {hideBackground ? 
                        <a href={"/plans/cardview/" + plan_id + "?download=t&v=d&p=t"} target="_blank" className="pdf">
                          PDF: Plan zabudowy
                        </a> :  <a href={"/plans/cardview/" + plan_id + "?download=t&v=d&p=t&background=t"} target="_blank" className="pdf">
                          PDF: Plan zabudowy
                        </a> 
                        } 
                        <a href={"/plans/cardview/" + plan_id + "?download=d&v=t&l5=t"} target="_blank" className="excel">
                          Excel: Dane do zabudowy
                        </a>
                        <a href={"/plans/cardview/" + plan_id + "?download=d&v=d&gns=t"} target="_blank" className="excel">
                          Excel: Grafika na stoisko
                        </a>
                        <a href={"/plans/cardview/" + plan_id + "?download=d&v=t&l4=t"} target="_blank" className="excel">
                          Excel: Informacje techniczne
                        </a>
                        <a href={"/plans/cardview/" + plan_id + "?download=d&v=t&l3=t"} target="_blank" className="excel">
                          Excel: Dane na fryz
                        </a>
                        <a href={"/plans/cardview/" + plan_id + "?download=d&v=d&l2e=t"} target="_blank" className="excel">
                          Excel: Pełen raport
                        </a>
                        <a href={"/plans/cardview/" + plan_id + "?download=t&v=t&p1=t"} target="_blank" className="pdf">
                          PDF: Plan stoisk
                        </a>
                        <a href={"/plans/cardview/" + plan_id + "?download=t&v=t&p2=t"} target="_blank" className="pdf">
                          PDF: Plan rezerwacji
                        </a>
                        <a href={"/plans/cardview/" + plan_id + "?download=t&v=t&l1=t"} target="_blank" className="pdf">PDF: Lista wystawców</a>
                        <a href={"/plans/cardview/" + plan_id + "?download=t&v=t&p3=t"} target="_blank" className="pdf">
                          PDF: Informacje techniczne
                        </a>
                      </div>
                    </div>
                  </li>

                 
                  
                  { modifier_id==user?.u_id && (AuthService.getCurrentUser()?.group && (AuthService.getCurrentUser()?.group as number)  <= 3) ?
                    <li>
                      <div  className="view-select list">
                        <span>Przywróć wersję</span>
                        <div className="inner backup-scroll">	
                        
                            {backups.map(function(item, i){
                              var id_txt = "restore" + (i+1)
                              var name = i+1 + ' | ' +  item.label
                              var api_data = {plan_id :plan_id,
                                backupFileName : item.name
                               };
                              return <a key={id_txt} id={id_txt}  onClick={(e) => {restoreBackupClick(e, item);}} className="restore" data-file={item} target="_blank" >{name}</a>				
                            })
                          }
                            								
                        </div>
                      </div>
                    </li>

                  : 
                  <li>
                  
                  <div style={{maxWidth:550}} className="view-select">
                  <label style={{marginRight:10}} htmlFor="plangrid">Znajdź na planie:</label>
                    <input
                        type="text"
                        id = 'search-text'
                        style={{padding: "5px 10px;"}}
                        onKeyUp={searchKeyUp}
                      />
                      <button  style={{marginLeft:5, padding:2, border:"solid 1px"}} onClick={searchClick}>Znajdź</button>
                      <button style={{marginLeft:5,  padding:2, border:"solid 1px"}} onClick={stopClick}>Stop</button>
                      
                    </div>
                </li>
                  }

              { modifier_id==user?.u_id && (AuthService.getCurrentUser()?.group && (AuthService.getCurrentUser()?.group as number)  <= 3) ?
                  <li>
                  
                    <div style={{maxWidth:550}} className="view-select">
                    <label style={{marginRight:10}} htmlFor="plangrid">Plik podkładu: </label>
                      <input
                          accept="image/*"
                          type="file"
                          id = 'plangrid'
                          onChange={imageGridChange}
                        />
                        
                      </div>
                  </li>
                : ""}
                </ul>
              </td>
            </tr>
            <tr>
              <td id="sbs-table-panel">
                <div className="sbs-table-scroll-fix">
                  <div className="sbs-table-panel-overflow">
                    <div id="sbs-panel-stand" className="sbs-table-panel-tab" style={{display: 'none'}}>
                      <p className="item stand-new"><span>&nbsp;</span>Nowe stoisko</p>
                      {/*<p class="item stand-load"><span>&nbsp;</span>Wczytaj stoisko</p>*/}
                      <p id="item-stand-edit" className="item stand-edit"><span>&nbsp;</span>Edytuj stoisko</p>
                      <p className="item stand-move"><span>&nbsp;</span>Przesuń stoisko</p>
                      <p className="item stand-rotate"><span>&nbsp;</span>Obróć stoisko o
                        <select id="rotate_type">
                                <option value={0} >&nbsp;90°</option>
                                <option value={1}>&nbsp;Inny</option>
                              </select>
                      </p>
                      <p className="item stand-clone"><span>&nbsp;</span>Sklonuj stoisko</p>
                      <p className="item stand-delete"><span>&nbsp;</span>Usuń stoisko</p>
                      <div style={{marginTop: 20}}>
                        <input id="plan_width" style={{width: 40, padding: 2}} type="number" /> x <input id="plan_height" style={{width: 40, padding: 2}} type="number" /> [m]
                        <label>Utnij/Dodaj z:</label>
                        <select id="changesize_type">
                                <option value={1} >&nbsp;prawa i dół</option>
                                <option value={2}>&nbsp;prawa i góra</option>
                                <option value={3}>&nbsp;lewa i dół</option>
                                <option value={4}>&nbsp;lewa i góra</option>
                              </select>
                        <p className="item stand-delete" onClick={(e) => {changesize('aa');}}>Zapisz wymiary</p>
                      </div>
                      {hideBackground ? "" :
                      <div style={{marginTop: 20}}>
                        <input id="background_left_position" onChange={change_background_left_position} style={{width: 40, padding: 2}} type="number" /> x <input id="background_top_position" onChange={change_background_top_position} style={{width: 40, padding: 2}} type="number" /> [px]
                        <label>Pozycja podkładu</label>
                        <p className="item stand-delete" onClick={(e) => {changeBackgroundOffset('aa');}}>Zapisz pozycję</p>
                      </div>}
                    </div>
                    <div id="sbs-panel-wall" className="sbs-table-panel-tab" style={{display: 'none'}}>
                      <div className="item color">Kolor
                        <div className="sbs-popup-colors sbs-popup-colors-wall">
                          <p className="group">Wybierz kolor</p>
                          <p className="color" style={{backgroundColor: "#a7a9ab"}}><span>#a7a9ab</span></p>
                          <p className="color" style={{backgroundColor: "#f1f1f2"}}><span>#f1f1f2</span></p>
                          <p className="color" style={{backgroundColor: "#c0c0c0"}}><span>#c0c0c0</span></p>
                          <p className="color" style={{backgroundColor: "#808080"}}><span>#808080</span></p>
                        </div> 
                        <p className="plan_COLOR_WALL form-colors w60" style={{backgroundColor: color_wall}} />
                      </div>
                      <p className="item wall-draw"><span>&nbsp;</span>Rysuj sciany</p>
                      <p className="item wall-draw-auto"><span>&nbsp;</span>Rysuj sciany automatycznie<br />&nbsp;<input id="input-wall-okta" type="checkbox" />z okty</p>
                      <p className="item wall-bull"><span>&nbsp;</span>Separator</p>
                      <p className="item wall-border"><span>&nbsp;</span>Rysuj obwód</p>
                      <p className="item wall-filar"><span>&nbsp;</span>Rysuj Filar <input id="input-filar-w" type="checkbox" />1m</p>
                      <p className="item wall-exit"><span>&nbsp;</span>Rysuj Wejście</p>
                      <p className="item wall-exit-arrow"><span>&nbsp;</span>Rysuj Wejście<br />Strzałki</p>
                      <p className="item wall-delete"><span>&nbsp;</span>Usuń</p>
                      <p className="item wall-delete-auto"><span>&nbsp;</span>Usuń automatycznie</p>
                      <p className="item wall-delete-all"><span>&nbsp;</span>Usuń wszystko</p>
                      <div style={{marginTop: 20}}>
                        <input placeholder="Tekst..." id="custom_text_input" style={{border:"solid", width: 80, padding: 2}} type="text" />
                        <br /><div style={{display: 'inline'}}>Kąt:</div><br /><input id="custom_text_degree" style={{width: 80, padding: 2, borderTop: '1px solid'}} defaultValue={0} type="number" />
                        <br /><div style={{display: 'inline'}}>Czcionka:</div><input id="custom_text_font" style={{width: 80, padding: 2, borderTop: '1px solid'}} defaultValue={13} type="number" />												
                        <p className="item custom-text">Dodaj tekst</p>
                      </div>
                      <p className="item wall-hydrant"><span>&nbsp;</span>Rysuj Hydrant<input id="input-hydrant-w" type="checkbox" />1m</p>
                      <p className="item wall-rbt"><span>&nbsp;</span>Rysuj RBT<input id="input-rbt-w" type="checkbox" />1m</p>
                      <p className="item wall-draw-media"><span>&nbsp;</span>Rysuj kanał mediowy</p>
                    </div>
                    <div id="sbs-panel-view" className="sbs-table-panel-tab-view">
                      <p className="title">Stoiska</p>
                      <p className="item-view stands-book active">Zarezerwowane</p>
                      <p className="item-view stands-free active">Wolne</p>
                      <p className="item-view stands-sold active">Sprzedane</p>
                      <p className="title">Warstwy</p>
                      <p className="item-view texts active">Teksty</p>
                      <p className="item-view walls active">Ściany</p>
                      <p className="item-view walls-fryz active">Fryzy</p>
                      <p className="item-view bulls active">Separatory</p>
                      <p className="item-view exits active">Drzwi</p>
                      <p className="item-view furnitures active">Meble</p>
                      <p className="item-view volts active">Prąd</p>
                      <p className="item-view lights active">Oświetlenie</p>
                      <p className="title">Opcje</p>
                      <p className="item-view guides active">Prowadnice</p>
                      <p className="item-view background">Podkład</p>
                    </div>
                  </div>
                </div>
              </td>
              <td id="sbs-table-content">
                <div className="sbs-table-scroll-fix">
                  <div className="sbs-table-scroll" id="sbs-content-scroll">
                    <div id="sbs-content">                    
                      {/* Plan Preview */}
                      <div id="plan-preview" className="plan-tab">
                        <div id="plan-preview-detail">
                          <p className="plan_ID">{plan_id}</p>
                          <p className="plan_BOSS">0</p>
                          <p className="plan_CHMOD2">0</p>
                          <p className="plan_NAME">{plan_name}</p>
                          <p className="plan_DATE">{plan_date}</p>
                          <p className="plan_GROUP">{plan_groupId}</p>
                          <p className="plan_UPDATE">{plan_modified}</p>
                          <p className="plan_W">{plan_width}</p>
                          <p className="plan_H">{plan_height}</p>
                          <p className="plan_COLOR_STAND">{color_stand}</p>
                          <p className="plan_COLOR_WALL">{color_wall}</p>
                        </div>
                        <table cellSpacing={0} className="plan-preview-table">
                          <tbody><tr>
                              <td className="plan-preview-table-fix"><div className="number-fix number-fix-tl">&nbsp;</div><div className="plan-preview-table-fix-div-l">&nbsp;</div></td>
                              <td className="plan-preview-table-top"><div className="number-horizontal">{parse(numberHorizontal)}</div></td>
                              <td className="plan-preview-table-fix"><div className="number-fix number-fix-tr">&nbsp;</div><div className="plan-preview-table-fix-div-r">&nbsp;</div></td>
                            </tr>
                            <tr>
                              <td className="plan-preview-table-left"><div className="number-vertical">{parse(numberVertical)}</div></td>
                              <td className="plan-preview-table-center">
                                <p id="temp-ARROW" className="none">&nbsp;</p>
                                <div id="temp-STAND" />
                                <div id="sbs-context-menu-stand" className="sbs-context-menu"><div><p className="move">&nbsp;</p><br /><p className="edit">&nbsp;</p><p className="clone">&nbsp;</p><p className="lib">&nbsp;</p><p className="delete">&nbsp;</p></div></div>
                                <p id="plan-temp-draw">&nbsp;</p>
                                <p id="plan-guide-x" className="sbs-plan-guide-x">&nbsp;</p>
                                <p id="plan-guide-y" className="sbs-plan-guide-y">&nbsp;</p>
                                <table cellSpacing={0} id="plan_CONTENT" style={{backgroundImage: hideBackground ? 'none' : `url(${backgroundImg})`, backgroundPosition:"left 0px top 0px", backgroundRepeat:"no-repeat", width: plan_width*40, height: plan_height*40}}>{parse(content)}</table>
                              </td>
                              <td className="plan-preview-table-right"><div className="number-vertical">{parse(numberVertical)}</div></td>
                            </tr>
                            <tr>
                              <td className="plan-preview-table-fix"><div className="number-fix number-fix-bl">&nbsp;</div><div className="plan-preview-table-fix-div-l">&nbsp;</div></td>
                              <td className="plan-preview-table-bottom"><div className="number-horizontal">{parse(numberHorizontal)}</div></td>
                              <td className="plan-preview-table-fix"><div className="number-fix number-fix-br">&nbsp;</div><div className="plan-preview-table-fix-div-r">&nbsp;</div></td>
                            </tr>
                          </tbody></table>
                        <div id="plan-legend">
                          <p className="plan-legend-title">Legenda</p>   
                          <p className="legend-number">[<span className="number">04</span>] Numer stoiska</p>
                          <p className="legend-stand"><span className="stand" style={{backgroundColor: color_stand}}>&nbsp;</span> Wykładzina</p>
                          <p className="legend-stand-own"><span className="stand-own" style={{backgroundColor: '#f1f1f2'}}>&nbsp;</span> Zabudowa własna</p>
                          <p className="legend-wall"><span className="wall" style={{backgroundColor: color_wall}}>&nbsp;</span> Sciana</p>
                          <p className="legend-filar"><span className="filar" style={{backgroundColor: color_wall}}>&nbsp;</span> Filar</p>
                          <p className="legend-exitplan"><img src="/dist/_img/plan-legend-exitplan.png" /> Wejście</p>
                          <br />
                          <p className="legend-light"><img src="/dist/_img/plan-legend-light.png" /> Punkt świetlny</p>
                          <p className="legend-light"><img src="/dist/_img/plan-legend-halogen.png" /> Halogen na wysięgniku</p>
                          <p className="legend-volt"><img src="/dist/_img/plan-legend-volt.png" /> Gniazdo elektryczne</p>
                          <p className="legend-any"><img src="/dist/_img/plan-legend-lada.png" /> lada</p>
                          <p className="legend-regal"><img src="/dist/_img/plan-legend-regal.png" /> Regał</p>
                          <p className="legend-hanger"><img src="/dist/_img/plan-legend-hanger.png" /> Wieszak</p>
                          <p className="legend-hoker"><img src="/dist/_img/plan-legend-hoker.png" /> Hoker</p>
                          <p className="legend-leaflets"><img src="/dist/_img/plan-legend-leaflets.png" /> Ulotki</p>
                          <p className="legend-exit"><img src="/dist/_img/plan-legend-exit.png" /> Drzwi</p>        
                        </div>    
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody></table>
        <div className="none">
          <img src="/dist/i/stand-bottom.png" />
          <img src="/dist/i/stand-left.png" />
          <img src="/dist/i/stand-right.png" />
          <img src="/dist/i/stand-top.png" />
          <img src="/dist/i/wall-exit-horizontal.png" />
          <img src="/dist/i/wall-exit-vertical.png" />
          <img src="/dist/i/s/bull-t.png" />
          <img src="/dist/i/s/bull-b.png" />
          <img src="/dist/i/s/bull-l.png" />
          <img src="/dist/i/s/bull-r.png" />
          <img src="/dist/i/s/exit-t.png" />
          <img src="/dist/i/s/exit-b.png" />
          <img src="/dist/i/s/exit-l.png" />
          <img src="/dist/i/s/exit-r.png" />
          <img src="/dist/i/s/wall-1-t.png" />
          <img src="/dist/i/s/wall-1-b.png" />
          <img src="/dist/i/s/wall-1-l.png" />
          <img src="/dist/i/s/wall-1-r.png"  />
          <img src="/dist/i/s/wall-2-t.png" />
          <img src="/dist/i/s/wall-2-b.png" />
          <img src="/dist/i/s/wall-2-l.png" />
          <img src="/dist/i/s/wall-2-r.png" />
          <img src="/dist/i/s/wall-3-t.png?1" />
          <img src="/dist/i/s/wall-3-b.png?1" />
          <img src="/dist/i/s/wall-3-l.png?1" />
          <img src="/dist/i/s/wall-3-r.png?1" />
          <img src="/dist/i/f/any-t.png" />
          <img src="/dist/i/f/any-b.png" />
          <img src="/dist/i/f/any-l.png" />
          <img src="/dist/i/f/any-r.png" />
          <img src="/dist/i/f/any2-t.png" />
          <img src="/dist/i/f/any2-b.png" />
          <img src="/dist/i/f/any2-l.png" />
          <img src="/dist/i/f/any2-r.png" />
          <img src="/dist/i/f/chairs-1-t.png" />
          <img src="/dist/i/f/chairs-1-b.png" />
          <img src="/dist/i/f/chairs-1-l.png" />
          <img src="/dist/i/f/chairs-1-r.png" />
          <img src="/dist/i/f/chairs-2-t.png" />
          <img src="/dist/i/f/chairs-2-b.png" />
          <img src="/dist/i/f/chairs-2-l.png" />
          <img src="/dist/i/f/chairs-2-r.png" />
          <img src="/dist/i/f/chairs-3-t.png" />
          <img src="/dist/i/f/chairs-3-b.png" />
          <img src="/dist/i/f/chairs-3-l.png" />
          <img src="/dist/i/f/chairs-3-r.png"  />
          <img src="/dist/i/f/hanger-t.png" />
          <img src="/dist/i/f/hanger-b.png" />
          <img src="/dist/i/f/hanger-l.png" />
          <img src="/dist/i/f/hanger-r.png" />
          <img src="/dist/i/f/hoker-t.png" />
          <img src="/dist/i/f/hoker-b.png" />
          <img src="/dist/i/f/hoker-l.png" />
          <img src="/dist/i/f/hoker-r.png" />
          <img src="/dist/i/f/regal-t.png" />
          <img src="/dist/i/f/regal-b.png" />
          <img src="/dist/i/f/regal-l.png" />
          <img src="/dist/i/f/regal-r.png" />
          <img src="/dist/i/f/leaflets-t.png" />
          <img src="/dist/i/f/leaflets-b.png" />
          <img src="/dist/i/f/leaflets-l.png" />
          <img src="/dist/i/f/leaflets-r.png" />
          <img src="/dist/i/m/light-t.png" />
          <img src="/dist/i/m/light-b.png" />
          <img src="/dist/i/m/light-l.png" />
          <img src="/dist/i/m/light-r.png" />
          <img src="/dist/i/m/volt-c.png" />
          <img src="/dist/i/m/volt-m.png" />
        </div>
        {/* Plan Popup */}
        <div id="sbs-popup">
          {/* Plan Popup Stand New*/}
          <div id="sbs-popup-stand-new" className="popup">
            <div className="close"><span>X</span></div>
            <div className="padding padding-dark">
              <p className="title">Nowe stoisko</p>
              <table className="table-text">
                <tbody><tr>
                    <td>Nazwa:<span className="color">*</span></td>
                    <td><input type="text" className="stand_NAME form-input w240" placeholder="Pole obowiązkowe" /></td>
                  </tr>
                  <tr>
                    <td>Numer:</td>
                    <td><input type="text" className="stand_NR form-input w60" defaultValue={0} /></td>
                  </tr>
                  <tr>
                    <td>Szerokość:<span className="color">*</span></td>
                    <td><input type="number" min="0.5" max={16} step="0.5" className="stand_W form-input w60" defaultValue={2} /> m <span className="mini ml10">(minimum: 0.5m, maksimum: 16m)</span></td>
                  </tr>
                  <tr><td>Wysokość:<span className="color">*</span></td><td><input type="number" min="0.5" max={16} step="0.5" className="stand_H form-input w60" defaultValue={2} /> m <span className="mini ml10">(minimum: 0.5m, maksimum: 16m)</span></td></tr>
                  <tr><td>&nbsp;</td><td><a className="form-submit">Dodaj</a> &nbsp;<a className="form-cancel">Anuluj</a></td></tr>
                </tbody></table>
            </div>
          </div>
          {/* Plan Popup Stand Edit*/}
          <div id="sbs-popup-stand-edit" className="popup">
            <div className="close"><span>X</span></div>
            <div className="edit-top">
              <p className="edit-top-title-name">Nazwa w Spisie:</p>
              <p className="edit-top-input-name"><input type="text" className="stand_NAME form-input-big w440" style={{width: 520}} placeholder="Nazwa firmy wystawienniczej - Pole obowiązkowe" /></p>
                
              <p className="edit-top-title-nr">Nr:</p>
              <p className="edit-top-input-nr"><input type="text" className="stand_NR form-input-big-center w80" /></p>
            </div>
            <table cellSpacing={0} className="edit-table">
              <tbody><tr>
                  <td className="edit-table-right">
                    <div className="edit-table-right-top">
                      <div style={{ /*display:"inline-flex"*/}} className="edit-table-right-scroll" id="editor-scroll">
                        
                          <table cellSpacing={0} className="edit-table-editor">
                            <tbody><tr><td colSpan={6} className="edit-table-editor-padding"><span>&nbsp;</span></td></tr>
                              <tr>
                                <td className="edit-table-editor-padding"><span>&nbsp;</span></td>
                                <td colSpan={3} className="edit-table-editor-number-horizontal"><div><p>&nbsp;</p><p>&nbsp;</p><p>1</p><p>2</p><p>3</p><p>4</p><p>5</p><p>6</p><p>7</p><p>8</p><p>9</p><p>10</p><p>11</p><p>12</p><p>13</p><p>14</p><p>15</p><p>16</p><p>&nbsp;</p></div><span>&nbsp;</span></td>
                                <td className="edit-table-editor-number-vertical"><span>&nbsp;</span></td>
                                <td className="edit-table-editor-padding"><span>&nbsp;</span></td>
                              </tr>
                              <tr>
                                <td className="edit-table-editor-padding"><span>&nbsp;</span></td>
                                <td className="edit-table-editor-number-vertical"><span>&nbsp;</span></td>
                                <td className="edit-table-editor-grid"><span>&nbsp;</span></td>
                                <td className="edit-table-editor-grid" id="editor-orient-top"><span>&nbsp;</span></td>
                                <td className="edit-table-editor-grid"><span>&nbsp;</span></td>
                                <td className="edit-table-editor-padding"><span>&nbsp;</span></td>
                              </tr>
                              <tr>
                                <td className="edit-table-editor-padding"><span>&nbsp;</span></td>
                                <td className="edit-table-editor-number-vertical"><div><p>1</p><p>2</p><p>3</p><p>4</p><p>5</p><p>6</p><p>7</p><p>8</p><p>9</p><p>10</p><p>11</p><p>12</p><p>13</p><p>14</p><p>15</p><p>16</p></div><span>&nbsp;</span></td>
                                <td className="edit-table-editor-grid" id="editor-orient-left"><span>&nbsp;</span></td>
                                <td className="edit-table-editor-relative" id="edit-table-editor-relative">
                                  <p id="draw-element">&nbsp;</p>
                                  <div id="temp-STAND-EDITOR" />
                                </td>
                                <td className="edit-table-editor-grid" id="editor-orient-right"><span className="biger">&nbsp;</span></td>
                                <td className="edit-table-editor-padding"><span>&nbsp;</span></td>
                              </tr>
                              <tr>
                                <td className="edit-table-editor-padding"><span>&nbsp;</span></td>
                                <td className="edit-table-editor-number-vertical"><span>&nbsp;</span></td>
                                <td className="edit-table-editor-grid"><span>&nbsp;</span></td>
                                <td className="edit-table-editor-grid" id="editor-orient-bottom"><span className="biger">&nbsp;</span></td>
                                <td className="edit-table-editor-grid"><span>&nbsp;</span></td>
                                <td className="edit-table-editor-padding"><span>&nbsp;</span></td>
                              </tr>
                              <tr><td colSpan={6} className="edit-table-editor-padding"><span>&nbsp;</span></td></tr>
                            </tbody>
                          </table>
                          
                         

                            
                        {/*     <div style={{position:'relative', display:"inline-flex", marginLeft:50, marginTop:50}}  >
                             <p  style={{marginLeft:20, marginTop:5}} id="draw-element1">Orientacja na planie:</p>
                             <div id="temp-STAND-EDITOR1" />  
                          </div>
                          */}
                      </div>                   
                    </div>
                    <div className="tab tab-info" style={{ overflow:"auto", height:"50vh"}}>
                    <table>
                        <tr>
                            
                            <td>
                              <Autocomplete
                                id="getcontracor-data-edit"
                                value={contractor_name}
                                onInput={ (e) => { 
                                   contractorService.similarityList(String($(e.target)?.val())).then(resp =>{
                                      setSimilarityList(resp)
                                    }).catch(error => {
                                      console.log(error)
                                    })
                                 }
                                }
                                sx={{ width: 300 }}
                                open={contractor_open}
                                onOpen={() => {
                                  setEditContractorOpen(true);
                                }}
                                onClose={() => {
                                  setEditContractorOpen(false);
                                }}
                                onChange={handleEditContractorChange}
                                //isOptionEqualToValue={(option, value) => option === value}
                                filterOptions={(x) => x}
                                getOptionLabel={(option:any) => {
                                  //console.log(option)
                                  if (option.name==undefined){
                                    return option
                                  }else{
                                    return option.name
                                  }
                                  }
                                }
                                options={similarityList}
                                loading={loadingContractor}
                               
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Wyszukaj firmę"
                                    
                                  />
                                )}
                              />
                              <div>
                              <input type="hidden" id="sbs_popup_edit_contractor_id" name="sbs_edit_popup_contractor_id" />  
                              <input type="hidden" id="sbs_popup_edit_contractor_name" name="sbs_popup_edit_contractor_name" />  
                              {
                                String($('#sbs_popup_edit_contractor_name').val()) !='' && (String($('#sbs_popup_edit_contractor_name').val()) != String($('#sbs-popup-stand-edit .stand_NAME').val()))  ?
                              <Button onClick={setEditedStandName} id="contractor_button_edit" variant="text">Zaktualizuj nazwę stoiska</Button> :
                              <Button id="contractor_button_edit" variant="text">-</Button> 

                              }
                                
                              </div>

                            </td>
                              <td style={{width:"20px"}}></td>
                            
                            <td>
                               <Autocomplete
                                id="getcontacts-data-edit"
                                value={contact_name}
                                sx={{ width: 300 }}
                                open={contact_open}
                                onOpen={() => {
                                  setEditContactOpen(true);
                                }}
                                onClose={() => {
                                  setEditContactOpen(false);
                                }}
                                onChange={handleEditContactChange}
                                filterOptions={(x) => x}
                                getOptionLabel={(option:any) => {
                                  if (option.name==undefined){
                                    return option
                                  }else{
                                    return option.name
                                  }
                                  }
                                }
                                options={contactsList}
                                loading={loadingContact}
                               
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Wyszukaj kontakt"
                                    
                                  />
                                )}
                              />
                              <div>
                                
                              <input type="hidden" id="sbs_popup_edit_contact_name" name="sbs_popup_edit_contact_name" />   
                              <input type="hidden" id="sbs_popup_edit_contact_id" name="sbs_popup_edit_contact_id" />  
                              {
                                  Number($('#sbs_popup_edit_contractor_id').val()) > 0 ? 
                                    Number($('#sbs_popup_edit_contact_id').val()) > 0 ? 
                                    <Button onClick={updateContact} id="contact_button_edit" variant="text">Aktualizuj kontakt w CRM</Button> :
                                    <Button onClick={addContact} id="contact_button_edit" variant="text">Dodaj kontakt do CRM</Button>
                                   : <Button id="contact_button_edit" variant="text">-</Button>
                              }
                              </div>
                              </td>
                              
                             
                          
                          </tr>
                      </table>    
                      <table className="table-text">
                        {/* first row */}
                        <tbody  style={{display:"block"}}>
                         
                         
                          <tr>
                            <td><strong>Imię i nazwisko:</strong></td><td>
                              <input type="text" className="stand_O_NAME form-input w220" />
                            </td>
                            
                            <td><strong>Status klienta:</strong></td>
                            <td>
                              <select className="form-select stand_O_MAIL_STATUS w140">
                                <option value={1} >&nbsp;do wysłania</option>
                                <option value={2}>&nbsp;wysłano</option>
                                <option value={3}>&nbsp;otrzymał (bez akceptacji)</option>
                                <option value={4}>&nbsp;potwierdzone telefonicznie</option>
                                <option value={5}>&nbsp;potwierdzone mailowo</option>
                              </select>
                              <a id="sendStandMail" target="_blank" href="mailto:">Wyślij »</a>
                            </td>
                          </tr>
                          {/* second row */}
                          <tr>
                            <td><strong><sup>*</sup>Adres e-mail:</strong></td>
                            <td>
                              <input type="text" className="stand_O_MAIL form-input w220" />
                            </td>
                            <td className="stand_TEXT_POSITION_td1"><strong>Miejsce nazwy:</strong></td>
                            <td className="stand_TEXT_POSITION_td2">
                              <select className="form-select stand_TEXT_POSITION w220">
                                <option value="center"> &nbsp;Środek</option>
                                <option value="top">&nbsp;Góra</option>
                                <option value="bottom">&nbsp;Dół</option>
                                <option value="left">&nbsp;Lewa</option>
                                <option value="right">&nbsp;Prawa</option>
                                <option value="none">&nbsp;Brak</option>
                              </select>
                            </td>
                          </tr>
                          {/* third row */}
                          <tr>
                            <td><strong>Numer telefonu:</strong></td>
                            <td>
                              <input type="tel" className="stand_O_TEL form-input w220" />
                            </td>
                            <td><strong>Wykładzina:</strong></td>
                            <td>
                              <div className="sbs-popup-colors sbs-popup-colors-stand">
                                <p className="group">Wybierz kolor</p>
                                <p className="color c-f1f1f2" onClick={changeColorClick} style={{backgroundColor: '#f1f1f2'}}><span>#f1f1f2</span></p>
                                <p className="color c-ec4e4e" onClick={changeColorClick} style={{backgroundColor: '#ec4e4e'}}><span>#ec4e4e</span></p>
                                <p className="color c-eeaf20" onClick={changeColorClick} style={{backgroundColor: '#eeaf20'}}><span>#eeaf20</span></p>    
                                <p className="color c-e2471b" onClick={changeColorClick} style={{backgroundColor: '#e2471b'}}><span>#e2471b</span></p>
                                <p className="color c-b81e04" onClick={changeColorClick} style={{backgroundColor: '#b81e04'}}><span>#b81e04</span></p>
                                <p className="color c-dc0c35" onClick={changeColorClick} style={{backgroundColor: '#dc0c35'}}><span>#dc0c35</span></p>
                                <p className="color c-29185e" onClick={changeColorClick} style={{backgroundColor: '#29185e'}}><span>#29185e</span></p>
                                <p className="color c-cb9c7a" onClick={changeColorClick} style={{backgroundColor: '#cb9c7a'}}><span>#cb9c7a</span></p>
                                <p className="color c-62bc56" onClick={changeColorClick} style={{backgroundColor: '#62bc56'}}><span>#62bc56</span></p>    
                                <p className="color c-1b95c8" onClick={changeColorClick} style={{backgroundColor: '#1b95c8'}}><span>#1b95c8</span></p>
                                <p className="color c-0075a4" onClick={changeColorClick} style={{backgroundColor: '#0075a4'}}><span>#0075a4</span></p>
                                <p className="color c-707070" onClick={changeColorClick} style={{backgroundColor: '#707070'}}><span>#707070</span></p>
                                <p className="color c-555555" onClick={changeColorClick} style={{backgroundColor: '#555555'}}><span>#555555</span></p>
                                <p className="color c-ffffff" onClick={changeColorClick} style={{backgroundColor: '#ffffff'}}><span>#ffffff</span></p>
                              </div>
                              <p className="stand_COLOR form-colors w220"  />
                            </td>
                          </tr>
                          <tr>
                            <td><strong>Fryz:</strong></td>
                            <td>
                              <select className="form-select stand_FRYZ_SELECT w220">
                                <option value={0} > </option>
                                <option value={1}>Nie dotyczy</option>
                                <option value={2}>Rezygnacja z fryzu</option>
                                <option value={3}>Własne wkłady</option>
                                <option value={4}>Biały fryz do wyklejenia</option>
                                <option value={5}>Fryz drukowany</option>
                              </select>
                            </td>
                          </tr>
                          <tr>
                            <td><strong>Dane na fryz:</strong></td>
                            <td><input type="text" className="stand_FRYZ form-input w220" /></td>
                            <td className="red-heading">Dodatkowe zam.</td>
                            <td><input type="text" className="stand_ADD_CLIENT form-input w220" /></td>
                          </tr>
                          <tr>
                            <td><strong>Powierzchnia:</strong></td><td>
                              <select  className="form-select stand_SUR w220">
                                <option value="Zabudowana">&nbsp;Zabudowana</option>
                                <option value="Niezabudowana">&nbsp;Niezabudowana</option>
                              </select>
                            </td>
                            <td><strong>Zabudowa:</strong></td>
                            <td><input type="text" className="stand_ADD_INFO form-input w220" /></td>
                          </tr>
                          <tr>
                            <td><strong>Status:</strong></td>
                            <td>
                              <select className="form-select stand_STATUS w220">
                                <option value="free" >&nbsp;Wolne</option>
                                <option value="book">&nbsp;Zarezerwowane</option>
                                <option value="nbindbook">&nbsp;Rezerwacja niezobowiązująca</option>
                                <option value="mparticipat">&nbsp;Przeniesiony udział</option>
                                <option value="deal">&nbsp;Wystawiona umowa</option>
                                <option value="sold">&nbsp;Sprzedane</option>
                                <option value="risk">&nbsp;Może podważyć umowę</option>
                              </select>
                            </td>
                            <td><strong>Organizator:</strong></td>
                            <td>
                              <select className="form-select stand_ADD_USER w140">
                                <option />
                                  {users.map(function(item:any, i){
                                      return  <option  key={"usr_"+item.shortcut} value={item.color} >{item.shortcut}</option>
                                    })
                                  }
                              </select>
                            </td>

                          </tr>
                        </tbody></table>
                    </div>
                    <div className="tab tab-wall tab-furniture tab-lights none">
                      <div className="items-menu">
                        <div className="walls-container">
                          <p className="title">Ściany, Fryzy, Drzwi</p>
                          <p className="element delete">
                            <img src="/dist/_img/i/delete.png" title="Usuń" />
                          </p>
                          <p className="element delete-all-s">
                            <img src="/dist/_img/i/delete-all.png" title="Usuń wszystko" />
                          </p>
                          <p className="element e-s-wall-1 automatic-possibility ml10" data-auto-draw="e-s-wall-1-auto">
                            <img src="/dist/_img/i/s/wall-1.png" title="Fryz" />
                          </p>
                          <p className="element e-s-wall-2 automatic-possibility" data-auto-draw="e-s-wall-2-auto">
                            <img src="/dist/_img/i/s/wall-2.png" title="Sciana działowa" />
                          </p>
                          <p className="element e-s-wall-3 automatic-possibility" data-auto-draw="e-s-wall-3-auto">
                            <img src="/dist/_img/i/s/wall-3.png" title="Stelaż" />
                          </p>
                          <p className="element e-s-bull automatic-possibility" data-auto-draw="e-s-bull-auto">
                            <img src="/dist/_img/i/s/bull.png" title="Separator" />
                          </p>
                          <p className="element e-s-exit">
                            <img src="/dist/_img/i/s/exit.png" title="Drzwi" />
                          </p>
                        </div>
                        <div className="lights-container">
                          <p className="title">Oświetlenie i prąd</p>
                          <p className="element delete">
                            <img src="/dist/_img/i/delete.png" title="Usuń" />
                          </p>
                          <p className="element delete-all-m">
                            <img src="/dist/_img/i/delete-all.png" alt="Usuń wszystko" />
                          </p>
                          <p className="element e-m-volt-c ml10">
                            <img src="/dist/_img/i/m/volt-c.png" title="Gniazdo elektryczne" />
                          </p>
                          <p className="element e-m-light automatic-possibility" data-auto-draw="e-m-light-auto">
                            <img src="/dist/_img/i/m/light.png" title="Punkt świetlny" />
                          </p>
                          <p className="element e-m-halogen">
                            <img src="/dist/_img/i/m/halogen.png" title="Halogen na wysięgniku" />
                          </p>
                         
                        </div>
                        <div className="furniture-container">
                          <p className="title">Meble</p>
                          <p className="element delete">
                            <img src="/dist/_img/i/delete.png" title="Usuń" />
                          </p>
                          <p className="element delete-all-f">
                            <img src="/dist/_img/i/delete-all.png" title="Usuń wszystko" />
                          </p>
                          <p className="element e-f-any ml10">
                            <img src="/dist/_img/i/f/any.png" title="Lada" />
                          </p>
                          <p className="element e-f-any2">
                            <img src="/dist/_img/i/f/any2.png" title="Lada" />
                          </p>
                          <p className="element e-f-regal">
                            <img src="/dist/_img/i/f/regal.png" title="Regał" />
                          </p>
                          <p className="element e-f-hanger">
                            <img src="/dist/_img/i/f/hanger.png" title="Wieszak" />
                          </p>
                          <p className="element e-f-hoker">
                            <img src="/dist/_img/i/f/hoker.png" />
                          </p>
                          <p className="element e-f-leaflets">
                            <img src="/dist/_img/i/f/leaflets.png" title="Ulotki" />
                          </p>
                          <p className="element e-f-table">
                            <img src="/dist/_img/i/f/table.png" title="Stolik Barowy" />
                          </p>
                          <p className="element e-f-chairs-1">
                            <img src="/dist/_img/i/f/chairs-1.png" title="1 krzesło + stolik" />
                          </p>
                          <p className="element e-f-chairs-2">
                            <img src="/dist/_img/i/f/chairs-2.png" title="2 krzesła + stolik" />
                          </p>
                          <p className="element e-f-chairs-3">
                            <img src="/dist/_img/i/f/chairs-3.png" title="3 krzesła + stolik" />
                          </p>
                        </div> 
                      </div>
                      <div id="automatic-draw-menu">
                        <p className="element element-disabled">
                          Rysowanie automatyczne
                        </p>
                        <p className="automatic-possibility element e-s-wall-1-auto">
                          Rysowanie automatyczne (fryz)
                        </p>
                        <p className="automatic-possibility element e-s-wall-2-auto">
                          Rysowanie automatyczne (ściana działowa)
                        </p>
                        <p className="automatic-possibility element e-s-wall-3-auto">
                          Rysowanie automatyczne (stelaż)
                        </p>
                        <p className="automatic-possibility element e-s-bull-auto">
                          Rysowanie automatyczne (separator)
                        </p>
                        <p className="automatic-possibility element e-m-light-auto">
                          Rysowanie automatyczne (punkty świetlne)
                        </p>
                      </div>
                      <div style={{minHeight:120}}></div>
                    </div>
                    <div className="tab tab-gfx none" style={{ overflow:"auto"}}>
                      <p className="title">Realizacja graficzna</p>
                      <table className="table-gfx">
                        <thead>
                          <tr className="header">
                            <th>&nbsp;</th>
                            <th>Usługi dodatkowe:</th>
                            <th>Ilość:</th>
                            <th>Status</th>
                            <th>Uwagi</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td><input type="checkbox" id="gfx_1_checkbox" className="gfx_checkbox gfx_1_checkbox" /></td>
                            <td><label htmlFor="gfx_1_checkbox">Projekt stoiska z wizualizacją</label></td>
                            <td><input type="number" className="gfx_count gfx_1_count" defaultValue={1} /></td>
                            <td>
                              <select className="gfx_status gfx_1_status">
                                <option />
                                <option value="do ściągnięcia">do ściągnięcia</option>
                                <option value="w realizacji (u grafika)">w realizacji (u grafika)</option>
                                <option value="zaakceptowane">zaakceptowane</option>
                                <option value="zrealizowane">zrealizowane</option>
                              </select>
                            </td>
                            <td><input type="text" className="gfx_info gfx_1_info" /></td>
                          </tr>
                          <tr>
                            <td><input type="checkbox" id="gfx_2_checkbox" className="gfx_checkbox gfx_2_checkbox" /></td>
                            <td><label htmlFor="gfx_2_checkbox">Projekt banneru</label>.</td>
                            <td><input type="number" className="gfx_count gfx_2_count" defaultValue={1} /></td>
                            <td>
                              <select className="gfx_status gfx_2_status">
                                <option />
                                <option value="do ściągnięcia">do ściągnięcia</option>
                                <option value="w realizacji (u grafika)">w realizacji (u grafika)</option>
                                <option value="zaakceptowane">zaakceptowane</option>
                                <option value="zrealizowane">zrealizowane</option>
                              </select>
                            </td>
                            <td><input type="text" className="gfx_info gfx_2_info" /></td>
                          </tr>
                          <tr>
                            <td><input type="checkbox" id="gfx_3_checkbox" className="gfx_checkbox gfx_3_checkbox" /></td>
                            <td><label htmlFor="gfx_3_checkbox">Oklejenie wkładów (ścian)</label></td>
                            <td><input type="number" className="gfx_count gfx_3_count" defaultValue={1} /></td>
                            <td>
                              <select className="gfx_status gfx_3_status">
                                <option />
                                <option value="do ściągnięcia">do ściągnięcia</option>
                                <option value="w realizacji (u grafika)">w realizacji (u grafika)</option>
                                <option value="zaakceptowane">zaakceptowane</option>
                                <option value="zrealizowane">zrealizowane</option>
                              </select>
                            </td>
                            <td><input type="text" className="gfx_info gfx_3_info" /></td>
                          </tr>
                          <tr>
                            <td><input type="checkbox" id="gfx_4_checkbox" className="gfx_checkbox gfx_4_checkbox" /></td>
                            <td><label htmlFor="gfx_4_checkbox">Oklejenie fryzów</label></td>
                            <td><input type="number" className="gfx_count gfx_4_count" defaultValue={1} /></td>
                            <td>
                              <select className="gfx_status gfx_4_status">
                                <option />
                                <option>do ściągnięcia</option>
                                <option>w realizacji (u grafika)</option>
                                <option>zaakceptowane</option>
                                <option>zrealizowane</option>
                              </select>
                            </td>
                            <td><input type="text" className="gfx_info gfx_4_info" /></td>
                          </tr>
                          <tr>
                            <td><input type="checkbox" id="gfx_5_checkbox" className="gfx_checkbox gfx_5_checkbox" /></td>
                            <td><label htmlFor="gfx_5_checkbox">Oklejenie lady - wkład podstawowy</label></td>
                            <td><input type="number" className="gfx_count gfx_5_count" defaultValue={1} /></td>
                            <td>
                              <select className="gfx_status gfx_5_status">
                                <option />
                                <option value="do ściągnięcia">do ściągnięcia</option>
                                <option value="w realizacji (u grafika)">w realizacji (u grafika)</option>
                                <option value="zaakceptowane">zaakceptowane</option>
                                <option value="zrealizowane">zrealizowane</option>
                              </select>
                            </td>
                            <td><input type="text" className="gfx_info gfx_5_info" /></td>
                          </tr>
                          <tr>
                            <td><input type="checkbox" id="gfx_6_checkbox" className="gfx_checkbox gfx_6_checkbox" /></td>
                            <td><label htmlFor="gfx_6_checkbox">Logo na fryzie (przed napisem)</label></td>
                            <td><input type="number" className="gfx_count gfx_6_count" defaultValue={1} /></td>
                            <td>
                              <select className="gfx_status gfx_6_status">
                                <option />
                                <option value="do ściągnięcia">do ściągnięcia</option>
                                <option value="w realizacji (u grafika)">w realizacji (u grafika)</option>
                                <option value="zaakceptowane">zaakceptowane</option>
                                <option value="zrealizowane">zrealizowane</option>
                              </select>
                            </td>
                            <td><input type="text" className="gfx_info gfx_6_info" /></td>
                          </tr>
                          <tr>
                            <td><input type="checkbox" id="gfx_7_checkbox" className="gfx_checkbox gfx_7_checkbox" /></td>
                            <td><label htmlFor="gfx_7_checkbox">Wydruk + montaż banneru</label></td>
                            <td><input type="number" className="gfx_count gfx_7_count" defaultValue={1} /></td>
                            <td>
                              <select className="gfx_status gfx_7_status">
                                <option />
                                <option value="do ściągnięcia">do ściągnięcia</option>
                                <option value="w realizacji (u grafika)">w realizacji (u grafika)</option>
                                <option value="zaakceptowane">zaakceptowane</option>
                                <option value="zrealizowane">zrealizowane</option>
                              </select>
                            </td>
                            <td><input type="text" className="gfx_info gfx_7_info" /></td>
                          </tr>
                          <tr>
                            <td><input type="checkbox" id="gfx_8_checkbox" className="gfx_checkbox gfx_8_checkbox" /></td>
                            <td><label htmlFor="gfx_8_checkbox">Montaż banneru / wkładów</label></td>
                            <td><input type="number" className="gfx_count gfx_8_count" defaultValue={1} /></td>
                            <td>
                              <select className="gfx_status gfx_8_status">
                                <option />
                                <option value="do ściągnięcia">do ściągnięcia</option>
                                <option value="w realizacji (u grafika)">w realizacji (u grafika)</option>
                                <option value="zaakceptowane">zaakceptowane</option>
                                <option value="zrealizowane">zrealizowane</option>
                              </select>
                            </td>
                            <td><input type="text" className="gfx_info gfx_8_info" /></td>
                          </tr>
                        </tbody>
                      </table>
                      <div style={{minHeight:120}}></div>
                    </div>
                    <div className="dimensions">
                      <strong>Szerokość:</strong> <span className="stand_W" />m
                      <strong>Wysokość:</strong> <span className="stand_H" />m
                      <strong>Metraż:</strong> <span className="stand_SIZE" />m²
                    </div>
                  </td>

                  <td className="edit-table-left">
                    <div className="menu">
                      <p className="tab-info active">Informacje</p>
                      <p className="tab-wall tab-furniture tab-light">Wyposażenie</p>
                      <p className="tab-gfx">Realizacja graficzna</p> 
                    </div>
                    <div className="btn">
                      <p><a className="editor-kt">Karta techniczna</a></p>
                      <p><a className="editor-kt-en">Technical card</a></p>
                      <p><a className="editor-kt-pdf">Karta techniczna <strong>PDF</strong></a></p>
                      <p><a className="editor-kt-pdf-en">Technical card <strong>PDF</strong></a></p>
                      <p><a className="editor-lib">Zapisz do biblioteki</a></p>
                      <p><a className="editor-update">Zaktualizuj</a></p>
                    </div>
                    <p className="menu-200">&nbsp;</p>
                  </td>
                </tr>
              </tbody></table>
              
          </div>
        </div>
      </div>
        
      </section>

      )
    }
    
    export default Standeditor;

    // Plan Restore - Restore Backup
    function f_BackupRestore(plan_id : number, backup_FILE: string) {
      console.group(plan_id)
      console.log(backup_FILE)
      if(!backup_FILE) return;
      //var  regex =  /#?(\d+)_/g;
      //var plan_ID
      //var data = regex.exec(backup_FILE)
      //if (data){
      //  plan_ID = data[1]
     // }

      //if(!plan_ID) return;

      standeditorService.restorebackup(plan_id, backup_FILE).then( (response: { data: any; }) => {
        window.location.reload();
      }
    )

}



